/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(e, t, i, s, r) {
    "use strict";

    function o() {
        if (document.querySelector("cart-items")) return;
        let e = document.createElement("cart-items");
        document.body.appendChild(e)
    }

    function a(e) {
        let t = e.querySelectorAll(".form-field");
        t.forEach(e => {
            let t = e.querySelector("label"),
                i = e.querySelector("input, textarea");
            t && i && (i.addEventListener("keyup", e => {
                "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float")
            }), i.value && i.value.length && t.classList.add("label--float"))
        })
    }! function() {
        let e = {
            NODE_ENV: "production"
        };
        try {
            if (process) {
                process.env = Object.assign({}, process.env), Object.assign(process.env, e);
                return
            }
        } catch (t) {}
        globalThis.process = {
            env: e
        }
    }(), window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let n = u();

    function l() {
        let e = {};
        return e.windowHeight = Math.min(window.screen.height, window.innerHeight), e.footerHeight = p('[data-section-type*="footer"]'), e.headerHeight = p("[data-header-height]"), e.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? e.headerHeight : 0, e.collectionNavHeight = p("[data-collection-nav]"), e.logoHeight = function e() {
            let t = p("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), e
    }

    function d() {
        document.addEventListener("theme:resize", h), c()
    }

    function c() {
        let {
            windowHeight: e,
            headerHeight: t,
            logoHeight: i,
            footerHeight: s,
            collectionNavHeight: r
        } = l();
        document.documentElement.style.setProperty("--full-height", `${e}px`), document.documentElement.style.setProperty("--three-quarters", `${e*(3/4)}px`), document.documentElement.style.setProperty("--two-thirds", `${e*(2/3)}px`), document.documentElement.style.setProperty("--one-half", `${e/2}px`), document.documentElement.style.setProperty("--one-third", `${e/3}px`), document.documentElement.style.setProperty("--collection-nav-height", `${r}px`), document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--footer-height", `${s}px`), document.documentElement.style.setProperty("--content-full", `${e-t-i/2}px`), document.documentElement.style.setProperty("--content-min", `${e-t-s}px`), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function h() {
        let {
            windowHeight: e,
            headerHeight: t,
            logoHeight: i,
            footerHeight: s,
            collectionNavHeight: r
        } = l(), o = u();
        (o !== n || window.innerWidth > window.theme.sizes.mobile) && (document.documentElement.style.setProperty("--full-height", `${e}px`), document.documentElement.style.setProperty("--three-quarters", `${e*(3/4)}px`), document.documentElement.style.setProperty("--two-thirds", `${e*(2/3)}px`), document.documentElement.style.setProperty("--one-half", `${e/2}px`), document.documentElement.style.setProperty("--one-third", `${e/3}px`), n = o), document.documentElement.style.setProperty("--collection-nav-height", `${r}px`), document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--footer-height", `${s}px`), document.documentElement.style.setProperty("--content-full", `${e-t-i/2}px`), document.documentElement.style.setProperty("--content-min", `${e-t-s}px`), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function u() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }

    function p(e) {
        let t = document.querySelector(e);
        return t ? t.offsetHeight : 0
    }

    function m(e, t) {
        let i;
        return function() {
            if (e) {
                let s = () => e.apply(this, arguments);
                clearTimeout(i), i = setTimeout(s, t)
            }
        }
    }

    function g() {
        return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth
    }

    function v() {
        return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight
    }

    function b() {
        return g() >= window.theme.sizes.small
    }

    function y() {
        return g() < window.theme.sizes.small
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let f = g(),
        S = v(),
        w = window.scrollY,
        L = null,
        E = null,
        k = null,
        A = null,
        $ = 0;

    function C() {
        e.clearQueueScrollLocks(), e.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    let T = (e, t = "", i) => {
        let s = i || document.createElement("div");
        return s.classList.add(t), e.parentNode.insertBefore(s, e), s.appendChild(e)
    };

    function q(e) {
        let t = e.querySelectorAll(".rte table");
        t.forEach(e => {
            T(e, "rte__table-wrapper"), e.setAttribute("data-scroll-lock-scrollable", "")
        });
        let i = e.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe');
        i.forEach(e => {
            T(e, "rte__video-wrapper")
        })
    }

    function P(e) {
        let t = e.querySelectorAll("[data-aria-toggle]");
        t.length && t.forEach(e => {
            e.addEventListener("click", function(e) {
                e.preventDefault();
                let t = e.currentTarget;
                t.setAttribute("aria-expanded", "false" == t.getAttribute("aria-expanded") ? "true" : "false");
                let i = t.getAttribute("aria-controls"),
                    s = document.querySelector(`#${i}`),
                    r = () => {
                        s.classList.remove("expanding"), s.removeEventListener("transitionend", r)
                    },
                    o = () => {
                        s.classList.add("expanding"), s.removeEventListener("transitionstart", o)
                    };
                s.addEventListener("transitionstart", o), s.addEventListener("transitionend", r), s.classList.toggle("expanded")
            })
        })
    }
    let x = {
            loading: "is-loading"
        },
        I = {
            img: "img.is-loading"
        };

    function _(e, t) {
        t = t || {};
        var i = e.tabIndex;

        function s(r) {
            r.target.removeEventListener(r.type, s), e.tabIndex = i, delete e.dataset.tabIndex, void 0 !== t.className && e.classList.remove(t.className)
        }
        e.tabIndex = -1, e.dataset.tabIndex = i, e.focus(), void 0 !== t.className && e.classList.add(t.className), e.addEventListener("blur", s)
    }

    function M(e) {
        return Array.prototype.slice.call(e.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function(e) {
            var t, i;
            return !!((e.offsetWidth || e.offsetHeight || e.getClientRects().length) && (t = e, "none" !== (i = window.getComputedStyle(t)).display && "hidden" !== i.visibility))
        })
    }
    var H = {};

    function B(e, t) {
        t = t || {};
        var i = M(e),
            s = t.elementToFocus || e,
            r = i[0],
            o = i[i.length - 1];
        O(), H.focusin = function(t) {
            e !== t.target && !e.contains(t.target) && r && r === t.target && r.focus(), (t.target === e || t.target === o || t.target === r) && document.addEventListener("keydown", H.keydown)
        }, H.focusout = function() {
            document.removeEventListener("keydown", H.keydown)
        }, H.keydown = function(t) {
            "Tab" === t.code && (t.target !== o || t.shiftKey || (t.preventDefault(), r.focus()), (t.target === e || t.target === r) && t.shiftKey && (t.preventDefault(), o.focus()))
        }, document.addEventListener("focusout", H.focusout), document.addEventListener("focusin", H.focusin), _(s, t)
    }

    function O() {
        document.removeEventListener("focusin", H.focusin), document.removeEventListener("focusout", H.focusout), document.removeEventListener("keydown", H.keydown)
    }

    function D() {
        window.accessibility.lastElement && document.body.classList.contains("is-focused") && setTimeout(() => {
            window.accessibility.lastElement?.focus()
        })
    }
    var F = Object.freeze({
        __proto__: null,
        forceFocus: _,
        focusHash: function e(t) {
            t = t || {};
            var i = window.location.hash,
                s = document.getElementById(i.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            i && s && _(s, t)
        },
        bindInPageLinks: function e(t) {
            var i;
            return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function(e) {
                if ("#" === e.hash || "" === e.hash || t.ignore && e.matches(t.ignore) || (i = e.hash.substr(1), null === document.getElementById(i))) return !1;
                var i, s = document.querySelector(e.hash);
                return !!s && (e.addEventListener("click", function() {
                    _(s, t)
                }), !0)
            })
        },
        focusable: M,
        trapFocus: B,
        removeTrapFocus: O,
        autoFocusLastElement: D,
        accessibleLinks: function e(t, i) {
            if ("string" != typeof t) throw TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (i = i || {}).messages = i.messages || {};
                var s, r, o, a = {
                        newWindow: i.messages.newWindow || "Opens in a new window.",
                        external: i.messages.external || "Opens external website.",
                        newWindowExternal: i.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    n = i.prefix || "a11y",
                    l = {
                        newWindow: n + "-new-window-message",
                        external: n + "-external-message",
                        newWindowExternal: n + "-new-window-external-message"
                    };
                t.forEach(function(e) {
                    var t, i = e.getAttribute("target"),
                        s = e.getAttribute("rel"),
                        r = (t = e).hostname !== window.location.hostname,
                        o = "_blank" === i,
                        a = null === s || -1 === s.indexOf("noopener");
                    o && a && e.setAttribute("rel", null === s ? "noopener" : s + " noopener"), r && o ? e.setAttribute("aria-describedby", l.newWindowExternal) : r ? e.setAttribute("aria-describedby", l.external) : o && e.setAttribute("aria-describedby", l.newWindow)
                }), s = a, r = document.createElement("ul"), o = Object.keys(s).reduce(function(e, t) {
                    return e + ("<li id=" + l[t] + ">" + s[t]) + "</li>"
                }, ""), r.setAttribute("hidden", !0), r.innerHTML = o, document.body.appendChild(r)
            }
        }
    });
    let N = {
            inputSearch: 'input[type="search"]',
            focusedElements: '[aria-selected="true"] a',
            resetButton: 'button[type="reset"]'
        },
        W = {
            hidden: "hidden"
        };
    class R extends HTMLElement {
        constructor() {
            super(), this.input = this.querySelector(N.inputSearch), this.resetButton = this.querySelector(N.resetButton), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", m(e => {
                this.onChange(e)
            }, 300).bind(this)))
        }
        toggleResetButton() {
            let e = this.resetButton.classList.contains(W.hidden);
            this.input.value.length > 0 && e ? this.resetButton.classList.remove(W.hidden) : 0 !== this.input.value.length || e || this.resetButton.classList.add(W.hidden)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(N.focusedElements)
        }
        onFormReset(e) {
            e.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), e.target.querySelector(N.inputSearch).focus())
        }
    }
    customElements.define("header-search-form", R);
    let V = {
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            predictiveSearch: "predictive-search",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearchStatus: "[data-predictive-search-status]",
            searchInput: 'input[type="search"]',
            searchPopdown: "[data-popdown]",
            searchResultsLiveRegion: "[data-predictive-search-live-region-count-value]",
            searchResultsGroupsWrapper: "[data-search-results-groups-wrapper]",
            searchForText: "[data-predictive-search-search-for-text]",
            sectionPredictiveSearch: "#shopify-section-predictive-search",
            selectedLink: '[aria-selected="true"] a',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]'
        },
        U = {
            popoutList: "[data-popout-list]",
            popoutToggle: "[data-popout-toggle]",
            popoutToggleText: "[data-popout-toggle-text]",
            popoutInput: "[data-popout-input]",
            popoutOptions: "[data-popout-option]",
            productGridImage: "[data-product-image]",
            productGridItem: "[data-grid-item]",
            section: "[data-section-type]"
        },
        z = {
            listVisible: "popout-list--visible",
            visible: "is-visible",
            active: "is-active",
            selectPopoutTop: "select-popout--top"
        },
        j = {
            ariaExpanded: "aria-expanded",
            ariaCurrent: "aria-current",
            dataValue: "data-value",
            popoutToggleText: "data-popout-toggle-text",
            submit: "submit"
        };
    class X extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.popoutList = this.querySelector(U.popoutList), this.popoutToggle = this.querySelector(U.popoutToggle), this.popoutToggleText = this.querySelector(U.popoutToggleText), this.popoutInput = this.querySelector(U.popoutInput), this.popoutOptions = this.querySelectorAll(U.popoutOptions), this.productGridItem = this.popoutList.closest(U.productGridItem), this.fireSubmitEvent = this.hasAttribute(j.submit), this.popupToggleFocusoutEvent = e => this.onPopupToggleFocusout(e), this.popupListFocusoutEvent = e => this.onPopupListFocusout(e), this.popupToggleClickEvent = e => this.onPopupToggleClick(e), this.keyUpEvent = e => this.onKeyUp(e), this.bodyClickEvent = e => this.onBodyClick(e), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth()
        }
        onPopupToggleClick(e) {
            let t = e.currentTarget,
                i = "true" === t.getAttribute(j.ariaExpanded);
            if (this.productGridItem) {
                let s = this.productGridItem.querySelector(U.productGridImage);
                s && s.classList.toggle(z.visible, !i), this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`
            }
            e.currentTarget.setAttribute(j.ariaExpanded, !i), this.popoutList.classList.toggle(z.listVisible), this.popupListMaxWidth(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent)
        }
        onPopupToggleFocusout(e) {
            let t = this.contains(e.relatedTarget);
            t || this._hideList()
        }
        onPopupListFocusout(e) {
            let t = e.currentTarget.contains(e.relatedTarget),
                i = this.popoutList.classList.contains(z.listVisible);
            i && !t && this._hideList()
        }
        toggleListPosition() {
            let e = this.querySelector(U.popoutToggle),
                t = "true" === e.getAttribute(j.ariaExpanded),
                i = window.innerHeight,
                s = this.popoutList.getBoundingClientRect().bottom,
                r = () => {
                    this.classList.remove(z.selectPopoutTop), this.popoutList.removeEventListener("transitionend", r)
                };
            t ? i < s && this.classList.add(z.selectPopoutTop) : this.popoutList.addEventListener("transitionend", r)
        }
        popupListMaxWidth() {
            this.popoutList.style.setProperty("--max-width", "100vw"), requestAnimationFrame(() => {
                this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`)
            })
        }
        popupOptionsClick(e) {
            let t = e.target.closest(U.popoutOptions);
            if ("#" === t.attributes.href.value) {
                e.preventDefault();
                let i = e.currentTarget.hasAttribute(j.dataValue) ? e.currentTarget.getAttribute(j.dataValue) : "";
                if (this.popoutInput.value = i, this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent) this._submitForm(i);
                else {
                    let s = e.currentTarget.parentElement,
                        r = this.popoutList.querySelector(`.${z.active}`),
                        o = this.popoutList.querySelector(`[${j.ariaCurrent}]`);
                    this.popoutInput.dispatchEvent(new Event("change")), r && (r.classList.remove(z.active), s.classList.add(z.active)), "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(z.active), o && o.hasAttribute(`${j.ariaCurrent}`) && (o.removeAttribute(`${j.ariaCurrent}`), e.currentTarget.setAttribute(`${j.ariaCurrent}`, "true")), "" !== i && (this.popoutToggleText.innerHTML = i, this.popoutToggleText.hasAttribute(j.popoutToggleText) && "" !== this.popoutToggleText.getAttribute(j.popoutToggleText) && this.popoutToggleText.setAttribute(j.popoutToggleText, i)), this.onPopupToggleFocusout(e), this.onPopupListFocusout(e)
                }
            }
        }
        onKeyUp(e) {
            "Escape" === e.code && (this._hideList(), this.popoutToggle.focus())
        }
        onBodyClick(e) {
            let t = this.contains(e.target),
                i = this.popoutList.classList.contains(z.listVisible);
            i && !t && this._hideList()
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach(e => {
                e.addEventListener("click", e => this.popupOptionsClick(e))
            })
        }
        _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent)
        }
        _submitForm() {
            let e = this.closest("form");
            e && e.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(z.listVisible), this.popoutToggle.setAttribute(j.ariaExpanded, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent)
        }
    }
    class G extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
                bubbles: !0
            }), this.buttonClickEvent = this.onButtonClick.bind(this), this.onQuantityChangeEvent = this.onQuantityChange.bind(this), this.input.addEventListener("change", this.onQuantityChangeEvent), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.buttonClickEvent))
        }
        onButtonClick(e) {
            e.preventDefault();
            let t = this.input.value,
                i = "BUTTON" == e.target.nodeName ? e.target : e.target.closest("button");
            "increase" === i.name && this.input.stepUp(), "decrease" === i.name && this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
        }
        onQuantityChange() {
            "updates[]" == this.input.name && this.updateCart()
        }
        updateCart() {
            "" !== this.quantityValue && this.dispatchEvent(new CustomEvent("theme:cart:update", {
                bubbles: !0,
                detail: {
                    id: this.input.dataset.id,
                    quantity: this.input.value
                }
            }))
        }
    }
    let J = {
            aos: "[data-aos]:not(.aos-animate)",
            aosAnchor: "[data-aos-anchor]",
            aosIndividual: "[data-aos]:not([data-aos-anchor]):not(.aos-animate)"
        },
        Y = {
            aosAnimate: "aos-animate"
        },
        Q = {
            attributes: !1,
            childList: !0,
            subtree: !0
        },
        K = [],
        Z = e => {
            for (let t of e)
                if ("childList" === t.type) {
                    let i = t.target,
                        s = i.querySelectorAll(J.aos),
                        r = i.querySelectorAll(J.aosAnchor);
                    s.length && s.forEach(e => {
                        ee.observe(e)
                    }), r.length && ei(r)
                }
        },
        ee = new IntersectionObserver((e, t) => {
            e.forEach(e => {
                e.isIntersecting && (e.target.classList.add(Y.aosAnimate), t.unobserve(e.target))
            })
        }, {
            root: null,
            rootMargin: "0px",
            threshold: [0, .1, .25, .5, .75, 1]
        }),
        et = new IntersectionObserver((e, t) => {
            e.forEach(e => {
                if (e.intersectionRatio) {
                    let i = e.target.querySelectorAll(J.aos);
                    i.length && i.forEach(e => {
                        e.classList.add(Y.aosAnimate)
                    }), t.unobserve(e.target)
                }
            })
        }, {
            root: null,
            rootMargin: "0px",
            threshold: [.1, .25, .5, .75, 1]
        });

    function ei(e) {
        e.length && e.forEach(e => {
            let t = e.dataset.aosAnchor;
            if (t && -1 === K.indexOf(t)) {
                let i = document.querySelector(t);
                i && (et.observe(i), K.push(t))
            }
        })
    }
    let es = {
            deferredMediaButton: "[data-deferred-media-button]",
            media: "video, model-viewer, iframe",
            youtube: '[data-host="youtube"]',
            vimeo: '[data-host="vimeo"]',
            productGridItem: "[data-grid-item]",
            section: ".shopify-section",
            template: "template",
            video: "video",
            productModel: "product-model"
        },
        er = {
            loaded: "loaded",
            autoplay: "autoplay"
        };
    class eo extends HTMLElement {
        constructor() {
            super();
            let e = this.querySelector(es.deferredMediaButton);
            e?.addEventListener("click", this.loadContent.bind(this)), this.section = this.closest(es.section), this.productGridItem = this.closest(es.productGridItem), this.hovered = !1, this.mouseEnterEvent = () => this.mouseEnterActions(), this.mouseLeaveEvent = () => this.mouseLeaveActions()
        }
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent))
        }
        disconnectedCallback() {
            this.productGridItem && (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent))
        }
        mouseEnterActions() {
            this.hovered = !0, this.videoActions(), this.getAttribute(er.loaded) || this.loadContent()
        }
        mouseLeaveActions() {
            this.hovered = !1, this.videoActions()
        }
        videoActions() {
            if (this.getAttribute(er.loaded)) {
                let e = this.querySelector(es.youtube),
                    t = this.querySelector(es.vimeo),
                    i = e || t,
                    s = this.querySelector(es.video);
                if (i) {
                    let r = this.hovered ? "playVideo" : "pauseVideo",
                        o = `{"event":"command","func":"${r}","args":""}`;
                    t && (o = `{"method":"${r=this.hovered?"play":"pause"}"}`), i.contentWindow.postMessage(o, "*"), i.addEventListener("load", e => {
                        this.videoActions()
                    })
                } else s && (this.hovered ? s.play() : s.pause())
            }
        }
        loadContent(e = !0) {
            if (this.pauseAllMedia(), !this.getAttribute(er.loaded)) {
                let t = document.createElement("div"),
                    i = this.querySelector(es.template).content.firstElementChild.cloneNode(!0);
                t.appendChild(i), this.setAttribute(er.loaded, !0);
                let s = this.appendChild(t.querySelector(es.media));
                e && s.focus(), "VIDEO" == s.nodeName && s.getAttribute(er.autoplay) && s.play(), this.productGridItem && this.videoActions()
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(es.youtube).forEach(e => {
                e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            }), document.querySelectorAll(es.vimeo).forEach(e => {
                e.contentWindow.postMessage('{"method":"pause"}', "*")
            }), document.querySelectorAll(es.video).forEach(e => e.pause()), document.querySelectorAll(es.productModel).forEach(e => {
                e.modelViewerUI && e.modelViewerUI.pause()
            })
        }
    }
    let ea = {
        visible: "is-visible"
    };
    class en {
        constructor(e, t) {
            if (!e || !t) return;
            this.observer = null, this.container = e, this.itemSelector = t, this.init()
        }
        init() {
            let e = {
                root: this.container,
                threshold: [.01, .5, .75, .99]
            };
            this.observer = new IntersectionObserver(e => {
                e.forEach(e => {
                    e.intersectionRatio >= .99 ? e.target.classList.add(ea.visible) : e.target.classList.remove(ea.visible)
                })
            }, e), this.container.querySelectorAll(this.itemSelector)?.forEach(e => {
                this.observer.observe(e)
            })
        }
        destroy() {
            this.observer.disconnect()
        }
    }
    let el = {
            dragging: "is-dragging",
            enabled: "is-enabled",
            scrolling: "is-scrolling",
            visible: "is-visible"
        },
        ed = {
            image: "img, svg",
            productImage: "[data-product-image]",
            slide: "[data-grid-item]",
            slider: "[data-grid-slider]"
        };
    class ec {
        constructor(e) {
            this.slider = e, this.isDown = !1, this.startX = 0, this.scrollLeft = 0, this.velX = 0, this.scrollAnimation = null, this.isScrolling = !1, this.duration = 800, this.scrollStep = this.scrollStep.bind(this), this.scrollToSlide = this.scrollToSlide.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseWheel = this.handleMouseWheel.bind(this), this.slider.addEventListener("mousedown", this.handleMouseDown), this.slider.addEventListener("mouseleave", this.handleMouseLeave), this.slider.addEventListener("mouseup", this.handleMouseUp), this.slider.addEventListener("mousemove", this.handleMouseMove), this.slider.addEventListener("wheel", this.handleMouseWheel, {
                passive: !0
            }), this.slider.classList.add(el.enabled)
        }
        handleMouseDown(e) {
            e.preventDefault(), this.isDown = !0, this.startX = e.pageX - this.slider.offsetLeft, this.scrollLeft = this.slider.scrollLeft, this.cancelMomentumTracking()
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1, this.beginMomentumTracking())
        }
        handleMouseUp() {
            this.isDown = !1, this.beginMomentumTracking()
        }
        handleMouseMove(e) {
            if (!this.isDown) return;
            e.preventDefault();
            let t = e.pageX - this.slider.offsetLeft,
                i = (t - this.startX) * 1,
                s = this.slider.scrollLeft;
            this.slider.classList.add(el.dragging, el.scrolling), this.slider.scrollLeft = this.scrollLeft - i, this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || (i > 0 ? 1 : -1))
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(el.scrolling)
        }
        beginMomentumTracking() {
            this.isScrolling = !1, this.slider.classList.remove(el.dragging), this.cancelMomentumTracking(), this.scrollToSlide()
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation)
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            let e = this.slider.querySelector(`${ed.slide}.${el.visible}`);
            if (!e) return;
            let t = parseInt(window.getComputedStyle(e).marginRight) || 0,
                i = e.offsetWidth + t,
                s = e.offsetLeft,
                r = this.velX > 0 ? 1 : -1,
                o = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft, this.distance = s - this.startPosition, this.startTime = performance.now(), this.isScrolling = !0, r < 0 && this.velX < i && (this.distance -= i * o), r > 0 && this.velX < i && (this.distance += i * o), this.scrollAnimation = requestAnimationFrame(this.scrollStep)
        }
        scrollStep() {
            let e = performance.now() - this.startTime,
                t = parseFloat(this.easeOutCubic(Math.min(e, this.duration))).toFixed(1);
            this.slider.scrollLeft = t, e < this.duration ? this.scrollAnimation = requestAnimationFrame(this.scrollStep) : (this.slider.classList.remove(el.scrolling), this.velX = 0, this.isScrolling = !1)
        }
        easeOutCubic(e) {
            return e /= this.duration, e--, this.distance * (e * e * e + 1) + this.startPosition
        }
        destroy() {
            this.slider.classList.remove(el.enabled), this.slider.removeEventListener("mousedown", this.handleMouseDown), this.slider.removeEventListener("mouseleave", this.handleMouseLeave), this.slider.removeEventListener("mouseup", this.handleMouseUp), this.slider.removeEventListener("mousemove", this.handleMouseMove), this.slider.removeEventListener("wheel", this.handleMouseWheel)
        }
    }
    let eh = {
            buttonArrow: "[data-button-arrow]",
            collectionImage: "[data-collection-image]",
            columnImage: "[data-column-image]",
            productImage: "[data-product-image]",
            slide: "[data-grid-item]",
            slider: "[data-grid-slider]"
        },
        eu = {
            buttonPrev: "data-button-prev",
            buttonNext: "data-button-next",
            alignArrows: "align-arrows"
        },
        ep = {
            arrows: "slider__arrows",
            visible: "is-visible",
            scrollSnapDisabled: "scroll-snap-disabled"
        };
    class em extends HTMLElement {
        constructor() {
            super(), this.isInitialized = !1, this.draggableSlider = null, this.positionArrows = this.positionArrows.bind(this), this.onButtonArrowClick = e => this.buttonArrowClickEvent(e), this.slidesObserver = null, this.firstLastSlidesObserver = null, this.isDragging = !1, this.toggleSlider = this.toggleSlider.bind(this)
        }
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init)
        }
        init() {
            var e;
            this.slider = this.querySelector(eh.slider), this.slides = this.querySelectorAll(eh.slide), this.buttons = this.querySelectorAll(eh.buttonArrow), this.slider.classList.add(ep.scrollSnapDisabled), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider), (e = this, new Promise(t => {
                let i = e.querySelectorAll("[data-aos]"),
                    s = 0;

                function r(e) {
                    ++s === i.length && t(), e.target.removeEventListener("animationend", r)
                }
                i.forEach(e => {
                    e.addEventListener("animationend", r)
                })
            })).then(() => {
                this.slider.classList.remove(ep.scrollSnapDisabled)
            })
        }
        toggleSlider() {
            let e = this.slider.clientWidth,
                t = this.getSlidesWidth();
            if (e < t && (b() || !window.theme.touch)) {
                if (this.isInitialized) return;
                this.slidesObserver = new en(this.slider, eh.slide), this.initArrows(), this.isInitialized = !0, this.draggableSlider = new ec(this.slider)
            } else this.destroy()
        }
        initArrows() {
            if (!this.buttons.length) {
                let e = document.createElement("div");
                e.classList.add(ep.arrows), e.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.append(e), this.buttons = this.querySelectorAll(eh.buttonArrow), this.buttonPrev = this.querySelector(`[${eu.buttonPrev}]`), this.buttonNext = this.querySelector(`[${eu.buttonNext}]`)
            }
            this.toggleArrowsObserver(), this.hasAttribute(eu.alignArrows) && (this.positionArrows(), this.arrowsResizeObserver()), this.buttons.forEach(e => {
                e.addEventListener("click", this.onButtonArrowClick)
            })
        }
        buttonArrowClickEvent(e) {
            e.preventDefault();
            let t = this.slider.querySelector(`${eh.slide}.${ep.visible}`),
                i = null;
            e.target.hasAttribute(eu.buttonPrev) && (i = t?.previousElementSibling), e.target.hasAttribute(eu.buttonNext) && (i = t?.nextElementSibling), this.goToSlide(i)
        }
        removeArrows() {
            this.querySelector(`.${ep.arrows}`)?.remove()
        }
        goToSlide(e) {
            e && this.slider.scrollTo({
                top: 0,
                left: e.offsetLeft,
                behavior: "smooth"
            })
        }
        getSlidesWidth() {
            return this.slider.querySelector(eh.slide)?.clientWidth * this.slider.querySelectorAll(eh.slide).length
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                let e = this.slides.length,
                    t = this.slides[0],
                    i = this.slides[e - 1],
                    s = {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    },
                    r = e => {
                        for (let s of e)
                            if ("attributes" === s.type) {
                                let r = s.target,
                                    o = Boolean(r.classList.contains(ep.visible));
                                r == t && (this.buttonPrev.disabled = o), r == i && (this.buttonNext.disabled = o)
                            }
                    };
                t && i && (this.firstLastSlidesObserver = new MutationObserver(r), this.firstLastSlidesObserver.observe(t, s), this.firstLastSlidesObserver.observe(i, s))
            }
        }
        positionArrows() {
            let e = this.slider.querySelector(eh.productImage) || this.slider.querySelector(eh.collectionImage) || this.slider.querySelector(eh.columnImage) || this.slider;
            e && this.style.setProperty("--button-position", `${e.clientHeight/2}px`)
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows)
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider)
        }
        destroy() {
            this.isInitialized = !1, this.draggableSlider?.destroy(), this.draggableSlider = null, this.slidesObserver?.destroy(), this.slidesObserver = null, this.removeArrows(), document.removeEventListener("theme:resize:width", this.positionArrows)
        }
    }
    let eg = {
            time: "time",
            days: "[data-days]",
            hours: "[data-hours]",
            minutes: "[data-minutes]",
            seconds: "[data-seconds]",
            shopifySection: ".shopify-section",
            countdownBlock: "[data-countdown-block]",
            tickerText: "[data-ticker-text]"
        },
        ev = {
            expirationBehavior: "data-expiration-behavior",
            clone: "data-clone"
        },
        eb = {
            showMessage: "show-message",
            hideCountdown: "hidden"
        },
        ey = {
            hideSection: "hide-section",
            showMessage: "show-message"
        };
    class ef extends HTMLElement {
        constructor() {
            super(), this.section = this.closest(eg.shopifySection), this.countdownParent = this.closest(eg.countdownBlock) || this.section, this.expirationBehavior = this.getAttribute(ev.expirationBehavior), this.time = this.querySelector(eg.time), this.days = this.querySelector(eg.days), this.hours = this.querySelector(eg.hours), this.minutes = this.querySelector(eg.minutes), this.seconds = this.querySelector(eg.seconds), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = this.expirationBehavior === ey.hideSection, this.shouldShowMessage = this.expirationBehavior === ey.showMessage, this.update = this.update.bind(this)
        }
        connectedCallback() {
            if (isNaN(this.endDate) || this.endDate <= Date.now()) {
                this.onComplete();
                return
            }
            this.update(), this.interval = setInterval(this.update, 1e3)
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        convertTime(e) {
            let t = this.formatDigits(parseInt(e / this.daysInMs, 10));
            e -= t * this.daysInMs;
            let i = this.formatDigits(parseInt(e / this.hoursInMs, 10));
            e -= i * this.hoursInMs;
            let s = this.formatDigits(parseInt(e / this.minutesInMs, 10));
            e -= s * this.minutesInMs;
            let r = this.formatDigits(parseInt(e / this.secondsInMs, 10));
            return {
                days: t,
                hours: i,
                minutes: s,
                seconds: r
            }
        }
        formatDigits(e) {
            return e < 10 && (e = "0" + e), e
        }
        render(e) {
            this.days.textContent = e.days, this.hours.textContent = e.hours, this.minutes.textContent = e.minutes, this.seconds.textContent = e.seconds
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        onComplete() {
            this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), this.shouldHideOnComplete && (this.countdownParent?.classList.add(eb.hideCountdown), this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:hide", {
                detail: {
                    element: this
                },
                bubbles: !0
            }))), this.shouldShowMessage && (this.classList?.add(eb.showMessage), !this.closest(eg.tickerText).hasAttribute(ev.clone) && this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:expire", {
                bubbles: !0
            })))
        }
        update() {
            let e = new Date().getTime(),
                t = this.endDate - e;
            t < 1e3 && (this.stopTimer(), this.onComplete());
            let i = this.convertTime(t);
            this.render(i)
        }
    }
    window.requestIdleCallback = window.requestIdleCallback || function(e) {
        var t = Date.now();
        return setTimeout(function() {
            e({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - t))
                }
            })
        }, 1)
    }, window.cancelIdleCallback = window.cancelIdleCallback || function(e) {
        clearTimeout(e)
    }, window.theme.settings.enableAnimations && (function e() {
        let t = document.querySelectorAll(J.aosIndividual);
        t.length && t.forEach(e => {
            ee.observe(e)
        })
    }(), function e() {
        let t = document.querySelectorAll(J.aosAnchor);
        t.length && ei(t)
    }(), function e() {
        let t = new MutationObserver(Z);
        t.observe(document.body, Q)
    }(), document.addEventListener("shopify:section:unload", e => {
        let t = "#" + e.target.querySelector("[data-section-id]")?.id,
            i = K.indexOf(t); - 1 !== i && K.splice(i, 1)
    })), window.addEventListener("resize", m(function() {
        document.dispatchEvent(new CustomEvent("theme:resize", {
            bubbles: !0
        })), f !== g() && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
            bubbles: !0
        })), f = g()), S !== v() && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
            bubbles: !0
        })), S = v())
    }, 50));
    let eS;
    window.addEventListener("scroll", function() {
        eS && window.cancelAnimationFrame(eS), eS = window.requestAnimationFrame(function() {
            ! function e() {
                let t = window.scrollY;
                t > w ? (E = !0, L = !1) : t < w ? (E = !1, L = !0) : (L = null, E = null), w = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                    detail: {
                        up: L,
                        down: E,
                        position: t
                    },
                    bubbles: !1
                })), L && !k && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                    detail: {
                        position: t
                    },
                    bubbles: !1
                })), E && !A && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                    detail: {
                        position: t
                    },
                    bubbles: !1
                })), A = E, k = L
            }()
        })
    }, {
        passive: !0
    }), window.addEventListener("theme:scroll:lock", function t(i) {
        setTimeout(() => {
            $ && clearTimeout($), e.disablePageScroll(i.detail, {
                allowTouchMove: e => "TEXTAREA" === e.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        })
    }), window.addEventListener("theme:scroll:unlock", function e(t) {
        let i = t.detail;
        i ? $ = setTimeout(C, i) : C()
    }), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, c(), document.addEventListener("load", e => {
        "img" == e.target.tagName.toLowerCase() && e.target.classList.contains(x.loading) && (e.target.classList.remove(x.loading), e.target.parentNode.classList.remove(x.loading), e.target.parentNode.parentNode.classList.contains(x.loading) && e.target.parentNode.parentNode.classList.remove(x.loading))
    }, !0), window.addEventListener("DOMContentLoaded", () => {
        d(), P(document), a(document), q(document),
            function e(t) {
                t.querySelectorAll(I.img).forEach(e => {
                    e.complete && (e.classList.remove(x.loading), e.parentNode.classList.remove(x.loading), e.parentNode.parentNode.classList.contains(x.loading) && e.parentNode.parentNode.classList.remove(x.loading))
                })
            }(document), document.body.classList.add("is-loaded"), o(), requestIdleCallback(() => {
                Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode")
            })
    }), document.addEventListener("shopify:section:load", e => {
        let t = e.target;
        a(t), q(t), P(document), d()
    }), customElements.get("popout-select") || customElements.define("popout-select", X), customElements.get("quantity-counter") || customElements.define("quantity-counter", G), customElements.get("predictive-search") || customElements.define("predictive-search", class e extends R {
        constructor() {
            super(), this.a11y = F, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(V.predictiveSearch), this.cachedResults = {}, this.input = this.querySelector(V.searchInput), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(V.predictiveSearchResults), this.searchPopdown = this.closest(V.searchPopdown), this.popularSearches = this.searchPopdown?.querySelector(V.popularSearches), this.searchTerm = ""
        }
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            let e = this.getQuery();
            if (this.searchTerm && e.startsWith(this.searchTerm) || this.querySelector(V.searchResultsGroupsWrapper)?.remove(), this.updateSearchForTerm(this.searchTerm, e), this.searchTerm = e, !this.searchTerm.length) {
                this.reset();
                return
            }
            this.getSearchResults(this.searchTerm)
        }
        onFormSubmit(e) {
            (!this.getQuery().length || this.querySelector(V.selectedLink)) && e.preventDefault()
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(V.selectedLink)
        }
        onFocus() {
            let e = this.getQuery();
            e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close()
            })
        }
        onKeyup(e) {
            switch (this.getQuery().length || this.close(!0), e.preventDefault(), e.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(e) {
            ("ArrowUp" === e.code || "ArrowDown" === e.code) && e.preventDefault()
        }
        updateSearchForTerm(e, t) {
            let i = this.querySelector(V.searchForText),
                s = i?.innerText;
            if (s) {
                if (s.match(RegExp(e, "g"))?.length > 1) return;
                let r = s.replace(e, t);
                i.innerText = r
            }
        }
        switchOption(e) {
            if (!this.getAttribute("open")) return;
            let t = "up" === e,
                i = this.querySelector(V.ariaSelected),
                s = Array.from(this.querySelectorAll(V.allVisibleElements)).filter(e => null !== e.offsetParent),
                r = 0;
            if (t && !i) return;
            let o = -1,
                a = 0;
            for (; - 1 === o && a <= s.length;) s[a] === i && (o = a), a++;
            if (this.statusElement.textContent = "", !t && i ? r = o === s.length - 1 ? 0 : o + 1 : t && (r = 0 === o ? s.length - 1 : o - 1), r === o) return;
            let n = s[r];
            n.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", n.id)
        }
        selectOption() {
            let e = this.querySelector(V.selectedOption);
            e && e.click()
        }
        getSearchResults(e) {
            let t = e.replace(" ", "-").toLowerCase();
            if (this.setLiveRegionLoadingState(), this.cachedResults[t]) {
                this.renderSearchResults(this.cachedResults[t]);
                return
            }
            fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then(e => {
                if (!e.ok) {
                    var t = Error(e.status);
                    throw this.close(), t
                }
                return e.text()
            }).then(e => {
                let i = new DOMParser().parseFromString(e, "text/html").querySelector(V.sectionPredictiveSearch).innerHTML;
                this.allPredictiveSearchInstances.forEach(e => {
                    e.cachedResults[t] = i
                }), this.renderSearchResults(i)
            }).catch(e => {
                if (e?.code !== 20) throw this.close(), e
            })
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(V.predictiveSearchStatus), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(e) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = e, setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }, 1e3)
        }
        renderSearchResults(e) {
            this.predictiveSearchResults.innerHTML = e, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(V.searchResultsLiveRegion).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0, this.predictiveSearchResults.style.setProperty("--full-screen", `${window.visualViewport.height}px`)
        }
        close(e = !1) {
            this.closeResults(e), this.isOpen = !1, this.predictiveSearchResults.style.removeProperty("--full-screen")
        }
        closeResults(e = !1) {
            e && (this.input.value = "", this.removeAttribute("results"));
            let t = this.querySelector(V.ariaSelected);
            t && t.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), this.predictiveSearchResults?.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus(), this.popularSearches && (this.input.dispatchEvent(new Event("blur", {
                bubbles: !1
            })), this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input
            }))
        }
    }), customElements.get("deferred-media") || customElements.define("deferred-media", eo), customElements.get("grid-slider") || customElements.define("grid-slider", em), customElements.get("countdown-timer") || customElements.define("countdown-timer", ef);
    let ew = (e, t = !1, i = "block") => {
        e && (t ? e.style.removeProperty("display") : e.style.display = i)
    };
    Shopify.Products = function() {
        let e = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                target: "api-product-grid-item",
                onComplete: null
            },
            t = [],
            i = null,
            s = null,
            r = new Date,
            o = new Date;
        o.setTime(r.getTime() + 7776e6);
        let a = {
                configuration: {
                    expires: o.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0
                },
                name: "shopify_recently_viewed",
                write: function(e) {
                    let t = encodeURIComponent(e.join(" "));
                    document.cookie = `${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
                },
                read: function() {
                    let e = [],
                        t = null;
                    return -1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find(e => e.startsWith(this.name)) && (t = document.cookie.split("; ").find(e => e.startsWith(this.name)).split("=")[1]), null !== t && (e = decodeURIComponent(t).split(" ")), e
                },
                destroy: function() {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                },
                remove: function(e) {
                    let t = this.read(),
                        i = t.indexOf(e); - 1 !== i && (t.splice(i, 1), this.write(t))
                }
            },
            n = (t, i) => {
                ew(t, !0);
                let r = a.read().length;
                if (Shopify.recentlyViewed && s && r && r < s && t.children.length) {
                    let o = [],
                        n = [],
                        l = 0;
                    for (let d in Shopify.recentlyViewed) {
                        l += 1;
                        let c = Shopify.recentlyViewed[d],
                            h = c.split(" "),
                            u = parseInt(d.split("_")[1]);
                        o = [...o, ...h], a.read().length !== u && (l !== Object.keys(Shopify.recentlyViewed).length || n.length) || (n = [...n, ...h])
                    }
                    for (let p = 0; p < t.children.length; p++) {
                        let m = t.children[p];
                        o.length && m.classList.remove(...o), n.length && m.classList.add(...n)
                    }
                }
                if (e.onComplete) try {
                    e.onComplete(t, i)
                } catch (g) {
                    console.log(g)
                }
            },
            l = (e, t, i, s, r, o) => {
                t.length && e < o ? fetch(`${window.theme.routes.root}products/${t[0]}?section_id=${r}`).then(e => e.text()).then(a => {
                    let n = 100 * e,
                        d = i.id ? `#${i.id}` : "",
                        c = document.createElement("div"),
                        h = a;
                    h = (h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", n) : h).includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", d) : h, c.innerHTML = h, i.innerHTML += c.querySelector("[data-api-content]").innerHTML, t.shift(), l(++e, t, i, s, r, o)
                }).catch(() => {
                    a.remove(t[0]), t.shift(), l(e, t, i, s, r, o)
                }) : n(i, s)
            };
        return {
            showRecentlyViewed: function(r) {
                Object.assign(e, r || {}), t = a.read(), i = document.querySelector(`#${e.wrapperId}`), s = e.howManyToShow, e.howManyToShow = Math.min(t.length, e.howManyToShow), e.howManyToShow && i && l(0, t, i, e.section, e.target, s)
            },
            getConfig: function() {
                return e
            },
            clearList: function() {
                a.destroy()
            },
            recordRecentlyViewed: function(t) {
                Object.assign(e, t || {});
                let i = a.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let s = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];
                    e.handle && (s = e.handle);
                    let r = i.indexOf(s); - 1 === r ? (i.unshift(s), i = i.splice(0, e.howManyToStoreInMemory)) : (i.splice(r, 1), i.unshift(s)), a.write(i)
                }
            },
            hasProducts: a.read().length > 0
        }
    }();
    let eL = {
            focus: "is-focused"
        },
        eE = {
            inPageLink: "[data-skip-content]",
            linkesWithOnlyHash: 'a[href="#"]'
        };

    function ek(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        let i = "",
            s = /\{\{\s*(\w+)\s*\}\}/,
            r = t || "${{amount}}";

        function o(e, t = 2, i = ",", s = ".") {
            if (isNaN(e) || null == e) return 0;
            e = (e / 100).toFixed(t);
            let r = e.split("."),
                o = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`),
                a = r[1] ? s + r[1] : "";
            return o + a
        }
        switch (r.match(s)[1]) {
            case "amount":
                i = o(e, 2);
                break;
            case "amount_no_decimals":
                i = o(e, 0);
                break;
            case "amount_with_comma_separator":
                i = o(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = o(e, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = o(e, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                i = o(e, 0, " ", "");
                break;
            case "amount_with_space_separator":
                i = o(e, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = o(e, 2, " ", ".")
        }
        return r.replace(s, i)
    }
    window.accessibility = new class e {
        constructor() {
            this.init()
        }
        init() {
            this.a11y = F, this.html = document.documentElement, this.body = document.body, this.inPageLink = document.querySelector(eE.inPageLink), this.linkesWithOnlyHash = document.querySelectorAll(eE.linkesWithOnlyHash), this.a11y.focusHash(), this.a11y.bindInPageLinks(), this.clickEvents(), this.focusEvents()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", e => {
                e.preventDefault()
            }), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach(e => {
                e.addEventListener("click", e => {
                    e.preventDefault()
                })
            })
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(eL.focus)
            }), document.addEventListener("keyup", e => {
                "Tab" === e.code && this.body.classList.add(eL.focus)
            })
        }
    };
    let eA = (e, t) => {
        let i, s;
        return function r(...o) {
            let a = Date.now();
            s = clearTimeout(s), !i || a - i >= t ? (e.apply(null, o), i = a) : s = setTimeout(r.bind(null, ...o), t - (a - i))
        }
    };

    function e$(e) {
        this.status = e.status || null, this.headers = e.headers || null, this.json = e.json || null, this.body = e.body || null
    }
    e$.prototype = Error.prototype;
    let eC = {
            animated: "is-animated",
            active: "is-active",
            added: "is-added",
            disabled: "is-disabled",
            empty: "is-empty",
            error: "has-error",
            headerStuck: "js__header__stuck",
            hidden: "is-hidden",
            hiding: "is-hiding",
            loading: "is-loading",
            open: "is-open",
            removed: "is-removed",
            success: "is-success",
            visible: "is-visible",
            expanded: "is-expanded",
            updated: "is-updated",
            variantSoldOut: "variant--soldout",
            variantUnavailable: "variant--unavailable"
        },
        eT = {
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            animation: "[data-animation]",
            additionalCheckoutButtons: ".additional-checkout-buttons",
            buttonSkipUpsellProduct: "[data-skip-upsell-product]",
            cartBarAdd: "[data-add-to-cart-bar]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartEmpty: "[data-cart-empty]",
            cartErrors: "[data-cart-errors]",
            cartItemRemove: "[data-item-remove]",
            cartPage: "[data-cart-page]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartTotal: "[data-cart-total]",
            checkoutButtons: "[data-checkout-buttons]",
            errorMessage: "[data-error-message]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            formWrapper: "[data-form-wrapper]",
            freeShipping: "[data-free-shipping]",
            freeShippingGraph: "[data-progress-graph]",
            freeShippingProgress: "[data-progress-bar]",
            headerWrapper: "[data-header-wrapper]",
            item: "[data-item]",
            itemsHolder: "[data-items-holder]",
            leftToSpend: "[data-left-to-spend]",
            navDrawer: "[data-drawer]",
            outerSection: "[data-section-id]",
            priceHolder: "[data-cart-price-holder]",
            quickAddHolder: "[data-quick-add-holder]",
            quickAddModal: "[data-quick-add-modal]",
            qtyInput: 'input[name="updates[]"]',
            upsellProductsHolder: "[data-upsell-products]",
            upsellWidget: "[data-upsell-widget]",
            termsErrorMessage: "[data-terms-error-message]",
            collapsibleBody: "[data-collapsible-body]",
            recentlyViewedHolderId: "recently-viewed-products-cart"
        },
        eq = {
            cartTotal: "data-cart-total",
            disabled: "disabled",
            freeShipping: "data-free-shipping",
            freeShippingLimit: "data-free-shipping-limit",
            item: "data-item",
            itemIndex: "data-item-index",
            itemTitle: "data-item-title",
            open: "open",
            quickAddHolder: "data-quick-add-holder",
            quickAddVariant: "data-quick-add-variant",
            scrollLocked: "data-scroll-locked",
            upsellAutoOpen: "data-upsell-auto-open"
        };
    class eP extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.cartPage = document.querySelector(eT.cartPage), this.cartForm = document.querySelector(eT.cartForm), this.cartDrawer = document.querySelector(eT.cartDrawer), this.cartEmpty = document.querySelector(eT.cartEmpty), this.cartTermsCheckbox = document.querySelector(eT.cartTermsCheckbox), this.cartCheckoutButtonWrapper = document.querySelector(eT.cartCheckoutButtonWrapper), this.cartCheckoutButton = document.querySelector(eT.cartCheckoutButton), this.checkoutButtons = document.querySelector(eT.checkoutButtons), this.itemsHolder = document.querySelector(eT.itemsHolder), this.priceHolder = document.querySelector(eT.priceHolder), this.items = document.querySelectorAll(eT.item), this.cartTotal = document.querySelector(eT.cartTotal), this.freeShipping = document.querySelectorAll(eT.freeShipping), this.cartErrorHolder = document.querySelector(eT.cartErrors), this.cartCloseErrorMessage = document.querySelector(eT.cartCloseError), this.headerWrapper = document.querySelector(eT.headerWrapper), this.navDrawer = document.querySelector(eT.navDrawer), this.upsellProductsHolder = document.querySelector(eT.upsellProductsHolder), this.subtotal = window.theme.subtotal, this.cart = this.cartDrawer || this.cartPage, this.animateItems = this.animateItems.bind(this), this.addToCart = this.addToCart.bind(this), this.cartAddEvent = this.cartAddEvent.bind(this), this.updateProgress = this.updateProgress.bind(this), this.onCartDrawerClose = this.onCartDrawerClose.bind(this), document.addEventListener("theme:cart:add", this.cartAddEvent), document.addEventListener("theme:announcement:init", this.updateProgress), "drawer" == theme.settings.cartType && (document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose)), this.skipUpsellProductsArray = [], this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility(), this.circumference = 28 * Math.PI, this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(eq.freeShippingLimit)) * window.Shopify.currency.rate : 0, this.freeShippingMessageHandle(this.subtotal), this.updateProgress(), this.build = this.build.bind(this), this.updateCart = this.updateCart.bind(this), this.productAddCallback = this.productAddCallback.bind(this), this.formSubmitHandler = eA(this.formSubmitHandler.bind(this), 50), this.cartPage && this.animateItems(), this.cart && (this.recentlyViewedProducts(), this.hasItemsInCart = this.hasItemsInCart.bind(this), this.cartCount = this.getCartItemCount()), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = this.items.length, this.cartUpdateFailed = !1, this.cartEvents(), this.cartRemoveEvents(), this.cartUpdateEvents(), document.addEventListener("theme:product:add", this.productAddCallback), document.addEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:load", {
                bubbles: !0
            }))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent), document.removeEventListener("theme:announcement:init", this.updateProgress), document.removeEventListener("theme:product:add", this.productAddCallback), document.removeEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:unload", {
                bubbles: !0
            })), document.documentElement.hasAttribute(eq.scrollLocked) && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        onCartDrawerClose() {
            this.resetAnimatedItems(), this.cartDrawer?.classList.contains(eC.open) && this.cart.classList.remove(eC.updated), this.cartEmpty.classList.remove(eC.updated), this.cartErrorHolder.classList.remove(eC.expanded), this.cart.querySelectorAll(eT.animation).forEach(e => {
                let t = () => {
                    e.classList.remove(eC.hiding), e.removeEventListener("animationend", t)
                };
                e.classList.add(eC.hiding), e.addEventListener("animationend", t)
            })
        }
        cartUpdateEvents() {
            this.items = document.querySelectorAll(eT.item), this.items.forEach(e => {
                e.addEventListener("theme:cart:update", t => {
                    this.updateCart({
                        id: t.detail.id,
                        quantity: t.detail.quantity
                    }, e)
                })
            })
        }
        cartRemoveEvents() {
            let e = document.querySelectorAll(eT.cartItemRemove);
            e.forEach(e => {
                let t = e.closest(eT.item);
                e.addEventListener("click", i => {
                    i.preventDefault(), e.classList.contains(eC.disabled) || this.updateCart({
                        id: e.dataset.id,
                        quantity: 0
                    }, t)
                })
            }), this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", e => {
                e.preventDefault(), this.cartErrorHolder.classList.remove(eC.expanded)
            })
        }
        cartAddEvent(e) {
            let t = "",
                i = e.detail.button;
            if (i.hasAttribute("disabled")) return;
            let s = i.closest("form");
            if (!s.checkValidity()) {
                s.reportValidity();
                return
            }
            t = new FormData(s), !(null !== s && s.querySelector('[type="file"]')) && ("drawer" === theme.settings.cartType && this.cartDrawer && e.preventDefault(), this.addToCart(t, i))
        }
        cartEvents() {
            this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
        }
        formSubmitHandler() {
            let e = document.querySelector(eT.cartTermsCheckbox).checked,
                t = document.querySelector(eT.termsErrorMessage);
            if (e) t.classList.remove(eC.expanded), this.cartCheckoutButton.removeAttribute(eq.disabled);
            else {
                if (document.querySelector(eT.termsErrorMessage).length > 0) return;
                t.innerText = theme.strings.cartAcceptanceError, this.cartCheckoutButton.setAttribute(eq.disabled, !0), t.classList.add(eC.expanded)
            }
        }
        formErrorsEvents(e) {
            let t = e.querySelector(eT.formCloseError);
            t?.addEventListener("click", t => {
                t.preventDefault(), e && e.classList.remove(eC.visible)
            })
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.cartErrorsHandler).then(e => e.text()).then(e => {
                let t = document.createElement("div");
                t.innerHTML = e;
                let i = t.querySelector(eT.apiContent);
                this.build(i)
            }).catch(e => console.log(e))
        }
        addToCart(e, t) {
            this.cart && this.cart.classList.add(eC.loading);
            let i = t?.closest(eT.quickAddHolder);
            t && (t.classList.add(eC.loading), t.disabled = !0), i && i.classList.add(eC.visible), fetch(theme.routes.cart_add_url, {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                },
                body: e
            }).then(e => e.json()).then(e => {
                if (e.status) {
                    this.addToCartError(e, t), t && (t.classList.remove(eC.loading), t.disabled = !1);
                    return
                }
                this.cart ? (t && (t.classList.remove(eC.loading), t.classList.add(eC.added), t.dispatchEvent(new CustomEvent("theme:product:add", {
                    detail: {
                        response: e,
                        button: t
                    },
                    bubbles: !0
                }))), "page" === theme.settings.cartType && (window.location = theme.routes.cart_url), this.getCart()) : window.location = theme.routes.cart_url
            }).catch(e => {
                this.addToCartError(e, t), this.enableCartButtons()
            })
        }
        updateCart(e = {}, t = null) {
            this.cart.classList.add(eC.loading);
            let i = e.quantity;
            null !== t && (i ? t.classList.add(eC.loading) : t.classList.add(eC.removed)), this.disableCartButtons();
            let s = this.cart.querySelector(`[${eq.item}="${e.id}"]`) || t,
                r = s?.hasAttribute(eq.itemIndex) ? parseInt(s.getAttribute(eq.itemIndex)) : 0,
                o = s?.hasAttribute(eq.itemTitle) ? s.getAttribute(eq.itemTitle) : null;
            0 !== r && fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    line: r,
                    quantity: i
                })
            }).then(e => e.text()).then(e => {
                let i = JSON.parse(e);
                if (i.errors) {
                    this.cartUpdateFailed = !0, this.updateErrorText(o), this.toggleErrorMessage(), this.resetLineItem(t), this.enableCartButtons();
                    return
                }
                this.getCart()
            }).catch(e => {
                console.log(e), this.enableCartButtons()
            })
        }
        resetLineItem(e) {
            let t = e.querySelector(eT.qtyInput),
                i = t.getAttribute("value");
            t.value = i, e.classList.remove(eC.loading)
        }
        disableCartButtons() {
            let e = this.cart.querySelectorAll("input"),
                t = this.cart.querySelectorAll(`button, ${eT.cartItemRemove}`);
            e.length && e.forEach(e => {
                e.classList.add(eC.disabled), e.blur(), e.disabled = !0
            }), t.length && t.forEach(e => {
                e.setAttribute(eq.disabled, !0)
            })
        }
        enableCartButtons() {
            let e = this.cart.querySelectorAll("input"),
                t = this.cart.querySelectorAll(`button, ${eT.cartItemRemove}`);
            e.length && e.forEach(e => {
                e.classList.remove(eC.disabled), e.disabled = !1
            }), t.length && t.forEach(e => {
                e.removeAttribute(eq.disabled)
            }), this.cart.classList.remove(eC.loading)
        }
        updateErrorText(e) {
            this.cartErrorHolder.querySelector(eT.errorMessage).innerText = e
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(eC.expanded, this.cartUpdateFailed), this.cartUpdateFailed = !1)
        }
        cartErrorsHandler(e) {
            return e.ok ? e : e.json().then(function(t) {
                let i = new e$({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                });
                throw i
            })
        }
        addToCartError(e, t) {
            if (null !== t) {
                let i = t.closest(eT.outerSection) || t.closest(eT.quickAddHolder) || t.closest(eT.quickAddModal),
                    s = i?.querySelector(eT.formErrorsContainer),
                    r = t.closest(eT.quickAddHolder);
                if (r && r.querySelector(eT.formErrorsContainer) && (s = r.querySelector(eT.formErrorsContainer)), s) {
                    let o = `${e.message}: ${e.description}`;
                    e.message == e.description && (o = e.message), s.innerHTML = `<div class="errors">${o}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`, s.classList.add(eC.visible), this.formErrorsEvents(s)
                }
                t.dispatchEvent(new CustomEvent("theme:product:add-error", {
                    detail: {
                        response: e,
                        button: t
                    },
                    bubbles: !0
                }))
            }
            let a = t?.closest(eT.quickAddHolder);
            a && a.dispatchEvent(new CustomEvent("theme:cart:error", {
                bubbles: !0,
                detail: {
                    message: e.message,
                    description: e.description,
                    holder: a
                }
            })), this.cart?.classList.remove(eC.loading)
        }
        productAddCallback(e) {
            let t = [],
                i = null,
                s = "theme:product:add-error" == e.type,
                r = e.detail.button,
                o = document.querySelector(eT.cartBarAdd);
            t.push(r), i = r.closest(eT.quickAddHolder), o && t.push(o), t.forEach(e => {
                e.classList.remove(eC.loading), s || e.classList.add(eC.added)
            }), setTimeout(() => {
                t.forEach(e => {
                    e.classList.remove(eC.added);
                    let t = e.closest(eT.formWrapper)?.classList.contains(eC.variantSoldOut) || e.closest(eT.formWrapper)?.classList.contains(eC.variantUnavailable);
                    t || (e.disabled = !1)
                }), i?.classList.remove(eC.visible)
            }, 1e3)
        }
        toggleClassesOnContainers() {
            let e = this.hasItemsInCart();
            this.cart.classList.toggle(eC.empty, !e), !e && this.cartDrawer && setTimeout(() => {
                B(this.cartDrawer, {
                    elementToFocus: this.cartDrawer.querySelector(eT.cartDrawerClose)
                })
            }, 100)
        }
        build(e) {
            let t = e.querySelector(eT.apiLineItems),
                i = e.querySelector(eT.apiUpsellItems),
                s = Boolean(null === t && null === i),
                r = e.querySelector(eT.apiCartPrice),
                o = e.querySelector(eT.cartTotal);
            this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML), s ? (this.itemsHolder.innerHTML = e.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = t.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = i.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()), this.newTotalItems = t && t.querySelectorAll(eT.item).length ? t.querySelectorAll(eT.item).length : 0, this.subtotal = o && o.hasAttribute(eq.cartTotal) ? parseInt(o.getAttribute(eq.cartTotal)) : 0, this.cartCount = this.getCartItemCount(), document.dispatchEvent(new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: {
                    cartCount: this.cartCount
                }
            })), this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : ek(this.subtotal, theme.moneyWithCurrencyFormat), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), this.cartDrawer?.classList.contains(eC.open) && this.cart.classList.add(eC.updated), this.cart.classList.remove(eC.loading), this.hasItemsInCart() || this.cartEmpty.querySelectorAll(eT.animation).forEach(e => {
                e.classList.remove(eC.animated)
            }), this.freeShippingMessageHandle(this.subtotal), this.cartRemoveEvents(), this.cartUpdateEvents(), this.toggleErrorMessage(), this.enableCartButtons(), this.updateProgress(), this.animateItems(), document.dispatchEvent(new CustomEvent("theme:product:added", {
                bubbles: !0
            }))
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(eT.qtyInput)).reduce((e, t) => e + parseInt(t.value), 0)
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        freeShippingMessageHandle(e) {
            this.freeShipping.length && this.freeShipping.forEach(t => {
                let i = t.hasAttribute(eq.freeShipping) && "true" === t.getAttribute(eq.freeShipping) && e >= 0;
                t.classList.toggle(eC.success, i && e >= this.freeShippingLimit)
            })
        }
        updateProgress() {
            if (this.freeShipping = document.querySelectorAll(eT.freeShipping), !this.freeShipping.length) return;
            let e = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                t = Math.min(100 * e, 100),
                i = this.circumference - t / 100 * this.circumference / 2,
                s = ek(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach(e => {
                let r = e.querySelector(eT.freeShippingProgress),
                    o = e.querySelector(eT.freeShippingGraph),
                    a = e.querySelector(eT.leftToSpend);
                a && (a.innerHTML = s.replace(".00", "")), r && (r.value = t), o && o.style.setProperty("--stroke-dashoffset", `${i}`)
            })
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            let e = this.upsellProductsHolder.querySelectorAll(eT.buttonSkipUpsellProduct);
            e.length && e.forEach(e => {
                e.addEventListener("click", t => {
                    t.preventDefault();
                    let i = e.closest(eT.quickAddHolder).getAttribute(eq.quickAddHolder);
                    this.skipUpsellProductsArray.includes(i) || this.skipUpsellProductsArray.push(i), window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray), this.removeUpsellProduct(i), this.toggleCartUpsellWidgetVisibility()
                })
            })
        }
        checkSkippedUpsellProductsFromStorage() {
            let e = window.sessionStorage.getItem("skip_upsell_products");
            if (!e) return;
            let t = e.split(",");
            t.forEach(e => {
                this.skipUpsellProductsArray.includes(e) || this.skipUpsellProductsArray.push(e), this.removeUpsellProduct(e)
            })
        }
        removeUpsellProduct(e) {
            if (!this.upsellProductsHolder) return;
            let t = this.upsellProductsHolder.querySelector(`[${eq.quickAddHolder}="${e}"]`);
            t && t.parentNode.remove()
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            let e = this.upsellProductsHolder.querySelectorAll(eT.quickAddHolder),
                t = this.upsellProductsHolder.closest(eT.upsellWidget);
            if (t && (t.classList.toggle(eC.hidden, !e.length), e.length && !t.hasAttribute(eq.open) && t.hasAttribute(eq.upsellAutoOpen))) {
                t.setAttribute(eq.open, !0);
                let i = t.querySelector(eT.collapsibleBody);
                i && (i.style.height = "auto")
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(eT.animation).forEach(e => {
                e.classList.remove(eC.animated), e.classList.remove(eC.hiding)
            })
        }
        animateItems(e) {
            requestAnimationFrame(() => {
                let t = this.cart;
                e && e.detail && e.detail.target && (t = e.detail.target), t?.querySelectorAll(eT.animation).forEach(e => {
                    e.classList.add(eC.animated)
                })
            })
        }
        recentlyViewedProducts() {
            let e = this.cart.querySelector(`#${eT.recentlyViewedHolderId}`);
            e && Shopify.Products.showRecentlyViewed({
                howManyToShow: 3,
                wrapperId: eT.recentlyViewedHolderId,
                section: this,
                target: "api-upsell-product"
            })
        }
    }
    customElements.get("cart-items") || customElements.define("cart-items", eP);
    let ex = {
        count: "data-cart-count",
        limit: "data-limit"
    };
    class eI extends HTMLElement {
        constructor() {
            super(), this.cartCount = null, this.limit = this.getAttribute(ex.limit), this.onCartChangeCallback = this.onCartChange.bind(this)
        }
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        onCartChange(e) {
            this.cartCount = e.detail.cartCount, this.update()
        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute(ex.count, this.cartCount);
                let e = this.cartCount;
                this.limit && this.cartCount >= this.limit && (e = "9+"), this.innerText = e
            }
        }
    }

    function e_(e) {
        return new Promise(t => {
            function i(s) {
                s.target == e && (e.removeEventListener("animationend", i), t())
            }
            e?.addEventListener("animationend", i)
        })
    }
    customElements.get("cart-count") || customElements.define("cart-count", eI);
    let eM = {
            open: "is-open",
            closing: "is-closing",
            duplicate: "drawer--duplicate",
            drawerEditorError: "drawer-editor-error"
        },
        eH = {
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartDrawerSection: '[data-section-type="cart-drawer"]',
            cartDrawerInner: "[data-cart-drawer-inner]",
            shopifySection: ".shopify-section"
        },
        eB = {
            drawerUnderlay: "data-drawer-underlay"
        };
    class eO extends HTMLElement {
        constructor() {
            super(), this.cartDrawerIsOpen = !1, this.cartDrawerClose = this.querySelector(eH.cartDrawerClose), this.cartDrawerInner = this.querySelector(eH.cartDrawerInner), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this), this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this), this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this), this.cartDrawerSection = this.closest(eH.shopifySection), this.closeCartEvents()
        }
        connectedCallback() {
            let e = this.closest(eH.shopifySection);
            if (window.theme.hasCartDrawer) {
                if (window.Shopify.designMode) {
                    let t = document.createElement("div");
                    t.classList.add(eM.drawerEditorError), t.innerText = "Cart drawer section already exists.", this.querySelector(`.${eM.drawerEditorError}`) || this.querySelector(eH.cartDrawerInner).append(t), this.classList.add(eM.duplicate)
                } else {
                    e.remove();
                    return
                }
            }
            window.theme.hasCartDrawer = !0, this.addEventListener("theme:cart-drawer:show", this.openCartDrawer), document.addEventListener("theme:cart:toggle", this.toggleCartDrawer), document.addEventListener("theme:quick-add:open", this.closeCartDrawer), document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer), document.removeEventListener("theme:quick-add:open", this.closeCartDrawer), document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect), document.querySelectorAll(eH.cartDrawer).length <= 1 && (window.theme.hasCartDrawer = !1), o()
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer()
        }
        openCartDrawerOnSelect(e) {
            let t = e.target.querySelector(eH.shopifySection) || e.target.closest(eH.shopifySection) || e.target;
            t === this.cartDrawerSection && this.openCartDrawer(!0)
        }
        closeCartDrawerOnDeselect() {
            this.cartDrawerIsOpen && this.closeCartDrawer()
        }
        openCartDrawer(e = !1) {
            !e && this.classList.contains(eM.duplicate) || (this.cartDrawerIsOpen = !0, this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", {
                detail: {
                    target: this
                },
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.classList.add(eM.open), this.observeAdditionalCheckoutButtons(), e_(this.cartDrawerInner).then(() => {
                B(this, {
                    elementToFocus: this.querySelector(eH.cartDrawerClose)
                })
            }))
        }
        closeCartDrawer() {
            this.classList.contains(eM.open) && (this.classList.add(eM.closing), this.classList.remove(eM.open), this.cartDrawerIsOpen = !1, document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", {
                bubbles: !0
            })), O(), D(), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), e_(this.cartDrawerInner).then(() => {
                this.classList.remove(eM.closing)
            }))
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer()
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", e => {
                e.preventDefault(), this.closeCartDrawer()
            }), this.addEventListener("keyup", e => {
                "Escape" === e.code && this.closeCartDrawer()
            })
        }
        onBodyClick(e) {
            e.target.hasAttribute(eB.drawerUnderlay) && this.closeCartDrawer()
        }
        observeAdditionalCheckoutButtons() {
            let e = this.querySelector(eH.additionalCheckoutButtons);
            if (e) {
                let t = new MutationObserver(() => {
                    B(this, {
                        elementToFocus: this.querySelector(eH.cartDrawerClose)
                    }), t.disconnect()
                });
                t.observe(e, {
                    subtree: !0,
                    childList: !0
                })
            }
        }
    }
    customElements.get("cart-drawer") || customElements.define("cart-drawer", eO);
    let eD = {
            collapsible: "[data-collapsible]",
            trigger: "[data-collapsible-trigger]",
            body: "[data-collapsible-body]",
            content: "[data-collapsible-content]"
        },
        e8 = {
            desktop: "desktop",
            disabled: "disabled",
            mobile: "mobile",
            open: "open",
            single: "single"
        };
    class e9 extends HTMLElement {
        constructor() {
            super(), this.collapsibles = this.querySelectorAll(eD.collapsible), this.single = this.hasAttribute(e8.single), this.toggle = this.toggle.bind(this)
        }
        connectedCallback() {
            this.toggle(), document.addEventListener("theme:resize:width", this.toggle), this.collapsibles.forEach(e => {
                let t = e.querySelector(eD.trigger),
                    i = e.querySelector(eD.body);
                t?.addEventListener("click", e => this.onCollapsibleClick(e)), i?.addEventListener("transitionend", t => {
                    t.target === i && ("true" == e.getAttribute(e8.open) && this.setBodyHeight(i, "auto"), "false" == e.getAttribute(e8.open) && (e.removeAttribute(e8.open), this.setBodyHeight(i, "")))
                })
            })
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.toggle)
        }
        toggle() {
            let e = b();
            this.collapsibles.forEach(t => {
                if (!t.hasAttribute(e8.desktop) && !t.hasAttribute(e8.mobile)) return;
                let i = t.hasAttribute(e8.desktop) ? t.getAttribute(e8.desktop) : "true",
                    s = t.hasAttribute(e8.mobile) ? t.getAttribute(e8.mobile) : "true",
                    r = t.querySelector(eD.body);
                e && "true" == i || !e && "true" == s ? (t.removeAttribute(e8.disabled), t.querySelector(eD.trigger).removeAttribute("tabindex"), t.removeAttribute(e8.open), this.setBodyHeight(r, "")) : (t.setAttribute(e8.disabled, ""), t.setAttribute("open", !0), t.querySelector(eD.trigger).setAttribute("tabindex", -1))
            })
        }
        open(e) {
            if ("true" == e.getAttribute("open")) return;
            let t = e.querySelector(eD.body),
                i = e.querySelector(eD.content);
            e.setAttribute("open", !0), this.setBodyHeight(t, i.offsetHeight)
        }
        close(e) {
            if (!e.hasAttribute("open")) return;
            let t = e.querySelector(eD.body),
                i = e.querySelector(eD.content);
            this.setBodyHeight(t, i.offsetHeight), e.setAttribute("open", !1), setTimeout(() => {
                requestAnimationFrame(() => {
                    this.setBodyHeight(t, 0)
                })
            })
        }
        setBodyHeight(e, t) {
            e.style.height = "auto" !== t && "" !== t ? `${t}px` : t
        }
        onCollapsibleClick(e) {
            e.preventDefault();
            let t = e.target,
                i = t.closest(eD.collapsible);
            this.single && this.collapsibles.forEach(e => {
                e.hasAttribute(e8.open) && e != i && requestAnimationFrame(() => {
                    this.close(e)
                })
            }), i.hasAttribute(e8.open) ? this.close(i) : this.open(i), i.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "accordion"
                }
            })), i.dispatchEvent(new CustomEvent("theme:collapsible:toggle", {
                bubbles: !0
            }))
        }
    }
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", e9);
    let eF = {
            details: "details",
            popdown: "[data-popdown]",
            popdownClose: "[data-popdown-close]",
            input: 'input:not([type="hidden"])'
        },
        eN = {
            popdownUnderlay: "data-popdown-underlay"
        },
        eW = {
            open: "is-open"
        };
    class eR extends HTMLElement {
        constructor() {
            super(), this.popdown = this.querySelector(eF.popdown), this.popdownContainer = this.querySelector(eF.details), this.popdownClose = this.querySelector(eF.popdownClose), this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this), this.detailsToggleCallback = this.detailsToggleCallback.bind(this), this.a11y = F
        }
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback), this.popdownContainer.addEventListener("keyup", e => "ESCAPE" === e.code.toUpperCase() && this.close()), this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback), this.popdownClose.addEventListener("click", this.close.bind(this))
        }
        detailsToggleCallback(e) {
            e.target.hasAttribute("open") && this.open()
        }
        popdownTransitionCallback(e) {
            e.target === this.popdown && (this.classList.contains(eW.open) ? "transform" === e.propertyName && this.a11y.trapFocus(this.popdown, {
                elementToFocus: this.popdown.querySelector(eF.input)
            }) : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()))
        }
        onBodyClick(e) {
            (!this.contains(e.target) || e.target.hasAttribute(eN.popdownUnderlay)) && this.close()
        }
        open() {
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), requestAnimationFrame(() => {
                this.classList.add(eW.open)
            })
        }
        close() {
            this.classList.remove(eW.open), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
    }
    customElements.define("header-search-popdown", eR), customElements.define("main-search", class e extends R {
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll('input[type="search"]'), this.setupEventListeners()
        }
        setupEventListeners() {
            let e = [];
            this.allSearchInputs.forEach(t => e.push(t.form)), this.input.addEventListener("focus", this.onInputFocus.bind(this)), e.length < 2 || (e.forEach(e => e.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach(e => e.addEventListener("input", this.onInput.bind(this))))
        }
        onFormReset(e) {
            super.onFormReset(e), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(e) {
            let t = e.target;
            this.keepInSync(t.value, t)
        }
        onInputFocus() {
            b() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(e, t) {
            this.allSearchInputs.forEach(i => {
                i !== t && (i.value = e)
            })
        }
    });
    let eV = {
            actions: "[data-actions]",
            content: "[data-content]",
            trigger: "[data-button]"
        },
        eU = {
            open: "is-open",
            enabled: "is-enabled"
        };
    class ez extends HTMLElement {
        constructor() {
            super(), this.initialHeight = this.getAttribute("data-height"), this.content = this.querySelector(eV.content), this.trigger = this.querySelector(eV.trigger), this.actions = this.querySelector(eV.actions), this.toggleActions = this.toggleActions.bind(this)
        }
        connectedCallback() {
            this.setHeight(this.initialHeight), this.trigger.addEventListener("click", () => {
                this.setHeight(this.content.offsetHeight), this.classList.add(eU.open)
            }), this.setHeight(this.initialHeight), this.toggleActions(), document.addEventListener("theme:resize", this.toggleActions), document.addEventListener("theme:collapsible:toggle", this.toggleActions)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions), document.removeEventListener("theme:collapsible:toggle", this.toggleActions)
        }
        setHeight(e) {
            this.style.setProperty("--height", `${e}px`)
        }
        toggleActions() {
            this.classList.toggle(eU.enabled, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight)
        }
    }
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", ez);
    let e0 = {
            templateAddresses: ".template-addresses",
            addressNewForm: "#AddressNewForm",
            btnNew: ".address-new-toggle",
            btnEdit: ".address-edit-toggle",
            btnDelete: ".address-delete",
            dataFormId: "data-form-id",
            dataConfirmMessage: "data-confirm-message",
            editAddress: "#EditAddress",
            addressCountryNew: "AddressCountryNew",
            addressProvinceNew: "AddressProvinceNew",
            addressProvinceContainerNew: "AddressProvinceContainerNew",
            addressCountryOption: ".address-country-option",
            addressCountry: "AddressCountry",
            addressProvince: "AddressProvince",
            addressProvinceContainer: "AddressProvinceContainer"
        },
        ej = {
            hidden: "hidden"
        },
        e3 = document.querySelector(e0.templateAddresses);
    e3 && new class e {
        constructor(e) {
            this.section = e, this.addressNewForm = this.section.querySelector(e0.addressNewForm), this.init()
        }
        init() {
            if (this.addressNewForm) {
                let e = this.section,
                    t = this.addressNewForm;
                this.customerAddresses();
                let i = e.querySelectorAll(e0.btnNew);
                i.length && i.forEach(e => {
                    e.addEventListener("click", function() {
                        t.classList.toggle(ej.hidden)
                    })
                });
                let s = e.querySelectorAll(e0.btnEdit);
                s.length && s.forEach(t => {
                    t.addEventListener("click", function() {
                        let t = this.getAttribute(e0.dataFormId);
                        e.querySelector(`${e0.editAddress}_${t}`).classList.toggle(ej.hidden)
                    })
                });
                let r = e.querySelectorAll(e0.btnDelete);
                r.length && r.forEach(e => {
                    e.addEventListener("click", function() {
                        let e = this.getAttribute(e0.dataFormId),
                            t = this.getAttribute(e0.dataConfirmMessage);
                        confirm(t) && Shopify.postLink(window.theme.routes.addresses_url + "/" + e, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    })
                })
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(e0.addressCountryNew, e0.addressProvinceNew, {
                hideElement: e0.addressProvinceContainerNew
            });
            let e = this.section.querySelectorAll(e0.addressCountryOption);
            e.forEach(e => {
                let t = e.getAttribute(e0.dataFormId),
                    i = `${e0.addressCountry}_${t}`,
                    s = `${e0.addressProvince}_${t}`,
                    r = `${e0.addressProvinceContainer}_${t}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: r
                })
            })
        }
    }(e3);
    let e2 = {
            accountTemplateLogged: ".customer-logged-in",
            account: ".account",
            accountSidebarMobile: ".account-sidebar--mobile"
        },
        eX = document.querySelector(e2.accountTemplateLogged);
    eX && new class e {
        constructor(e) {
            this.section = e, this.init()
        }
        init() {
            this.section.querySelector(e2.account) && this.accountMobileSidebar()
        }
        accountMobileSidebar() {
            this.section.querySelector(e2.accountSidebarMobile) && this.section.querySelector(e2.accountSidebarMobile).addEventListener("click", function() {
                let e = this.nextElementSibling;
                e && "UL" === e.tagName && e.classList.toggle("visible")
            })
        }
    }(eX);
    let e1 = {
            form: "[data-account-form]",
            showReset: "[data-show-reset]",
            hideReset: "[data-hide-reset]",
            recover: "[data-recover-password]",
            recoverSuccess: "[data-recover-success]",
            login: "[data-login-form]",
            recoverHash: "#recover",
            hideClass: "is-hidden"
        },
        eG = document.querySelector(e1.form);
    eG && new class e {
        constructor(e) {
            this.form = e, this.showButton = e.querySelector(e1.showReset), this.hideButton = e.querySelector(e1.hideReset), this.recover = e.querySelector(e1.recover), this.recoverSuccess = e.querySelector(e1.recoverSuccess), this.login = e.querySelector(e1.login), this.init()
        }
        init() {
            window.location.hash == e1.recoverHash || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(), this.showButton.addEventListener("click", (function(e) {
                e.preventDefault(), this.showRecoverPasswordForm()
            }).bind(this), !1), this.hideButton.addEventListener("click", (function(e) {
                e.preventDefault(), this.hideRecoverPasswordForm()
            }).bind(this), !1)
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(e1.hideClass), this.recover.classList.remove(e1.hideClass), window.location.hash = e1.recoverHash, !1
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(e1.hideClass), this.login.classList.remove(e1.hideClass), window.location.hash = "", !1
        }
    }(eG), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    let e4 = window.Shopify.theme.sections.registered,
        eJ = window.Shopify.theme.sections.instances,
        eY = {
            id: "data-section-id",
            type: "data-section-type"
        };
    class eQ {
        constructor(e = null, t = []) {
            this.type = e, this.components = function e(t) {
                if (void 0 !== t && "object" != typeof t || null === t) throw TypeError("Theme Sections: The components object provided is not a valid");
                return t
            }(t), this.callStack = {
                onLoad: [],
                onUnload: [],
                onSelect: [],
                onDeselect: [],
                onBlockSelect: [],
                onBlockDeselect: [],
                onReorder: []
            }, t.forEach(e => {
                for (let [t, i] of Object.entries(e)) {
                    let s = this.callStack[t];
                    Array.isArray(s) && "function" == typeof i ? s.push(i) : (console.warn(`Unregisted function: '${t}' in component: '${this.type}'`), console.warn(i))
                }
            })
        }
        getStack() {
            return this.callStack
        }
    }
    class e5 {
        constructor(e, t) {
            this.container = function e(t) {
                if (!(t instanceof Element)) throw TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(eY.id)) throw Error("Theme Sections: The section container provided does not have an id assigned to the " + eY.id + " attribute.");
                return t
            }(e), this.id = e.getAttribute(eY.id), this.type = t.type, this.callStack = t.getStack();
            try {
                this.onLoad()
            } catch (i) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(i)
            }
        }
        callFunctions(e, t = null) {
            this.callStack[e].forEach(e => {
                let i = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                t ? e.call(i, t) : e.call(i)
            })
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(e) {
            this.callFunctions("onSelect", e)
        }
        onDeselect(e) {
            this.callFunctions("onDeselect", e)
        }
        onBlockSelect(e) {
            this.callFunctions("onBlockSelect", e)
        }
        onBlockDeselect(e) {
            this.callFunctions("onBlockDeselect", e)
        }
        onReorder(e) {
            this.callFunctions("onReorder", e)
        }
    }

    function e6(e, t) {
        if ("string" != typeof e) throw TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== e4[e]) throw Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(t) || (t = [t]);
        let i = new eQ(e, t);
        return e4[e] = i, e4
    }

    function e7(e, t) {
        e = te(e), void 0 === t && (t = document.querySelectorAll("[" + eY.type + "]")), t = tt(t), e.forEach(function(e) {
            let i = e4[e];
            void 0 !== i && (t = t.filter(function(t) {
                var s;
                return s = t, !(eK(s).length > 0) && null !== t.getAttribute(eY.type) && (t.getAttribute(eY.type) !== e || (eJ.push(new e5(t, i)), !1))
            }))
        })
    }

    function eK(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
        return e instanceof Element || i instanceof Element ? tt(e).forEach(function(e) {
            t = t.concat(eJ.filter(function(t) {
                return t.container === e
            }))
        }) : ("string" == typeof e || "string" == typeof i) && te(e).forEach(function(e) {
            t = t.concat(eJ.filter(function(t) {
                return t.type === e
            }))
        }), t
    }

    function eZ(e) {
        for (var t, i = 0; i < eJ.length; i++)
            if (eJ[i].id === e) {
                t = eJ[i];
                break
            } return t
    }

    function te(e) {
        return "*" === e ? e = Object.keys(e4) : "string" == typeof e ? e = [e] : e.constructor === e5 ? e = [e.prototype.type] : Array.isArray(e) && e[0].constructor === e5 && (e = e.map(function(e) {
            return e.type
        })), e = e.map(function(e) {
            return e.toLowerCase()
        })
    }

    function tt(e) {
        return NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? e = Array.prototype.slice.call(e) : NodeList.prototype.isPrototypeOf(e) && 0 === e.length ? e = [] : null === e ? e = [] : !Array.isArray(e) && e instanceof Element && (e = [e]), e
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", function(e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + eY.id + '="' + t + '"]');
        null !== i && e7(i.getAttribute(eY.type), i)
    }), document.addEventListener("shopify:section:reorder", function(e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + eY.id + '="' + t + '"]');
        "object" == typeof eK(i)[0] && function e(t) {
            eK(t).forEach(function(e) {
                e.onReorder()
            })
        }(i)
    }), document.addEventListener("shopify:section:unload", function(e) {
        var t = e.detail.sectionId,
            i = e.target.querySelector("[" + eY.id + '="' + t + '"]');
        "object" == typeof eK(i)[0] && function e(t) {
            eK(t).forEach(function(e) {
                var t = eJ.map(function(e) {
                    return e.id
                }).indexOf(e.id);
                eJ.splice(t, 1), e.onUnload()
            })
        }(i)
    }), document.addEventListener("shopify:section:select", function(e) {
        var t = eZ(e.detail.sectionId);
        "object" == typeof t && t.onSelect(e)
    }), document.addEventListener("shopify:section:deselect", function(e) {
        var t = eZ(e.detail.sectionId);
        "object" == typeof t && t.onDeselect(e)
    }), document.addEventListener("shopify:block:select", function(e) {
        var t = eZ(e.detail.sectionId);
        "object" == typeof t && t.onBlockSelect(e)
    }), document.addEventListener("shopify:block:deselect", function(e) {
        var t = eZ(e.detail.sectionId);
        "object" == typeof t && t.onBlockDeselect(e)
    }));
    let ti = {
            tooltip: "data-tooltip",
            tooltipStopMouseEnter: "data-tooltip-stop-mouseenter"
        },
        ts = {
            tooltipDefault: "tooltip-default",
            visible: "is-visible",
            hiding: "is-hiding"
        },
        tr = {};
    class to {
        constructor(e, t = {}) {
            if (this.tooltip = e, !this.tooltip.hasAttribute(ti.tooltip)) return;
            this.label = this.tooltip.getAttribute(ti.tooltip), this.class = t.class || ts.tooltipDefault, this.transitionSpeed = t.transitionSpeed || 200, this.hideTransitionTimeout = 0, this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = e => eA(this.removePin(e), 50), this.removePinMouseEvent = e => this.removePin(e, !0, !0), this.init()
        }
        init() {
            if (!document.querySelector(`.${this.class}`)) {
                let e = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                    t = document.createElement("div");
                t.className = this.class, t.innerHTML = e, document.body.appendChild(t)
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent)
        }
        addPin(e = !1) {
            let t = document.querySelector(`.${this.class}`);
            if (this.label && t && (e && !this.tooltip.hasAttribute(ti.tooltipStopMouseEnter) || !e)) {
                let i = t.querySelector(`.${this.class}__arrow`),
                    s = t.querySelector(`.${this.class}__inner`),
                    r = t.querySelector(`.${this.class}__text`);
                r.innerHTML = this.label;
                let o = s.offsetWidth,
                    a = this.tooltip.getBoundingClientRect(),
                    n = a.top,
                    l = a.width,
                    d = a.height,
                    c = n + d + window.scrollY,
                    h = a.left - o / 2 + l / 2,
                    u = h + o,
                    p = u - g() + 24;
                p > 0 && (h -= p), h < 0 && (h = 0), i.style.left = `${a.left+l/2}px`, t.style.setProperty("--tooltip-top", `${c}px`), s.style.transform = `translateX(${h}px)`, t.classList.remove(ts.hiding), t.classList.add(ts.visible), document.addEventListener("theme:scroll", this.removePinEvent)
            }
        }
        removePin(e, t = !1, i = !1) {
            let s = document.querySelector(`.${this.class}`),
                r = s.classList.contains(ts.visible);
            s && (t && !this.tooltip.hasAttribute(ti.tooltipStopMouseEnter) || !t) && (r && (i || e.detail.hideTransition) && (s.classList.add(ts.hiding), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout(() => {
                s.classList.remove(ts.hiding)
            }, this.transitionSpeed)), s.classList.remove(ts.visible), document.removeEventListener("theme:scroll", this.removePinEvent))
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
        }
    }
    let ta = {
        onLoad() {
            tr[this.id] = [];
            let e = this.container.querySelectorAll(`[${ti.tooltip}]`);
            e.forEach(e => {
                tr[this.id].push(new to(e))
            })
        },
        onUnload: function() {
            tr[this.id].forEach(e => {
                "function" == typeof e.unload && e.unload()
            })
        }
    };
    var tn = {};
    let tl = {
        onLoad() {
            tn[this.id] = [];
            let e = this.container.querySelectorAll("[data-parallax-wrapper]");
            e.forEach(e => {
                let i = e.querySelector("[data-parallax-img]");
                tn[this.id].push(new t(i, {
                    center: !0,
                    round: !0,
                    frame: e
                }))
            }), window.addEventListener("load", () => {
                tn[this.id].forEach(e => {
                    "function" == typeof e.refresh && e.refresh()
                })
            })
        },
        onUnload: function() {
            tn[this.id].forEach(e => {
                "function" == typeof e.destroy && e.destroy()
            })
        }
    };
    e6("article", [ta, tl]);
    let td = {
            aos: "[data-aos]",
            collectionImage: ".collection-item__image",
            columnImage: "[data-column-image]",
            flickityNextArrow: ".flickity-button.next",
            flickityPrevArrow: ".flickity-button.previous",
            link: "a:not(.btn)",
            productItemImage: ".product-item__image",
            slide: "[data-slide]",
            slideValue: "data-slide",
            slider: "[data-slider]",
            sliderThumb: "[data-slider-thumb]"
        },
        tc = {
            arrowPositionMiddle: "data-arrow-position-middle",
            slideIndex: "data-slide-index",
            sliderOptions: "data-options",
            slideTextColor: "data-slide-text-color"
        },
        th = {
            aosAnimate: "aos-animate",
            desktop: "desktop",
            focused: "is-focused",
            flickityEnabled: "flickity-enabled",
            heroContentTransparent: "hero__content--transparent",
            initialized: "is-initialized",
            isLoading: "is-loading",
            isSelected: "is-selected",
            mobile: "mobile",
            singleSlide: "single-slide",
            sliderInitialized: "js-slider--initialized"
        },
        tu = {};
    class tp {
        constructor(e, t = null) {
            if (this.container = e, this.slideshow = t || this.container.querySelector(td.slider), !this.slideshow || (this.slideshowSlides = this.slideshow.querySelectorAll(td.slide), this.slideshowSlides.length <= 1)) return;
            this.sliderThumbs = this.container.querySelectorAll(td.sliderThumb), this.multipleSlides = this.slideshow.hasAttribute(tc.slidesLargeDesktop), this.slideshow.hasAttribute(tc.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(tc.sliderOptions)))), this.flkty = null, this.init()
        }
        init() {
            this.slideshow.classList.add(th.isLoading);
            let e = td.slide,
                t = b(),
                r = `${td.slide}:not(.${th.mobile})`,
                o = `${td.slide}:not(.${th.desktop})`,
                a = this.slideshow.querySelectorAll(o).length || this.slideshow.querySelectorAll(r).length;
            a && (e = t ? r : o), this.slideshow.querySelectorAll(e).length <= 1 && (this.slideshow.classList.add(th.singleSlide), this.slideshow.classList.remove(th.isLoading)), this.sliderOptions = {
                cellSelector: e,
                contain: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                ...this.customOptions,
                on: {
                    ready: () => {
                        requestAnimationFrame(() => {
                            this.slideshow.classList.add(th.initialized), this.slideshow.classList.remove(th.isLoading), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", {
                                bubbles: !0,
                                detail: {
                                    slider: this
                                }
                            }))
                        }), this.slideActions(), this.sliderOptions.prevNextButtons && this.positionArrows()
                    },
                    change: e => {
                        let t = this.slideshowSlides[e];
                        if (!t || this.sliderOptions.groupCells) return;
                        let i = t.querySelectorAll(td.aos);
                        i.length && i.forEach(e => {
                            e.classList.remove(th.aosAnimate), requestAnimationFrame(() => {
                                setTimeout(() => {
                                    e.classList.add(th.aosAnimate)
                                }, 0)
                            })
                        })
                    },
                    resize: () => {
                        this.sliderOptions.prevNextButtons && this.positionArrows()
                    }
                }
            }, this.sliderOptions.fade && (this.flkty = new s(this.slideshow, this.sliderOptions)), this.sliderOptions.fade || (this.flkty = new i(this.slideshow, this.sliderOptions)), this.flkty.on("change", () => this.slideActions(!0)), this.sliderThumbs.length && this.sliderThumbs.forEach(e => {
                e.addEventListener("click", t => {
                    t.preventDefault();
                    let i = [...e.parentElement.children].indexOf(e);
                    this.flkty.select(i)
                })
            }), this.flkty && this.flkty.isActive || this.slideshow.classList.remove(th.isLoading)
        }
        slideActions(e = !1) {
            let t = this.slideshow.querySelector(`.${th.isSelected}`);
            if (!t) return;
            let i = t.hasAttribute(tc.slideTextColor) ? t.getAttribute(tc.slideTextColor) : "",
                s = t.querySelector(td.link),
                r = this.slideshow.querySelectorAll(`${td.slide} a, ${td.slide} button`);
            if (document.body.classList.contains(th.focused) && s && this.sliderOptions.groupCells && e && s.focus(), r.length && r.forEach(e => {
                    let t = e.closest(td.slide);
                    if (t) {
                        let i = t.classList.contains(th.isSelected) ? 0 : -1;
                        e.setAttribute("tabindex", i)
                    }
                }), "rgba(0,0,0,0)" !== i && "" !== i && this.slideshow.style.setProperty("--text", i), this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && t.hasAttribute(tc.slideIndex)) {
                let o = parseInt(t.getAttribute(tc.slideIndex)),
                    a = this.container.querySelector(`${td.sliderThumb}.${th.isSelected}`);
                a && a.classList.remove(th.isSelected), this.sliderThumbs[o].classList.add(th.isSelected)
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(tc.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                let e = this.slideshow.querySelector(td.collectionImage) || this.slideshow.querySelector(td.productItemImage) || this.slideshow.querySelector(td.columnImage);
                e && (this.slideshow.querySelector(td.flickityPrevArrow).style.top = e.clientHeight / 2 + "px", this.slideshow.querySelector(td.flickityNextArrow).style.top = e.clientHeight / 2 + "px")
            }
        }
        onUnload() {
            this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        onBlockSelect(e) {
            if (!this.slideshow) return;
            let t = this.slideshow.querySelector(`[${td.slideValue}="${e.detail.blockId}"]`);
            if (!t) return;
            let i = parseInt(t.getAttribute(tc.slideIndex));
            this.multipleSlides && !this.slideshow.classList.contains(th.sliderInitialized) && (i = 0), this.slideshow.classList.add(th.isSelected), this.flkty && this.slideshow.classList.contains(th.flickityEnabled) && (this.flkty.selectCell(i), this.flkty.stopPlayer())
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(th.isSelected), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer())
        }
    }
    let tm = {
        onLoad() {
            tu[this.id] = [];
            let e = this.container.querySelectorAll(td.slider);
            e.forEach(e => {
                tu[this.id].push(new tp(this.container, e))
            })
        },
        onUnload() {
            tu[this.id].forEach(e => {
                "function" == typeof e.onUnload && e.onUnload()
            })
        },
        onBlockSelect(e) {
            tu[this.id].forEach(t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            })
        },
        onBlockDeselect(e) {
            tu[this.id].forEach(t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            })
        }
    };
    e6("blog-section", [tm]), e6("hero", tl), e6("double", tm);
    let tg = e => {
        let {
            stickyHeaderHeight: t
        } = l();
        window.scrollTo({
            top: e + window.scrollY - t,
            left: 0,
            behavior: "smooth"
        })
    };
    class tv {
        constructor(e, t, i = 7) {
            let s = new Date,
                r = new Date;
            r.setTime(s.getTime() + 864e5 * i), this.configuration = {
                expires: r.toGMTString(),
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, this.name = e, this.value = t
        }
        write() {
            let e = -1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find(e => e.startsWith(this.name));
            (e || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        read() {
            if (!(-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find(e => e.startsWith(this.name)))) return !1;
            {
                let e = document.cookie.split("; ").find(e => e.startsWith(this.name)).split("=")[1];
                return e
            }
        }
        destroy() {
            document.cookie.split("; ").find(e => e.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
        }
    }
    let tb = {
            newsletterForm: "[data-newsletter-form]",
            newsletterHeading: "[data-newsletter-heading]",
            newsletterPopup: "[data-newsletter]"
        },
        ty = {
            success: "has-success",
            error: "has-error",
            hidden: "hidden"
        },
        tf = {};
    class tS {
        constructor(e) {
            this.sessionStorage = window.sessionStorage, this.newsletter = e, this.popup = this.newsletter.closest(tb.newsletterPopup), this.popup && (this.cookie = new tv(this.popup.getAttribute("data-cookie-name"), "user_has_closed", null)), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = e => this.newsletterSubmitEvent(e), this.isChallengePage || this.init()
        }
        init() {
            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
        }
        newsletterSubmitEvent(e) {
            this.stopSubmit && (e.preventDefault(), e.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
        }
        checkForChallengePage() {
            this.isChallengePage = "/challenge" === window.location.pathname
        }
        writeStorage() {
            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
        }
        readStorage() {
            this.formID = this.sessionStorage.getItem("newsletter_form_id")
        }
        removeStorage() {
            this.sessionStorage.removeItem("newsletter_form_id")
        }
        showMessage() {
            if (this.readStorage(), this.newsletter.id === this.formID) {
                let e = document.getElementById(this.formID),
                    t = e.parentElement.querySelector(tb.newsletterHeading),
                    i = -1 !== window.location.search.indexOf("?customer_posted=true"),
                    s = -1 !== window.location.search.indexOf("accepts_marketing");
                i ? (e.classList.remove(ty.error), e.classList.add(ty.success), t && (t.classList.add(ty.hidden), e.classList.remove(ty.hidden)), this.popup && this.cookie.write()) : s && (e.classList.remove(ty.success), e.classList.add(ty.error), t && (t.classList.add(ty.hidden), e.classList.remove(ty.hidden))), (i || s) && window.addEventListener("load", () => {
                    this.scrollToForm(e)
                })
            }
        }
        scrollToForm(e) {
            let t = e.getBoundingClientRect(),
                i = t.top >= 0 && t.left >= 0 && t.bottom <= v() && t.right <= g();
            i || setTimeout(() => {
                tg(e.getBoundingClientRect().top)
            }, 500)
        }
        unload() {
            this.newsletter.removeEventListener("submit", this.newsletterSubmit)
        }
    }
    let tw = {
        onLoad() {
            tf[this.id] = [];
            let e = this.container.querySelectorAll(tb.newsletterForm);
            e.forEach(e => {
                tf[this.id].push(new tS(e))
            })
        },
        onUnload() {
            tf[this.id].forEach(e => {
                "function" == typeof e.unload && e.unload()
            })
        }
    };
    e6("footer", [tl, tw]);
    let tL = {
            collectionSidebar: "[data-collection-sidebar]",
            collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
            collectionSidebarCloseButton: "[data-collection-sidebar-close]",
            groupTagsButton: "[data-aria-toggle]",
            animation: "[data-animation]"
        },
        tE = {
            animated: "drawer--animated",
            hiding: "is-hiding",
            expanded: "expanded",
            noMobileAnimation: "no-mobile-animation",
            focused: "is-focused"
        },
        tk = {};
    class tA {
        constructor(e) {
            this.container = e.container, this.collectionSidebar = this.container.querySelector(tL.collectionSidebar), this.groupTagsButton = this.container.querySelector(tL.groupTagsButton), this.a11y = F, this.groupTagsButtonClickEvent = e => this.groupTagsButtonClick(e), this.sidebarResizeEvent = () => this.toggleSidebarSlider(), this.collectionSidebarCloseEvent = e => this.collectionSidebarClose(e), this.init()
        }
        init() {
            if (null !== this.groupTagsButton) {
                document.addEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent), this.collectionSidebar && setTimeout(() => {
                    this.collectionSidebar.classList.remove(tE.noMobileAnimation)
                }, 1e3);
                let e = new MutationObserver(e => {
                    for (let t of e)
                        if ("attributes" === t.type) {
                            let i = "true" == t.target.getAttribute("aria-expanded");
                            i && this.showSidebarCallback()
                        }
                });
                e.observe(this.groupTagsButton, {
                    attributes: !0,
                    childList: !1,
                    subtree: !1
                })
            }
            this.container.addEventListener("keyup", (function(e) {
                "Escape" === e.code && this.hideSidebar()
            }).bind(this)), this.collectionSidebar && (this.collectionSidebar.addEventListener("transitionend", () => {
                this.collectionSidebar.classList.contains(tE.expanded) || this.collectionSidebar.classList.remove(tE.animated)
            }), this.toggleSidebarSlider(), this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent))
        }
        showSidebarCallback() {
            let e = this.container.querySelector(tL.collectionSidebarSlideOut),
                t = document.documentElement.hasAttribute("data-scroll-locked"),
                i = y();
            this.collectionSidebar.classList.add(tE.animated), null === e && !i && t && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))), (i || null !== e) && (e && this.a11y.trapFocus(this.collectionSidebar, {
                elementToFocus: this.collectionSidebar.querySelector(tL.collectionSidebarCloseButton)
            }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })))
        }
        hideSidebar() {
            let e = this.container.querySelector(tL.collectionSidebarSlideOut),
                t = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"), this.collectionSidebar.classList.remove(tE.expanded), e && this.a11y.removeTrapFocus(), t && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        toggleSidebarSlider() {
            y() ? this.hideSidebar() : this.collectionSidebar.classList.contains(tE.expanded) && this.showSidebarCallback()
        }
        collectionSidebarClose(e) {
            e.preventDefault(), this.hideSidebar(), document.body.classList.contains(tE.focused) && this.groupTagsButton && this.groupTagsButton.focus()
        }
        groupTagsButtonClick() {
            let e = document.documentElement.hasAttribute("data-scroll-locked");
            e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        onUnload() {
            null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)), this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent)
        }
    }
    e6("collection", [tm, tl, {
        onLoad() {
            tk[this.id] = new tA(this)
        },
        onUnload() {
            tk[this.id].onUnload()
        }
    }, ta]);
    let t$ = {
            frame: "[data-ticker-frame]",
            scale: "[data-ticker-scale]",
            text: "[data-ticker-text]",
            clone: "data-clone"
        },
        tC = {
            autoplay: "autoplay",
            speed: "speed"
        },
        tT = {
            animation: "ticker--animated",
            unloaded: "ticker--unloaded",
            comparitor: "ticker__comparitor"
        },
        tq = {
            speed: 1.63,
            space: 100
        };
    class tP extends HTMLElement {
        constructor() {
            super(), this.autoplay = this.hasAttribute(tC.autoplay), this.scale = this.querySelector(t$.scale), this.text = this.querySelector(t$.text), this.speed = this.hasAttribute(tC.speed) ? this.getAttribute(tC.speed) : tq.speed, this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(tT.comparitor), this.appendChild(this.comparitor), this.scale.classList.remove(tT.unloaded), this.checkWidthEvent = this.checkWidth.bind(this)
        }
        connectedCallback() {
            this.checkWidth(), this.addEventListener("theme:ticker:refresh", m(() => this.checkWidthEvent(), 50)), screen.orientation.addEventListener("change", this.checkWidthEvent), document.addEventListener("theme:resize:width", this.checkWidthEvent)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkWidthEvent)
        }
        checkWidth() {
            this.text = this.querySelector(t$.text);
            let e = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
                t = this.clientWidth - e < this.comparitor.clientWidth;
            if (t || this.autoplay) {
                this.text.classList.remove(tT.animation);
                let i = this.scale.querySelectorAll(`[${t$.clone}]`),
                    s = this.autoplay ? parseInt((window.innerWidth - e) / this.text.clientWidth) : 2;
                if (i?.forEach(e => {
                        e.remove()
                    }), this.autoplay || t)
                    for (let r = 0; r <= s; r++) {
                        let o = this.text.cloneNode(!0);
                        o.setAttribute(t$.clone, ""), this.scale.appendChild(o)
                    }
                let a = (this.text.clientWidth / tq.space * Number(this.speed)).toFixed(2);
                this.scale.style.removeProperty("--animation-time"), this.scale.style.setProperty("--animation-time", `${a}s`), this.scale.querySelectorAll(t$.text)?.forEach(e => {
                    e.classList.add(tT.animation)
                })
            } else {
                this.text.classList.add(tT.animation);
                let n = this.scale.querySelectorAll(`[${t$.clone}]`);
                n.forEach(e => {
                    e.parentNode.removeChild(e)
                }), this.text.classList.remove(tT.animation)
            }
        }
    }
    let tx = {
            marquee: ".announcement__bar-holder--marquee",
            slide: "[data-slide]",
            slider: "[data-slider]",
            ticker: "ticker-bar",
            tickerSlide: ".announcement__slide"
        },
        tI = {
            hidden: "hidden"
        };
    class t_ extends HTMLElement {
        constructor() {
            super(), this.slider = this.querySelector(tx.slider), this.enableSlider = b(), this.slidesCount = this.querySelectorAll(tx.tickerSlide).length, this.initSliderEvent = e => this.initSlider(e)
        }
        connectedCallback() {
            this.slider && this.initSliders(), this.addEventListener("theme:block:select", e => {
                this.onBlockSelect(e)
            }), this.addEventListener("theme:block:deselect", e => {
                this.onBlockDeselect(e)
            }), this.addEventListener("theme:countdown:hide", e => {
                if (window.Shopify.designMode) return;
                let t = e.target.closest(tx.marquee);
                if (1 === this.slidesCount) {
                    let i = this.querySelector(tx.ticker);
                    i.style.display = "none"
                }
                if (t) {
                    let s = e.target.closest(tx.tickerSlide);
                    this.removeTickerText(s)
                } else {
                    let r = e.target.closest(tx.slide);
                    this.removeSlide(r)
                }
            }), this.addEventListener("theme:countdown:expire", () => {
                this.querySelectorAll(tx.ticker)?.forEach(e => {
                    e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                })
            }), document.dispatchEvent(new CustomEvent("theme:announcement:init", {
                bubbles: !0
            }))
        }
        initSliders() {
            this.initSlider(), document.addEventListener("theme:resize:width", this.initSliderEvent), this.addEventListener("theme:slider:loaded", () => {
                this.querySelectorAll(tx.tickerBar)?.forEach(e => {
                    e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                })
            })
        }
        initSlider() {
            let e = b(),
                t = !e;
            (e && this.enableSlider || t && !this.enableSlider) && (this.slider.flkty?.destroy(), e && this.enableSlider ? this.enableSlider = !1 : t && !this.enableSlider && (this.enableSlider = !0), this.slider = new tp(this, this.querySelector(tx.slider)), this.slider.flkty?.reposition())
        }
        removeSlide(e) {
            this.slider.flkty?.remove(e), 0 === this.slider.flkty?.cells.length && this.section.classList.add(tI.hidden)
        }
        removeTickerText(e) {
            let t = e.closest(tx.ticker);
            e.remove(), t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
        }
        onBlockSelect(e) {
            this.slider && this.slider.onBlockSelect(e)
        }
        onBlockDeselect(e) {
            this.slider && this.slider.onBlockDeselect(e)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent), document.removeEventListener("theme:resize:width", this.tickerResizeEvent), this.removeEventListener("theme:block:select", e => {
                this.onBlockSelect(e)
            }), this.removeEventListener("theme:block:deselect", e => {
                this.onBlockDeselect(e)
            })
        }
    }
    customElements.get("announcement-bar") || customElements.define("announcement-bar", t_), customElements.get("ticker-bar") || customElements.define("ticker-bar", tP);
    let tM = {
            body: "body",
            drawerWrappper: "[data-drawer]",
            drawerInner: "[data-drawer-inner]",
            underlay: "[data-drawer-underlay]",
            stagger: "[data-stagger-animation]",
            wrapper: "[data-header-wrapper]",
            drawerToggle: "data-drawer-toggle",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
        },
        tH = {
            animated: "drawer--animated",
            open: "is-open",
            closing: "is-closing",
            isFocused: "is-focused",
            headerStuck: "js__header__stuck"
        },
        tB = {};
    class tO {
        constructor(e) {
            this.isAnimating = !1, this.drawer = e, this.drawerWrapper = this.drawer.closest(tM.drawerWrappper), this.drawerInner = this.drawer.querySelector(tM.drawerInner), this.underlay = this.drawer.querySelector(tM.underlay), this.wrapper = this.drawer.closest(tM.wrapper), this.key = this.drawer.dataset.drawer, this.btnSelector = `[${tM.drawerToggle}='${this.key}']`, this.buttons = document.querySelectorAll(this.btnSelector), this.staggers = this.drawer.querySelectorAll(tM.stagger), this.body = document.querySelector(tM.body), this.showDrawer = this.showDrawer.bind(this), this.hideDrawer = this.hideDrawer.bind(this), this.connectToggle(), this.connectDrawer(), this.closers()
        }
        connectToggle() {
            this.buttons.forEach(e => {
                e.addEventListener("click", () => {
                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                        bubbles: !1
                    }))
                })
            })
        }
        connectDrawer() {
            this.drawer.addEventListener("theme:drawer:toggle", () => {
                this.drawer.classList.contains(tH.open) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                    bubbles: !0
                })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                    bubbles: !0
                }))
            }), document.addEventListener("theme:cart-drawer:open", this.hideDrawer), document.addEventListener("theme:drawer:close", this.hideDrawer), document.addEventListener("theme:drawer:open", this.showDrawer)
        }
        closers() {
            this.wrapper.addEventListener("keyup", e => {
                "Escape" === e.code && this.hideDrawer()
            }), this.underlay.addEventListener("click", () => {
                this.hideDrawer()
            })
        }
        showDrawer() {
            !this.isAnimating && (this.isAnimating = !0, this.buttons.forEach(e => {
                e.setAttribute("aria-expanded", !0)
            }), this.drawer.classList.add(tH.open, tH.animated), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.drawerInner && this.drawerInner.querySelector(this.btnSelector) && (O(), e_(this.drawerInner).then(() => {
                this.drawer.querySelector(tM.focusable).focus(), this.isAnimating = !1, B(this.drawerInner, {
                    elementToFocus: this.drawerInner.querySelector(this.btnSelector)
                })
            })))
        }
        hideDrawer() {
            this.drawer.classList.contains(tH.open) && !this.isAnimating && (this.isAnimating = !0, this.drawer.classList.add(tH.closing), this.drawer.classList.remove(tH.open), O(), this.body.classList.contains(tH.isFocused) && this.buttons.length && this.buttons[0].focus(), this.buttons.forEach(e => {
                e.setAttribute("aria-expanded", !1)
            }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), e_(this.drawerInner).then(() => {
                this.drawer.classList.remove(tH.closing, tH.animated), this.isAnimating = !1, document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                    bubbles: !1
                }))
            }))
        }
        onUnload() {
            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer)
        }
    }
    let tD = {
            pageHeader: ".page-header"
        },
        t8 = {
            stuck: "js__header__stuck",
            sticky: "has-header-sticky",
            headerGroup: "shopify-section-group-header-group"
        },
        t9 = {
            stickyHeader: "data-header-sticky",
            scrollLock: "data-scroll-locked"
        },
        tF = {};
    class tN {
        constructor(e) {
            if (this.wrapper = e, this.sticks = this.wrapper.hasAttribute(t9.stickyHeader), document.body.classList.toggle(t8.sticky, this.sticks), !this.sticks) return;
            this.isStuck = !1, this.cls = this.wrapper.classList, this.headerOffset = document.querySelector(tD.pageHeader)?.offsetTop, this.updateHeaderOffset = this.updateHeaderOffset.bind(this), this.scrollEvent = e => this.onScroll(e), this.listen(), this.stickOnLoad()
        }
        listen() {
            document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset)
        }
        onScroll(e) {
            e.detail.down ? !this.isStuck && e.detail.position > this.headerOffset && this.stickSimple() : e.detail.position <= this.headerOffset && this.unstickSimple()
        }
        updateHeaderOffset(e) {
            e.target.classList.contains(t8.headerGroup) && setTimeout(() => {
                this.headerOffset = document.querySelector(tD.pageHeader)?.offsetTop
            })
        }
        stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple()
        }
        stickSimple() {
            this.cls.add(t8.stuck), this.isStuck = !0
        }
        unstickSimple() {
            document.documentElement.hasAttribute(t9.scrollLock) || (this.cls.remove(t8.stuck), this.isStuck = !1)
        }
        unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("shopify:section:load", this.updateHeaderOffset), document.removeEventListener("shopify:section:unload", this.updateHeaderOffset)
        }
    }
    let tW = {
            disclosureToggle: "data-hover-disclosure-toggle",
            disclosureWrappper: "[data-hover-disclosure]",
            link: "[data-top-link]",
            wrapper: "[data-header-wrapper]",
            stagger: "[data-stagger]",
            staggerPair: "[data-stagger-first]",
            staggerAfter: "[data-stagger-second]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        },
        tR = {
            isVisible: "is-visible",
            meganavVisible: "meganav--visible",
            meganavIsTransitioning: "meganav--is-transitioning"
        },
        tV = {},
        tU = {};
    class tz {
        constructor(e) {
            this.disclosure = e, this.wrapper = e.closest(tW.wrapper), this.key = this.disclosure.id, this.trigger = document.querySelector(`[${tW.disclosureToggle}='${this.key}']`), this.link = this.trigger.querySelector(tW.link), this.grandparent = this.trigger.classList.contains("grandparent"), this.transitionTimeout = 0, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
        }
        onBlockSelect(e) {
            this.disclosure.contains(e.target) && this.showDisclosure(e)
        }
        onBlockDeselect(e) {
            this.disclosure.contains(e.target) && this.hideDisclosure()
        }
        showDisclosure(e) {
            e && e.type && "mouseenter" === e.type && this.wrapper.classList.add(tR.meganavIsTransitioning), this.grandparent ? this.wrapper.classList.add(tR.meganavVisible) : this.wrapper.classList.remove(tR.meganavVisible), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(tR.isVisible), this.disclosure.classList.add(tR.isVisible), this.transitionTimeout && clearTimeout(this.transitionTimeout), this.transitionTimeout = setTimeout(() => {
                this.wrapper.classList.remove(tR.meganavIsTransitioning)
            }, 200)
        }
        hideDisclosure() {
            this.disclosure.classList.remove(tR.isVisible), this.trigger.classList.remove(tR.isVisible), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(tR.meganavVisible, tR.meganavIsTransitioning)
        }
        staggerChildAnimations() {
            let e = this.disclosure.querySelectorAll(tW.stagger);
            e.forEach((e, t) => {
                e.style.transitionDelay = `${50*t+10}ms`
            });
            let t = this.disclosure.querySelectorAll(tW.staggerPair);
            t.forEach((e, t) => {
                let i = 100 * t;
                e.style.transitionDelay = `${i}ms`, e.parentElement.querySelectorAll(tW.staggerAfter).forEach((e, t) => {
                    e.style.transitionDelay = `${i+20*(t+1)}ms`
                })
            })
        }
        handleTablets() {
            this.trigger.addEventListener("touchstart", (function(e) {
                let t = this.disclosure.classList.contains(tR.isVisible);
                t || (e.preventDefault(), this.showDisclosure(e))
            }).bind(this), {
                passive: !0
            })
        }
        connectHoverToggle() {
            this.trigger.addEventListener("mouseenter", e => this.showDisclosure(e)), this.link.addEventListener("focus", e => this.showDisclosure(e)), this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()), this.trigger.addEventListener("focusout", e => {
                let t = this.trigger.contains(e.relatedTarget);
                t || this.hideDisclosure()
            }), this.disclosure.addEventListener("keyup", e => {
                "Escape" === e.code && this.hideDisclosure()
            })
        }
    }
    let t0 = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            dataAnimates: "data-animates",
            children: `:scope > [data-animates],:scope > * > [data-animates],:scope > * > * >[data-animates],:scope > * > .sliderule-grid  > *`
        },
        tj = {
            isVisible: "is-visible",
            isHiding: "is-hiding",
            isHidden: "is-hidden",
            focused: "is-focused",
            scrolling: "is-scrolling"
        },
        t3 = {};
    class t2 {
        constructor(e) {
            this.sliderule = e, this.key = this.sliderule.id;
            let t = `[${t0.slideruleOpen}='${this.key}']`;
            this.exitSelector = `[${t0.slideruleClose}='${this.key}']`, this.trigger = document.querySelector(t), this.exit = document.querySelectorAll(this.exitSelector), this.pane = document.querySelector(`[${t0.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(t0.children), this.drawerContent = document.querySelector(t0.drawerContent), this.cachedButton = null, this.accessibility = F, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.closeSliderule = this.closeSliderule.bind(this), this.clickEvents(), this.keyboardEvents(), document.addEventListener("theme:sliderule:close", this.closeSliderule)
        }
        clickEvents() {
            this.trigger.addEventListener("click", () => {
                this.cachedButton = this.trigger, this.showSliderule()
            }), this.exit.forEach(e => {
                e.addEventListener("click", () => {
                    this.hideSliderule()
                })
            })
        }
        keyboardEvents() {
            this.sliderule.addEventListener("keyup", e => {
                e.stopPropagation(), "Escape" === e.code && this.hideSliderule()
            })
        }
        trapFocusSliderule(e = !0) {
            let t = e ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
            this.accessibility.removeTrapFocus(), t && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, {
                elementToFocus: document.body.classList.contains(tj.focused) ? t : null
            })
        }
        hideSliderule(e = !1) {
            let t = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute(t0.sliderulePane, t), this.pane.classList.add(tj.isHiding), this.sliderule.classList.add(tj.isHiding);
            let i = e ? `[${t0.dataAnimates}].${tj.isHidden}` : `[${t0.dataAnimates}="${t}"]`,
                s = this.pane.querySelectorAll(i);
            s.length && s.forEach(e => {
                e.classList.remove(tj.isHidden)
            });
            let r = e ? this.pane.querySelectorAll(`.${tj.isVisible}, .${tj.isHiding}`) : this.children;
            r.forEach((i, s) => {
                let o = r.length - 1 == s;
                i.classList.remove(tj.isVisible), e && (i.classList.remove(tj.isHiding), this.pane.classList.remove(tj.isHiding));
                let a = () => {
                    parseInt(this.pane.getAttribute(t0.sliderulePane)) === t && this.sliderule.classList.remove(tj.isVisible), this.sliderule.classList.remove(tj.isHiding), this.pane.classList.remove(tj.isHiding), o && (this.accessibility.removeTrapFocus(), e || this.trapFocusSliderule(!1)), i.removeEventListener("animationend", a)
                };
                window.theme.settings.enableAnimations ? i.addEventListener("animationend", a) : a()
            })
        }
        showSliderule() {
            let e = null,
                t = this.sliderule.closest(`.${tj.isVisible}`),
                i = this.pane;
            t && (i = t), i.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            }), i.classList.add(tj.scrolling);
            let s = () => {
                i.scrollTop <= 0 ? (i.classList.remove(tj.scrolling), e && cancelAnimationFrame(e)) : e = requestAnimationFrame(s)
            };
            e = requestAnimationFrame(s), this.sliderule.classList.add(tj.isVisible);
            let r = parseInt(this.pane.dataset.sliderulePane, 10);
            this.pane.setAttribute(t0.sliderulePane, r + 1);
            let o = this.pane.querySelectorAll(`[${t0.dataAnimates}="${r}"]`);
            o.length && o.forEach((e, t) => {
                let i = o.length - 1 == t;
                e.classList.add(tj.isHiding);
                let s = () => {
                    e.classList.remove(tj.isHiding), parseInt(this.pane.getAttribute(t0.sliderulePane)) !== r && e.classList.add(tj.isHidden), i && this.trapFocusSliderule(), e.removeEventListener("animationend", s)
                };
                window.theme.settings.enableAnimations ? e.addEventListener("animationend", s) : s()
            })
        }
        closeSliderule() {
            this.pane && this.pane.hasAttribute(t0.sliderulePane) && parseInt(this.pane.getAttribute(t0.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(t0.sliderulePane)) > 0 && this.pane.setAttribute(t0.sliderulePane, 0))
        }
        onUnload() {
            document.removeEventListener("theme:sliderule:close", this.closeSliderule)
        }
    }
    let tX = {
            wrapper: "[data-header-wrapper]",
            style: "data-header-style",
            widthContentWrapper: "[data-takes-space-wrapper]",
            widthContent: "[data-child-takes-space]",
            desktop: "[data-header-desktop]",
            deadLink: '.navlink[href="#"]',
            cartDrawer: "cart-drawer",
            cartToggleButton: "[data-cart-toggle]",
            firstSectionOverlayHeader: ".main-content > .shopify-section.section-overlay-header:first-of-type"
        },
        t1 = {
            clone: "js__header__clone",
            firstSectionOverlayHeader: "has-first-section-overlay-header",
            showMobileClass: "js__show__mobile",
            transparent: "has-header-transparent"
        },
        tG = {};
    class t4 {
        constructor(e) {
            this.wrapper = e, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(tX.desktop), this.deadLinks = document.querySelectorAll(tX.deadLink), this.resizeObserver = null, this.checkWidth = this.checkWidth.bind(this), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.cartToggleEvent();
            let t = document.querySelector(tX.firstSectionOverlayHeader);
            document.body.classList.toggle(t1.transparent, this.wrapper.hasAttribute("data-header-transparent")), document.body.classList.toggle(t1.firstSectionOverlayHeader, t)
        }
        initTicker(e = !1) {
            this.tickerFrames.forEach(t => {
                new tP(t, e)
            }), this.tickerResizeEvent = e => this.onTickerResize(e), document.addEventListener("theme:resize:width", this.tickerResizeEvent)
        }
        listenWidth() {
            "ResizeObserver" in window ? (this.resizeObserver = new ResizeObserver(this.checkWidth), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth)
        }
        killDeadLinks() {
            this.deadLinks.forEach(e => {
                e.onclick = e => {
                    e.preventDefault()
                }
            })
        }
        checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
                this.wrapper.classList.add(t1.showMobileClass);
                let {
                    headerHeight: e
                } = l();
                document.documentElement.style.setProperty("--header-height", `${e}px`)
            } else this.wrapper.classList.remove(t1.showMobileClass)
        }
        getMinWidth() {
            let e = this.wrapper.cloneNode(!0);
            e.classList.add(t1.clone), document.body.appendChild(e);
            let t = e.querySelectorAll(tX.widthContentWrapper),
                i = 0,
                s = 0;
            return t.forEach(e => {
                var t;
                let r = e.querySelectorAll(tX.widthContent),
                    o = 0,
                    a;
                (o = 3 === r.length ? function e(t) {
                    let i = [];
                    t.forEach(e => {
                        e.firstElementChild && i.push(e.firstElementChild.clientWidth)
                    }), i[0] > i[2] ? i[2] = i[0] : i[0] = i[2];
                    let s = i.reduce((e, t) => e + t);
                    return s
                }(r) : (t = r, a = 0, t.forEach(e => {
                    a += e.clientWidth
                }), a)) > i && (i = o, s = 20 * r.length)
            }), document.body.removeChild(e), i + s
        }
        cartToggleEvent() {
            "drawer" === theme.settings.cartType && this.wrapper.querySelectorAll(tX.cartToggleButton)?.forEach(e => {
                e.addEventListener("click", t => {
                    let i = document.querySelector(tX.cartDrawer);
                    i && (t.preventDefault(), i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), window.accessibility.lastElement = e)
                })
            })
        }
        toggleButtonClick(e) {
            e.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", {
                bubbles: !0
            }))
        }
        unload() {
            "ResizeObserver" in window ? this.resizeObserver?.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth)
        }
    }
    e6("header", [{
        onLoad() {
            tG = new t4(this.container)
        },
        onUnload() {
            "function" == typeof tG.unload && tG.unload()
        }
    }, {
        onLoad() {
            tB[this.id] = [];
            let e = this.container.querySelectorAll(tM.drawerWrappper);
            e.forEach(e => {
                tB[this.id].push(new tO(e))
            })
        },
        onUnload() {
            tB[this.id].forEach(e => {
                "function" == typeof e.onUnload && e.onUnload()
            })
        }
    }, {
        onLoad() {
            t3[this.id] = [];
            let e = this.container.querySelectorAll(t0.slideruleWrappper);
            e.forEach(e => {
                t3[this.id].push(new t2(e))
            })
        },
        onUnload() {
            t3[this.id].forEach(e => {
                "function" == typeof e.onUnload && e.onUnload()
            })
        }
    }, {
        onLoad() {
            tF = new tN(this.container)
        },
        onUnload: function() {
            "function" == typeof tF.unload && tF.unload()
        }
    }, {
        onLoad() {
            tV[this.id] = [], (tU = this.container.querySelectorAll(tW.disclosureWrappper)).forEach(e => {
                tV[this.id].push(new tz(e))
            })
        },
        onBlockSelect(e) {
            tV[this.id].forEach(t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            })
        },
        onBlockDeselect(e) {
            tV[this.id].forEach(t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            })
        }
    }]), customElements.get("ticker-bar") || customElements.define("ticker-bar", tP);
    let tJ = {
            scrollElement: "[data-block-scroll]",
            flickityEnabled: "flickity-enabled"
        },
        tY = {};
    class tQ {
        constructor(e) {
            this.container = e.container
        }
        onBlockSelect(e) {
            let t = this.container.querySelector(tJ.scrollElement);
            if (t && !t.classList.contains(tJ.flickityEnabled)) {
                let i = e.srcElement;
                i && t.scrollTo({
                    top: 0,
                    left: i.offsetLeft,
                    behavior: "smooth"
                })
            }
        }
    }
    let t5 = {
            onLoad() {
                tY[this.id] = new tQ(this)
            },
            onBlockSelect(e) {
                tY[this.id].onBlockSelect(e)
            }
        },
        t6 = {
            slider: "[data-slider-mobile]",
            slide: "[data-slide]",
            thumb: "[data-slider-thumb]",
            sliderContainer: "[data-slider-container]",
            popupContainer: "[data-popup-container]",
            popupClose: "[data-popup-close]"
        },
        t7 = {
            isAnimating: "is-animating",
            isSelected: "is-selected",
            isOpen: "is-open"
        },
        tK = {
            thumbValue: "data-slider-thumb"
        },
        tZ = {};
    class ie {
        constructor(e) {
            this.container = e.container, this.slider = this.container.querySelector(t6.slider), this.slides = this.container.querySelectorAll(t6.slide), this.thumbs = this.container.querySelectorAll(t6.thumb), this.popupContainer = this.container.querySelector(t6.popupContainer), this.popupClose = this.container.querySelectorAll(t6.popupClose), this.popupCloseByEvent = this.popupCloseByEvent.bind(this), this.init()
        }
        init() {
            this.slider && this.slides.length && this.thumbs.length && (this.popupContainer.addEventListener("transitionend", e => {
                e.target == this.popupContainer && (this.popupContainer.classList.remove(t7.isAnimating), e.target.classList.contains(t7.isOpen) ? this.popupOpenCallback() : this.popupCloseCallback())
            }), this.popupContainer.addEventListener("transitionstart", e => {
                e.target == this.popupContainer && this.popupContainer.classList.add(t7.isAnimating)
            }), this.popupClose.forEach(e => {
                e.addEventListener("click", () => {
                    this.popupContainer.classList.remove(t7.isOpen), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                })
            }), this.thumbs.forEach((e, t) => {
                e.addEventListener("click", i => {
                    i.preventDefault();
                    let s = e.hasAttribute(tK.thumbValue) && "" !== e.getAttribute(tK.thumbValue) ? parseInt(e.getAttribute(tK.thumbValue)) : t,
                        r = this.slides[s];
                    if (y()) {
                        let o = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                        this.slider.scrollTo({
                            top: 0,
                            left: r.offsetLeft - o,
                            behavior: "auto"
                        }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })), this.popupContainer.classList.add(t7.isAnimating, t7.isOpen)
                    } else {
                        let {
                            stickyHeaderHeight: a
                        } = l(), n = r.getBoundingClientRect().top, d = r.offsetHeight / 2, c = window.innerHeight, h = this.container.querySelector(t6.sliderContainer), u = n + d - c / 2 + window.scrollY;
                        if (h) {
                            let p = h.getBoundingClientRect().top + window.scrollY,
                                m = h.offsetHeight,
                                g = p + m;
                            u < p ? u = p - a : u + c > g && (u = g - c)
                        }
                        window.scrollTo({
                            top: u,
                            left: 0,
                            behavior: "smooth"
                        })
                    }
                })
            }))
        }
        popupCloseByEvent() {
            this.popupContainer.classList.remove(t7.isOpen)
        }
        popupOpenCallback() {
            document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                once: !0
            }), document.addEventListener("theme:product:added", this.popupCloseByEvent, {
                once: !0
            })
        }
        popupCloseCallback() {
            document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                once: !0
            }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, {
                once: !0
            })
        }
    }

    function it() {
        this.entries = []
    }

    function ii(e) {
        if ("object" != typeof e) throw TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw Error(e + " is empty.")
    }
    e6("look", [{
        onLoad() {
            tZ[this.id] = new ie(this)
        }
    }, t5]), it.prototype.add = function(e, t, i) {
        this.entries.push({
            element: e,
            event: t,
            fn: i
        }), e.addEventListener(t, i)
    }, it.prototype.removeAll = function() {
        this.entries = this.entries.filter(function(e) {
            return e.element.removeEventListener(e.event, e.fn), !1
        })
    };
    var is = {
        idInput: '[name="id"]',
        planInput: '[name="selling_plan"]',
        optionInput: '[name^="options"]',
        quantityInput: '[name="quantity"]',
        propertyInput: '[name^="properties"]'
    };
    class ir {
        constructor(e, t, i) {
            this.element = e, this.product = this._validateProductObject(t), this.variantElement = this.element.querySelector(is.idInput), i = i || {}, this._listeners = new it, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)), this.optionInputs = this._initInputs(is.optionInput, i.onOptionChange), this.planInputs = this._initInputs(is.planInput, i.onPlanChange), this.quantityInputs = this._initInputs(is.quantityInput, i.onQuantityChange), this.propertyInputs = this._initInputs(is.propertyInput, i.onPropertyChange)
        }
        destroy() {
            this._listeners.removeAll()
        }
        options() {
            return this._serializeInputValues(this.optionInputs, function(e) {
                return e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2], e
            })
        }
        variant() {
            var e, t, i, s, r, o, a, n;
            let l = this.options();
            if (!l.length) return this.product.variants[0];
            return e = this.product, t = l, ii(e), i = (s = e, r = t, ii(s), function e(t) {
                    if (!Array.isArray(t)) throw TypeError(t + " is not an array.");
                    if (0 === t.length) throw Error(t + " is empty.");
                    if (t[0].hasOwnProperty("name")) {
                        if ("string" != typeof t[0].name) throw TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                    } else throw Error(t[0] + "does not contain name key.")
                }(r), o = [], r.forEach(function(e) {
                    for (var t = 0; t < s.options.length; t++)
                        if ((s.options[t].name || s.options[t]).toLowerCase() === e.name.toLowerCase()) {
                            o[t] = e.value;
                            break
                        }
                }), o), a = e, n = i, ii(a),
                function e(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw Error(t + "is not a valid array of options.")
                }(n), a.variants.filter(function(e) {
                    return n.every(function(t, i) {
                        return e.options[i] === t
                    })
                })[0] || null
        }
        plan(e) {
            let t = {
                    allocation: null,
                    group: null,
                    detail: null
                },
                i = this.element.querySelector(`${is.planInput}:checked`);
            if (!i) return null;
            let s = i.value,
                r = s && "" !== s ? s : null;
            return (r && e && (t.allocation = e.selling_plan_allocations.find(function(e) {
                return e.selling_plan_id.toString() === r.toString()
            })), t.allocation && (t.group = this.product.selling_plan_groups.find(function(e) {
                return e.id.toString() === t.allocation.selling_plan_group_id.toString()
            })), t.group && (t.detail = t.group.selling_plans.find(function(e) {
                return e.id.toString() === r.toString()
            })), t && t.allocation && t.detail && t.allocation) ? t : null
        }
        properties() {
            return this._serializeInputValues(this.propertyInputs, function(e) {
                return e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2], e
            })
        }
        quantity() {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
        }
        getFormState() {
            let e = this.variant();
            return {
                options: this.options(),
                variant: e,
                properties: this.properties(),
                quantity: this.quantity(),
                plan: this.plan(e)
            }
        }
        _setIdInputValue(e) {
            e && e.id ? this.variantElement.value = e.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
        }
        _onSubmit(e, t) {
            t.dataset = this.getFormState(), e.onFormSubmit && e.onFormSubmit(t)
        }
        _onOptionChange(e) {
            this._setIdInputValue(e.dataset.variant)
        }
        _onFormEvent(e) {
            return void 0 === e ? Function.prototype.bind() : (function(t) {
                t.dataset = this.getFormState(), this._setIdInputValue(t.dataset.variant), e(t)
            }).bind(this)
        }
        _initInputs(e, t) {
            return Array.prototype.slice.call(this.element.querySelectorAll(e)).map((function(e) {
                return this._listeners.add(e, "change", this._onFormEvent(t)), e
            }).bind(this))
        }
        _serializeInputValues(e, t) {
            return e.reduce(function(e, i) {
                return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && e.push(t({
                    name: i.name,
                    value: i.value
                })), e
            }, [])
        }
        _validateProductObject(e) {
            if ("object" != typeof e) throw TypeError(e + " is not an object.");
            if (void 0 === e.variants[0].options) throw TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
            return e
        }
    }
    let io = {
            scrollbarAttribute: "data-scrollbar",
            scrollbar: "data-scrollbar-slider",
            scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
            scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
            scrollbarArrowNext: "[data-scrollbar-arrow-next]"
        },
        ia = {
            hidden: "is-hidden"
        },
        il = {
            delay: 200
        };
    class id {
        constructor(e) {
            this.scrollbar = e, this.arrowNext = this.scrollbar.parentNode.querySelector(io.scrollbarArrowNext), this.arrowPrev = this.scrollbar.parentNode.querySelector(io.scrollbarArrowPrev), this.scrollbar.hasAttribute(io.scrollbarAttribute) && (this.init(), this.listen()), this.scrollbar.hasAttribute(io.scrollbar) && this.scrollToVisibleElement()
        }
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events())
        }
        listen() {
            document.addEventListener("theme:modal:open", () => {
                this.toggleNextArrow()
            }), document.addEventListener("theme:resize", () => {
                this.toggleNextArrow()
            })
        }
        events() {
            this.arrowNext.addEventListener("click", e => {
                e.preventDefault(), this.goToNext()
            }), this.arrowPrev.addEventListener("click", e => {
                e.preventDefault(), this.goToPrev()
            }), this.scrollbar.addEventListener("scroll", () => {
                this.togglePrevArrow(), this.toggleNextArrow()
            })
        }
        goToNext() {
            let e = this.scrollbar.hasAttribute(io.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                t = e + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(ia.hidden), this.toggleNextArrow()
        }
        goToPrev() {
            let e = this.scrollbar.hasAttribute(io.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                t = this.scrollbar.scrollLeft - e;
            this.move(t), this.arrowNext.classList.remove(ia.hidden), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout(() => {
                this.arrowNext?.classList.toggle(ia.hidden, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }, il.delay)
        }
        togglePrevArrow() {
            setTimeout(() => {
                this.arrowPrev.classList.toggle(ia.hidden, this.scrollbar.scrollLeft <= 0)
            }, il.delay)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, e => {
                e.addEventListener("click", t => {
                    t.preventDefault(), this.move(e.offsetLeft - e.clientWidth)
                })
            })
        }
        move(e) {
            this.scrollbar.scrollTo({
                top: 0,
                left: e,
                behavior: "smooth"
            })
        }
    }
    let ic = {
            gridSwatchForm: "[data-grid-swatch-form]",
            input: "[data-swatch-input]",
            productItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            sectionId: "[data-section-id]",
            productImage: "[data-product-image]",
            swatchButton: "[data-swatch-button]",
            swatchLink: "[data-swatch-link]",
            swatchText: "[data-swatch-text]",
            template: "[data-swatch-template]"
        },
        ih = {
            visible: "is-visible",
            hidden: "hidden",
            stopEvents: "no-events",
            swatch: "swatch"
        },
        iu = {
            image: "data-swatch-image",
            handle: "data-swatch-handle",
            label: "data-swatch-label",
            scrollbar: "data-scrollbar",
            swatchCount: "data-swatch-count",
            tooltip: "data-tooltip",
            variant: "data-swatch-variant",
            variantName: "data-swatch-variant-name",
            variantTitle: "data-variant-title",
            swatchValues: "data-swatch-values"
        };
    class ip extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.hasAttribute(iu.tooltip) && new to(this)
        }
    }
    class im extends HTMLElement {
        constructor() {
            super(), this.productItemMouseLeaveEvent = () => this.hideVariantImages(), this.showVariantImageEvent = e => this.showVariantImage(e)
        }
        connectedCallback() {
            this.handle = this.getAttribute(iu.handle), this.productItem = this.closest(ic.productItem), this.productInfo = this.closest(ic.productInfo), this.productImage = this.productItem.querySelector(ic.productImage), this.template = document.querySelector(ic.template).innerHTML, this.swatchesJSON = this.getSwatchesJSON(), this.swatchesStyle = theme.settings.collectionSwatchStyle;
            let e = this.getAttribute(iu.label).trim().toLowerCase();
            (function e(t) {
                let i = `${window.theme.routes.root}products/${t}.js`;
                return window.fetch(i).then(e => e.json()).catch(e => {
                    console.error(e)
                })
            })(this.handle).then(t => {
                this.product = t, this.colorOption = t.options.find(function(t) {
                    return t.name.toLowerCase() === e || null
                }), this.colorOption && (this.swatches = this.colorOption.values, this.init())
            })
        }
        init() {
            if (this.innerHTML = "", this.count = 0, this.limitedCount = 0, this.swatches.forEach(e => {
                    let t = null,
                        i = !1,
                        s = "";
                    for (let r of this.product.variants) {
                        let o = r.options.includes(e);
                        if (!t && o && (t = r), o && r.featured_media) {
                            s = r.featured_media.preview_image.src, t = r;
                            break
                        }
                    }
                    for (let a of this.product.variants) {
                        let n = a.options.includes(e);
                        if (n && a.available) {
                            i = !0;
                            break
                        }
                    }
                    if (t) {
                        var l, d;
                        let c = document.createElement("div");
                        c.innerHTML = this.template;
                        let h = c.querySelector(ic.swatchButton),
                            u = c.querySelector(ic.swatchLink),
                            p = c.querySelector(ic.swatchText),
                            m = this.swatchesJSON[e],
                            g = "native" == theme.settings.swatchesType ? m : `var(--${m})`,
                            v = t.title.replaceAll('"', "'");
                        h.style = `--animation-delay: ${100*this.count/1250}s`, h.classList.add(`${ih.swatch}-${m}`), h.dataset.tooltip = e, h.dataset.swatchVariant = t.id, h.dataset.swatchVariantName = v, h.dataset.swatchImage = s, h.dataset.variant = t.id, h.style.setProperty("--swatch", g), u.href = (l = this.product.url, d = t.id, /variant=/.test(l) ? l.replace(/(variant=)[^&]+/, "$1" + d) : /\?/.test(l) ? l.concat("&variant=").concat(d) : l.concat("?variant=").concat(d)), u.dataset.swatch = e, u.disabled = !i, p.innerText = e, "limited" != this.swatchesStyle ? this.innerHTML += c.innerHTML : this.count <= 4 && (this.innerHTML += c.innerHTML, this.limitedCount++), this.count++
                    }
                }), this.swatchCount = this.productInfo.querySelector(`[${iu.swatchCount}]`), this.swatchElements = this.querySelectorAll(ic.swatchLink), this.swatchForm = this.productInfo.querySelector(ic.gridSwatchForm), this.hideSwatchesTimer = 0, this.swatchCount.hasAttribute(iu.swatchCount)) {
                if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
                    if (this.swatchCount.innerText = `${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`, "text" == this.swatchesStyle) return;
                    this.swatchCount.addEventListener("mouseenter", () => {
                        this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(ih.stopEvents), this.swatchForm.classList.add(ih.visible)
                    }), this.productInfo.addEventListener("mouseleave", () => {
                        this.hideSwatchesTimer = setTimeout(() => {
                            this.productInfo.classList.remove(ih.stopEvents), this.swatchForm.classList.remove(ih.visible)
                        }, 100)
                    })
                }
                if (("slider" == this.swatchesStyle || "grid" == this.swatchesStyle) && this.swatchForm.classList.add(ih.visible), "limited" == this.swatchesStyle) {
                    let e = this.count - this.limitedCount;
                    this.swatchForm.classList.add(ih.visible), e > 0 && (this.innerHTML += `<div class="swatch-limited">+${e}</div>`)
                }
            }("text-slider" == this.swatchesStyle || "slider" == this.swatchesStyle) && this.hasAttribute(iu.scrollbar) && new id(this), this.bindSwatchButtonEvents()
        }
        bindSwatchButtonEvents() {
            this.querySelectorAll(ic.swatchButton)?.forEach(e => {
                e.addEventListener("mouseenter", this.showVariantImageEvent), e.hasAttribute(iu.tooltip) && new to(e)
            }), this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent)
        }
        showVariantImage(e) {
            let t = e.target,
                i = t.getAttribute(iu.variantName)?.replaceAll('"', "'"),
                s = this.productImage.querySelectorAll(`[${iu.variantTitle}]`),
                r = this.productImage.querySelector(`[${iu.variantTitle}="${i}"]`);
            s?.forEach(e => {
                e.classList.remove(ih.visible)
            }), r?.classList.add(ih.visible)
        }
        hideVariantImages() {
            this.productImage.querySelectorAll(`[${iu.variantTitle}].${ih.visible}`)?.forEach(e => {
                e.classList.remove(ih.visible)
            })
        }
        getSwatchesJSON() {
            if (!this.hasAttribute(iu.swatchValues)) return {};
            let e = this.getAttribute(iu.swatchValues).split(","),
                t = {};
            return e?.forEach(e => {
                let [i, s] = e.split(":");
                t[i.trim()] = s.trim()
            }), t
        }
    }
    let ig = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]"
        },
        iv = {
            visible: "is-visible",
            fade: "is-fade",
            stopEvents: "no-events",
            active: "is-active"
        },
        ib = {
            siblingAddedImage: "data-sibling-added-image",
            siblingCutline: "data-sibling-cutline",
            siblingImage: "data-sibling-image",
            siblingLink: "data-sibling-link",
            siblingPrice: "data-sibling-price",
            siblingCompareAtPrice: "data-sibling-compare-at-price",
            productLink: "data-product-link"
        };
    class iy {
        constructor(e, t) {
            this.swatches = e, this.product = t, this.productLinks = this.product.querySelectorAll(ig.productLink), this.productCutline = this.product.querySelector(ig.productCutline), this.productPrice = this.product.querySelector(ig.productPrice), this.productImage = this.product.querySelector(ig.productImage), this.productImageSibling = this.product.querySelector(ig.productImageSibling), this.init()
        }
        init() {
            this.cacheDefaultValues(), this.product.addEventListener("mouseleave", () => this.resetProductValues()), this.swatches.forEach(e => {
                e.addEventListener("mouseenter", e => this.showSibling(e))
            }), this.productLinks.length && this.swatches.forEach(e => {
                e.addEventListener("click", () => {
                    this.productLinks[0].click()
                })
            })
        }
        cacheDefaultValues() {
            this.productLinkValue = this.productLinks[0].hasAttribute(ib.productLink) ? this.productLinks[0].getAttribute(ib.productLink) : "", this.productPriceValue = this.productPrice.innerHTML, this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML)
        }
        resetProductValues() {
            this.product.classList.remove(iv.active), this.productLinkValue && this.productLinks.forEach(e => {
                e.href = this.productLinkValue
            }), this.productPrice && (this.productPrice.innerHTML = this.productPriceValue), this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue, this.productCutline.title = this.productCutlineValue), this.hideSiblingImage()
        }
        showSibling(e) {
            let t = e.target,
                i = t.hasAttribute(ib.siblingLink) ? t.getAttribute(ib.siblingLink) : "",
                s = t.hasAttribute(ib.siblingPrice) ? t.getAttribute(ib.siblingPrice) : "",
                r = t.hasAttribute(ib.siblingCompareAtPrice) ? t.getAttribute(ib.siblingCompareAtPrice) : "",
                o = t.hasAttribute(ib.siblingCutline) ? t.getAttribute(ib.siblingCutline) : "",
                a = t.hasAttribute(ib.siblingImage) ? t.getAttribute(ib.siblingImage) : "";
            i && this.productLinks.forEach(e => {
                e.href = i
            }), r ? this.productPrice.innerHTML = `<span class="price sale"><span class="new-price">${s}</span> <span class="old-price">${r}</span></span>` : this.productPrice.innerHTML = `<span class="price">${s}</span>`, this.productCutline && (o ? (this.productCutline.innerHTML = o, this.productCutline.title = o) : (this.productCutline.innerHTML = "", this.productCutline.title = "")), a && this.showSiblingImage(a)
        }
        showSiblingImage(e) {
            if (!this.productImageSibling) return;
            let t = window.devicePixelRatio || 1,
                i = this.productImage.offsetWidth * t,
                s = r.getSizedImageUrl(e, `${180*Math.ceil(i/180)}x`),
                o = this.productImageSibling.querySelector(`[src="${s}"]`),
                a = () => {
                    this.productImageSibling.classList.add(iv.visible), this.productImageSibling.querySelector(`[src="${s}"]`).classList.add(iv.fade)
                },
                n = () => {
                    this.productImageSibling.querySelectorAll("img").forEach(e => {
                        e.classList.remove(iv.fade)
                    }), requestAnimationFrame(a)
                };
            if (o) n();
            else {
                let l = document.createElement("img");
                l.src = s, this.productCutline && (l.alt = this.productCutline.innerText), l.addEventListener("load", () => {
                    this.productImageSibling.append(l), n()
                })
            }
        }
        hideSiblingImage() {
            this.productImageSibling && (this.productImageSibling.classList.remove(iv.visible), this.productImageSibling.querySelectorAll("img").forEach(e => {
                e.classList.remove(iv.fade)
            }))
        }
    }
    class iS extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.product = this.closest(ig.productGridItem), this.siblingScrollbar = this.querySelector(ig.siblingsInnerHolder), this.siblingCount = this.querySelector(ig.siblingCount), this.siblingFieldset = this.querySelector(ig.siblingFieldset), this.siblingLinks = this.querySelectorAll(ig.siblingLink), this.productInfo = this.closest(ig.productInfo), this.productLink = this.closest(ig.link), this.hideSwatchesTimer = 0, this.swatchesStyle = theme.settings.collectionSwatchStyle, this.initScrollbar(), this.siblingFieldset && this.productInfo && (("grid" == this.swatchesStyle || "slider" == this.swatchesStyle || "limited" == this.swatchesStyle) && this.siblingFieldset.classList.add(iv.visible), this.siblingCount && (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()), this.productInfo.addEventListener("mouseleave", () => this.hideSiblings()))), this.siblingLinks.length && new iy(this.siblingLinks, this.product), this.querySelectorAll(ig.tooltip).forEach(e => {
                new to(e)
            })
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(iv.stopEvents), "text" != this.swatchesStyle && this.siblingFieldset.classList.add(iv.visible)
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout(() => {
                this.productLink && this.productLink.classList.remove(iv.stopEvents), this.siblingFieldset.classList.remove(iv.visible)
            }, 100)
        }
        initScrollbar() {
            this.siblingScrollbar && new id(this.siblingScrollbar)
        }
    }
    let iw = {
        slide: "[data-hover-slide]",
        slideTouch: "[data-hover-slide-touch]",
        slider: "[data-hover-slider]",
        productLink: "[data-product-link]",
        flickityButton: ".flickity-prev-next-button"
    };
    class iL extends HTMLElement {
        constructor() {
            super(), this.flkty = null, this.slider = this.querySelector(iw.slider), this.handleScroll = this.handleScroll.bind(this)
        }
        connectedCallback() {
            window.theme.touch ? this.initTouch() : this.initFlickity()
        }
        disconnectedCallback() {
            this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        initTouch() {
            this.style.setProperty("--slides-count", this.querySelectorAll(iw.slideTouch).length), this.slider.addEventListener("scroll", this.handleScroll)
        }
        handleScroll() {
            let e = this.slider.scrollLeft / this.slider.clientWidth;
            this.style.setProperty("--slider-index", e)
        }
        initFlickity() {
            this.querySelectorAll(iw.slide).length < 2 || (this.flkty = new i(this.slider, {
                cellSelector: iw.slide,
                contain: !0,
                wrapAround: !0,
                watchCSS: !0,
                autoPlay: !1,
                draggable: !1,
                pageDots: !1,
                prevNextButtons: !0
            }), this.flkty.pausePlayer(), this.addEventListener("mouseenter", () => {
                this.flkty.unpausePlayer()
            }), this.addEventListener("mouseleave", () => {
                this.flkty.pausePlayer()
            }), this.closest(iw.productLink).addEventListener("click", e => {
                e.target.matches(iw.flickityButton) && e.preventDefault()
            }))
        }
    }
    let iE = {
            body: "body",
            dataRelatedSectionElem: "[data-related-section]",
            dataTabsHolder: "[data-tabs-holder]",
            dataTab: "data-tab",
            dataTabIndex: "data-tab-index",
            dataAos: "[data-aos]",
            blockId: "data-block-id",
            tabsLi: "[data-tab]",
            tabLink: ".tab-link",
            tabLinkRecent: ".tab-link__recent",
            tabContent: ".tab-content",
            scrollbarHolder: "[data-scrollbar]"
        },
        ik = {
            current: "current",
            hidden: "hidden",
            aosAnimate: "aos-animate",
            aosNoTransition: "aos-no-transition",
            focused: "is-focused"
        },
        iA = {};
    class i$ {
        constructor(e) {
            this.container = e, this.body = document.querySelector(iE.body), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(iE.scrollbarHolder), this.init(), this.initNativeScrollbar())
        }
        init() {
            let e = this.container.querySelectorAll(iE.tabsLi);
            this.container.addEventListener("theme:tab:check", () => this.checkRecentTab()), this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab()), e.length && e.forEach(e => {
                let t = parseInt(e.getAttribute(iE.dataTab)),
                    i = this.container.querySelector(`${iE.tabContent}-${t}`);
                e.addEventListener("click", () => {
                    this.tabChange(e, i)
                }), e.addEventListener("keyup", t => {
                    ("Space" === t.code || "Enter" === t.code) && this.body.classList.contains(ik.focused) && this.tabChange(e, i)
                })
            })
        }
        tabChange(e, t) {
            if (e.classList.contains(ik.current)) return;
            let i = this.container.querySelector(`${iE.tabsLi}.${ik.current}`),
                s = this.container.querySelector(`${iE.tabContent}.${ik.current}`);
            i?.classList.remove(ik.current), s?.classList.remove(ik.current), e.classList.add(ik.current), t.classList.add(ik.current), e.classList.contains(ik.hidden) && t.classList.add(ik.hidden), this.accessibility.a11y.removeTrapFocus(), this.container.dispatchEvent(new CustomEvent("theme:tab:change", {
                bubbles: !0
            })), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "tab"
                }
            })), this.animateItems(t)
        }
        animateItems(e, t = !0) {
            let i = e.querySelectorAll(iE.dataAos);
            i.length && i.forEach(e => {
                e.classList.remove(ik.aosAnimate), t && (e.classList.add(ik.aosNoTransition), requestAnimationFrame(() => {
                    e.classList.remove(ik.aosNoTransition), e.classList.add(ik.aosAnimate)
                }))
            })
        }
        initNativeScrollbar() {
            this.scrollbarHolder.length && this.scrollbarHolder.forEach(e => {
                new id(e)
            })
        }
        checkRecentTab() {
            let e = this.container.querySelector(iE.tabLinkRecent);
            if (e) {
                e.classList.remove(ik.hidden);
                let t = parseInt(e.getAttribute(iE.dataTab)),
                    i = this.container.querySelector(`${iE.tabContent}[${iE.dataTabIndex}="${t}"]`);
                i && (i.classList.remove(ik.hidden), this.animateItems(i, !1)), this.initNativeScrollbar()
            }
        }
        hideRelatedTab() {
            let e = this.container.querySelector(iE.dataRelatedSectionElem);
            if (!e) return;
            let t = e.closest(`${iE.tabContent}.${ik.current}`);
            if (!t) return;
            let i = parseInt(t.getAttribute(iE.dataTabIndex)),
                s = this.container.querySelectorAll(iE.tabsLi);
            if (s.length > i) {
                let r = s[i].nextSibling;
                r && (s[i].classList.add(ik.hidden), r.dispatchEvent(new Event("click")), this.initNativeScrollbar())
            }
        }
        onBlockSelect(e) {
            let t = this.container.querySelector(`${iE.tabLink}[${iE.blockId}="${e.detail.blockId}"]`);
            t && (t.dispatchEvent(new Event("click")), t.parentNode.scrollTo({
                top: 0,
                left: t.offsetLeft - t.clientWidth,
                behavior: "smooth"
            }))
        }
    }
    let iC = {
        onLoad() {
            iA[this.id] = [];
            let e = this.container.querySelectorAll(iE.dataTabsHolder);
            e.forEach(e => {
                iA[this.id].push(new i$(e))
            })
        },
        onBlockSelect(e) {
            iA[this.id].forEach(t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            })
        }
    };

    function iT() {
        let e = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            t = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return e || t
    }
    let iq = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current"
        },
        iP = {
            errorDelay: 3e3
        },
        ix = {
            animation: "[data-animation]",
            apiContent: "[data-api-content]",
            buttonQuickAdd: "[data-quick-add-btn]",
            buttonAddToCart: "[data-add-to-cart]",
            cartDrawer: "cart-drawer",
            cartPage: "[data-cart-page]",
            cartLineItems: "[data-line-items]",
            dialog: "dialog",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
            messageError: "[data-message-error]",
            modalButton: "[data-quick-add-modal-handle]",
            modalContainer: "[data-product-upsell-container]",
            modalContent: "[data-product-upsell-ajax]",
            modalClose: "[data-quick-add-modal-close]",
            productGridItem: "data-grid-item",
            productInformationHolder: "[data-product-information]",
            quickAddHolder: "[data-quick-add-holder]",
            quickAddModal: "[data-quick-add-modal]",
            quickAddModalTemplate: "[data-quick-add-modal-template]",
            tooltip: "[data-tooltip]"
        },
        iI = {
            closing: "closing",
            productId: "data-product-id",
            modalHandle: "data-quick-add-modal-handle",
            siblingSwapper: "data-sibling-swapper",
            quickAddHolder: "data-quick-add-holder"
        };
    class i_ extends HTMLElement {
        constructor() {
            super(), this.container = this, this.quickAddHolder = this.container.querySelector(ix.quickAddHolder), this.quickAddHolder && (this.modal = null, this.currentModal = null, this.productId = this.quickAddHolder.getAttribute(iI.quickAddHolder), this.modalButton = this.quickAddHolder.querySelector(ix.modalButton), this.handle = this.modalButton?.getAttribute(iI.modalHandle), this.buttonQuickAdd = this.quickAddHolder.querySelector(ix.buttonQuickAdd), this.buttonATC = this.quickAddHolder.querySelector(ix.buttonAddToCart), this.button = this.modalButton || this.buttonATC, this.modalClose = this.modalClose.bind(this), this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this), this.a11y = F, this.isAnimating = !1, this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this), this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this))
        }
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent), this.buttonATC && this.buttonATC.addEventListener("click", e => {
                e.preventDefault(), window.accessibility.lastElement = this.buttonATC, document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    }
                }))
            }), this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler())
        }
        modalButtonClickEvent(e) {
            e.preventDefault();
            let t = this.modalButton.hasAttribute(iI.siblingSwapper),
                i = this.modalButton.classList.contains(iq.siblingLinkCurrent);
            i || (this.modalButton.classList.add(iq.loading), this.modalButton.disabled = !0, t && !i && (this.currentModal = e.target.closest(ix.quickAddModal), this.currentModal.classList.add(iq.loading)), this.renderModal())
        }
        modalCreate(e) {
            let t = document.querySelector(`${ix.quickAddModal}[${iI.productId}="${this.productId}"]`);
            if (t) this.modal = t, this.modalOpen();
            else {
                let i = this.quickAddHolder.querySelector(ix.quickAddModalTemplate);
                if (!i) return;
                let s = document.createElement("div");
                s.innerHTML = i.innerHTML, document.body.appendChild(s.querySelector(ix.quickAddModal)), i.remove(), this.modal = document.querySelector(`${ix.quickAddModal}[${iI.productId}="${this.productId}"]`), this.modal.querySelector(ix.modalContent).innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(ix.apiContent).innerHTML, this.modal.querySelectorAll(ix.tooltip).forEach(e => {
                    new to(e)
                }), this.modalCreatedCallback()
            }
        }
        modalOpen() {
            this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", {
                bubbles: !1
            })), "function" == typeof this.modal.show && this.modal.show(), this.modal.setAttribute("open", !0), this.modal.removeAttribute("inert"), this.quickAddHolder.classList.add(iq.disabled), this.modalButton && (this.modalButton.classList.remove(iq.loading), this.modalButton.disabled = !1, window.accessibility.lastElement = this.modalButton), requestAnimationFrame(() => {
                this.modal.querySelectorAll(ix.animation).forEach(e => {
                    e.classList.add(iq.animated)
                })
            }), document.dispatchEvent(new CustomEvent("theme:quick-add:open", {
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, {
                once: !0
            })
        }
        modalClose() {
            if (!this.isAnimating) {
                if (!this.modal.hasAttribute(iI.closing)) {
                    this.modal.setAttribute(iI.closing, ""), this.isAnimating = !0;
                    return
                }
                "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"), this.modal.removeAttribute(iI.closing), this.modal.setAttribute("inert", ""), this.modal.classList.remove(iq.loading), this.modalButton && (this.modalButton.disabled = !1), this.quickAddHolder && this.quickAddHolder.classList.contains(iq.disabled) && this.quickAddHolder.classList.remove(iq.disabled), this.resetAnimatedItems(), iT() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
            }
        }
        modalEvents() {
            this.modal.querySelector(ix.modalClose)?.addEventListener("click", e => {
                e.preventDefault(), this.modalClose()
            }), this.modal.addEventListener("click", e => {
                "DIALOG" === e.target.nodeName && "click" === e.type && this.modalClose()
            }), this.modal.addEventListener("keydown", e => {
                "Escape" == e.code && (e.preventDefault(), this.modalClose())
            }), this.modal.addEventListener("theme:modal:close", () => {
                this.modalClose()
            }), this.modal.addEventListener("animationend", e => {
                e.target === this.modal && (this.isAnimating = !1, this.modal.hasAttribute(iI.closing) ? this.modalClose() : setTimeout(() => {
                    this.a11y.trapFocus(this.modal);
                    let e = this.modal.querySelector("[autofocus]") || this.modal.querySelector(ix.focusable);
                    e?.focus()
                }, 50))
            })
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose()
        }
        quickAddLoadingToggle(e) {
            e.target == this.quickAddHolder && this.quickAddHolder.classList.remove(iq.disabled)
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", e => {
                let t = e.detail.holder,
                    i = t.closest(`[${ix.productGridItem}]`);
                if (!i) return;
                let s = t.querySelector(ix.messageError),
                    r = i.classList.contains(iq.overlayText),
                    o = i.querySelector(ix.productInformationHolder),
                    a = t.querySelector(ix.buttonAddToCart);
                a && (a.classList.remove(iq.added, iq.loading), t.classList.add(iq.error)), s && (s.innerText = e.detail.description), r && o.classList.add(iq.hidden), setTimeout(() => {
                    this.resetQuickAddButtons(), r && o.classList.remove(iq.hidden)
                }, iP.errorDelay)
            })
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(iq.visible, iq.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(iq.added), this.buttonQuickAdd.disabled = !1)
        }
        renderModal() {
            this.modal ? this.modalOpen() : window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then(e => e.text()).then(e => {
                this.modalCreate(e)
            })
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), q(this.modal)
        }
        upsellErrorsHandler(e) {
            return e.ok ? e : e.json().then(function(t) {
                let i = new e$({
                    status: e.statusText,
                    headers: e.headers,
                    json: t
                });
                throw i
            })
        }
        resetAnimatedItems() {
            this.modal?.querySelectorAll(ix.animation).forEach(e => {
                e.classList.remove(iq.animated)
            })
        }
    }
    e6("product-grid", [iC]), customElements.get("quick-add-product") || customElements.define("quick-add-product", i_), customElements.get("radio-swatch") || customElements.define("radio-swatch", ip), customElements.get("grid-swatch") || customElements.define("grid-swatch", im), customElements.get("product-siblings") || customElements.define("product-siblings", iS), customElements.get("hover-images") || customElements.define("hover-images", iL);
    let iM = {
        fields: 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
        fieldEmail: 'input[type="email"]',
        fieldCheckbox: 'input[type="checkbox"]',
        form: "[data-form-wrapper]"
    };
    class iH extends HTMLElement {
        constructor() {
            super(), this.fieldCheckbox = this.querySelector(iM.fieldCheckbox), this.fieldEmail = this.querySelector(iM.fieldEmail), this.fields = this.querySelectorAll(iM.fields), this.form = this.closest(iM.form), this.onChangeEvent = e => this.onChange(e)
        }
        connectedCallback() {
            this.fieldCheckbox && (this.fieldCheckbox.addEventListener("change", this.onChangeEvent), this.form && this.form.addEventListener("theme:product:add", () => {
                this.fieldCheckbox.checked = !1, this.fieldCheckbox.dispatchEvent(new Event("change"))
            }))
        }
        clearInputValues() {
            this.fields.length && this.fields.forEach(e => {
                e.value = ""
            })
        }
        onChange(e) {
            this.fieldEmail.required = Boolean(e.target.checked), e.target.checked || this.clearInputValues()
        }
        disconnectedCallback() {
            this.fieldCheckbox.removeEventListener("change", this.onChangeEvent)
        }
    }
    let iB = {
            productPage: ".product__page",
            formWrapper: "[data-form-wrapper]",
            headerSticky: "[data-header-sticky]",
            productMediaList: "[data-product-media-list]"
        },
        iO = {
            sticky: "is-sticky"
        };
    window.theme.variables = {
        productPageSticky: !1
    };
    let iD = {};
    class i8 {
        constructor(e) {
            this.section = e, this.container = e.container, this.stickyEnabled = "true" === this.container.getAttribute("data-sticky-enabled"), this.formWrapper = this.container.querySelector(iB.formWrapper), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = e => this.scrollEvents(e), this.resizeEvent = e => this.resizeEvents(e), this.stickyFormEvent = e => this.stickyFormEvents(e), setTimeout(() => {
                this.init()
            }, 50)
        }
        init() {
            this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
        }
        initSticky() {
            theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()), this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent), document.addEventListener("theme:scroll", this.scrollEvent))
        }
        stickyFormEvents(e) {
            this.removeAnimationFrameSticky(), this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e))
        }
        scrollEvents(e) {
            this.scrollTop = e.detail.position, this.scrollDirectionDown = e.detail.down, this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()))
        }
        resizeEvents(e) {
            this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky()
        }
        stickyScrollCheck() {
            let e = this.container.querySelector(`${iB.productPage} ${iB.formWrapper}`);
            if (e) {
                if (b()) {
                    let t = this.container.querySelector(iB.formWrapper),
                        i = this.container.querySelector(iB.productMediaList);
                    if (!t || !i) return;
                    let s = t.offsetHeight,
                        r = i.offsetHeight;
                    s < r ? (theme.variables.productPageSticky = !0, e.classList.add(iO.sticky)) : (theme.variables.productPageSticky = !1, e.classList.remove(iO.sticky))
                } else theme.variables.productPageSticky = !1, e.classList.remove(iO.sticky)
            }
        }
        calculateStickyPosition(e = null) {
            let t = document.documentElement.hasAttribute("data-scroll-locked");
            if (t) {
                this.removeAnimationFrameSticky();
                return
            }
            let i = Boolean(e && e.detail),
                s = Boolean(i && e.detail.element && "accordion" === e.detail.element),
                r = this.formWrapper.offsetHeight,
                o = window.innerHeight - r - this.defaultTopBottomSpacings,
                a = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (this.scrollDirectionDown ? this.stickyScrollTop -= a : this.stickyScrollTop += a, this.stickyFormLoad) {
                if (document.querySelector(iB.headerSticky)) {
                    let {
                        headerHeight: n
                    } = l();
                    this.stickyDefaultTop = n
                } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                this.stickyScrollTop = this.stickyDefaultTop
            }
            this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
            let d = this.stickyScrollTop - this.currentPoint;
            this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * d, this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, s && this.onChangeCounter <= 10 || s && this.stickyFormLastHeight !== r || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== r && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e))) : this.requestAnimationSticky && this.removeAnimationFrameSticky(), this.stickyFormLastHeight = r
        }
        removeAnimationFrameSticky() {
            this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
        }
        onUnload() {
            this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
        }
    }
    let i9 = {
            buttonArrow: "[data-button-arrow]",
            deferredMediaButton: "[data-deferred-media-button]",
            focusedElement: "model-viewer, video, iframe, button, [href], input, [tabindex]",
            productMedia: "[data-image-id]",
            productMediaList: "[data-product-media-list]",
            section: "[data-section-type]"
        },
        iF = {
            arrows: "slider__arrows",
            dragging: "is-dragging",
            hidden: "hidden",
            isFocused: "is-focused",
            mediaActive: "media--active",
            mediaHidden: "media--hidden",
            mediaHiding: "media--hiding"
        },
        iN = {
            activeMedia: "data-active-media",
            buttonPrev: "data-button-prev",
            buttonNext: "data-button-next",
            imageId: "data-image-id",
            mediaId: "data-media-id",
            type: "data-type",
            faderDesktop: "data-fader-desktop",
            faderMobile: "data-fader-mobile"
        };
    class iW extends HTMLElement {
        constructor() {
            super(), this.initialized = !1, this.buttons = !1, this.isDown = !1, this.startX = 0, this.startY = 0, this.scrollLeft = 0, this.onButtonArrowClick = e => this.buttonArrowClickEvent(e), this.container = this.closest(i9.section), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.productMediaItems = this.querySelectorAll(i9.productMedia), this.productMediaList = this.querySelector(i9.productMediaList), this.setHeight = this.setHeight.bind(this), this.toggleEvents = this.toggleEvents.bind(this), this.selectMediaEvent = e => this.showMediaOnVariantSelect(e)
        }
        connectedCallback() {
            1 !== Object.keys(this.productMediaItems).length && (this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight())
        }
        disconnectedCallback() {
            this.unlisten()
        }
        listen() {
            document.addEventListener("theme:resize:width", this.toggleEvents), document.addEventListener("theme:resize:width", this.setHeight), this.addEventListener("theme:media:select", this.selectMediaEvent)
        }
        unlisten() {
            document.removeEventListener("theme:resize:width", this.toggleEvents), document.removeEventListener("theme:resize:width", this.setHeight), this.removeEventListener("theme:media:select", this.selectMediaEvent)
        }
        toggleEvents() {
            let e = y();
            e && this.hasAttribute(iN.faderMobile) || !e && this.hasAttribute(iN.faderDesktop) ? this.bindEventListeners() : this.unbindEventListeners()
        }
        bindEventListeners() {
            this.initialized || (this.productMediaList.addEventListener("mousedown", this.handleMouseDown), this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.addEventListener("mouseup", this.handleMouseUp), this.productMediaList.addEventListener("mousemove", this.handleMouseMove), this.productMediaList.addEventListener("touchstart", this.handleMouseDown, {
                passive: !0
            }), this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
                passive: !0
            }), this.productMediaList.addEventListener("touchmove", this.handleMouseMove, {
                passive: !0
            }), this.productMediaList.addEventListener("keyup", this.handleKeyUp), this.initArrows(), this.resetScrollPosition(), this.initialized = !0)
        }
        unbindEventListeners() {
            this.initialized && (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown), this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.removeEventListener("mouseup", this.handleMouseUp), this.productMediaList.removeEventListener("mousemove", this.handleMouseMove), this.productMediaList.removeEventListener("touchstart", this.handleMouseDown), this.productMediaList.removeEventListener("touchend", this.handleMouseUp), this.productMediaList.removeEventListener("touchmove", this.handleMouseMove), this.productMediaList.removeEventListener("keyup", this.handleKeyUp), this.removeArrows(), this.initialized = !1)
        }
        handleMouseDown(e) {
            this.isDown = !0, this.startX = (e.pageX || e.changedTouches[0].screenX) - this.offsetLeft, this.startY = (e.pageY || e.changedTouches[0].screenY) - this.offsetTop
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1)
        }
        handleMouseUp(e) {
            let t = (e.pageX || e.changedTouches[0].screenX) - this.offsetLeft,
                i = (e.pageY || e.changedTouches[0].screenY) - this.offsetTop,
                s = t - this.startX,
                r = i - this.startY,
                o = this.getCurrentMedia().hasAttribute(iN.type) && "image" === this.getCurrentMedia().getAttribute(iN.type);
            Math.abs(s) > 10 && Math.abs(s) > Math.abs(r) && o && ((s > 0 ? 1 : -1) < 0 ? this.showNextImage() : this.showPreviousImage()), this.isDown = !1, requestAnimationFrame(() => {
                this.classList.remove(iF.dragging)
            })
        }
        handleMouseMove() {
            this.isDown && this.classList.add(iF.dragging)
        }
        handleKeyUp(e) {
            "ArrowLeft" === e.code && this.showPreviousImage(), "ArrowRight" === e.code && this.showNextImage()
        }
        handleArrowsClickEvent() {
            this.querySelectorAll(i9.buttonArrow)?.forEach(e => {
                e.addEventListener("click", e => {
                    e.preventDefault(), e.target.hasAttribute(iN.buttonPrev) && this.showPreviousImage(), e.target.hasAttribute(iN.buttonNext) && this.showNextImage()
                })
            })
        }
        resetScrollPosition() {
            0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0)
        }
        initArrows() {
            if (!this.buttons.length) {
                let e = document.createElement("div");
                e.classList.add(iF.arrows), e.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.productMediaList.append(e), this.buttons = this.querySelectorAll(i9.buttonArrow), this.buttonPrev = this.querySelector(`[${iN.buttonPrev}]`), this.buttonNext = this.querySelector(`[${iN.buttonNext}]`)
            }
            this.handleArrowsClickEvent(), this.preloadImageOnArrowHover()
        }
        removeArrows() {
            this.querySelector(`.${iF.arrows}`)?.remove()
        }
        preloadImageOnArrowHover() {
            this.buttonPrev?.addEventListener("mouseover", () => {
                let e = this.getPreviousMediaId();
                this.preloadImage(e)
            }), this.buttonNext?.addEventListener("mouseover", () => {
                let e = this.getNextMediaId();
                this.preloadImage(e)
            })
        }
        preloadImage(e) {
            this.querySelector(`[${iN.mediaId}="${e}"] img`)?.setAttribute("loading", "eager")
        }
        showMediaOnVariantSelect(e) {
            let t = e.detail.id;
            this.setActiveMedia(t)
        }
        getCurrentMedia() {
            return this.querySelector(`${i9.productMedia}.${iF.mediaActive}`)
        }
        getNextMediaId() {
            let e = this.getCurrentMedia(),
                t = e?.nextElementSibling.hasAttribute(iN.imageId) ? e?.nextElementSibling : this.querySelector(i9.productMedia);
            return t?.getAttribute(iN.mediaId)
        }
        getPreviousMediaId() {
            let e = this.getCurrentMedia(),
                t = this.productMediaItems.length - 1,
                i = e?.previousElementSibling || this.productMediaItems[t];
            return i?.getAttribute(iN.mediaId)
        }
        showNextImage() {
            let e = this.getNextMediaId();
            this.selectMedia(e)
        }
        showPreviousImage() {
            let e = this.getPreviousMediaId();
            this.selectMedia(e)
        }
        selectMedia(e) {
            this.dispatchEvent(new CustomEvent("theme:media:select", {
                detail: {
                    id: e
                }
            }))
        }
        setActiveMedia(e) {
            if (!e) return;
            this.setAttribute(iN.activeMedia, e);
            let t = this.querySelector(`${i9.productMedia}.${iF.mediaActive}`),
                i = this.querySelector(`[${iN.mediaId}="${e}"]`),
                s = i?.querySelector(i9.focusedElement),
                r = i.querySelector("deferred-media");
            t?.classList.add(iF.mediaHiding), t?.classList.remove(iF.mediaActive), i?.classList.remove(iF.mediaHiding, iF.mediaHidden), i?.classList.add(iF.mediaActive), r && !0 !== r.getAttribute("loaded") && i.querySelector(i9.deferredMediaButton)?.dispatchEvent(new Event("click", {
                bubbles: !1
            })), requestAnimationFrame(() => {
                this.setHeight(), document.body.classList.contains(iF.isFocused) && s?.focus()
            })
        }
        setHeight() {
            let e = this.querySelector(`${i9.productMedia}.${iF.mediaActive}`)?.offsetHeight || this.productMediaItems[0]?.offsetHeight;
            this.style.setProperty("--height", `${e}px`)
        }
        productMediaObserver() {
            this.productMediaItems.forEach(e => {
                e.addEventListener("transitionend", t => {
                    t.target == e && e.classList.contains(iF.mediaHiding) && (e.classList.remove(iF.mediaHiding), e.classList.add(iF.mediaHidden))
                }), e.addEventListener("transitioncancel", t => {
                    t.target == e && e.classList.contains(iF.mediaHiding) && (e.classList.remove(iF.mediaHiding), e.classList.add(iF.mediaHidden))
                })
            })
        }
    }
    let iR = e => {
            e && (e.style.display = "none")
        },
        iV = {
            optionPosition: "data-option-position",
            optionInput: '[name^="options"], [data-popout-option]',
            optionInputCurrent: '[name^="options"]:checked, [name^="options"][type="hidden"]',
            selectOptionValue: "data-value",
            popout: "[data-popout]"
        },
        iU = {
            soldOut: "sold-out",
            unavailable: "unavailable",
            sale: "sale"
        };
    class iz {
        constructor(e, t) {
            this.container = e, this.productJSON = t, this.optionElements = this.container.querySelectorAll(iV.optionInput), this.productJSON && this.optionElements.length && this.init()
        }
        init() {
            this.update()
        }
        update() {
            this.getCurrentState(), this.optionElements.forEach(e => {
                let t = e.closest(`[${iV.optionPosition}]`);
                if (!t) return;
                let i = e.value || e.getAttribute(iV.selectOptionValue),
                    s = t.getAttribute(iV.optionPosition),
                    r = parseInt(s, 10) - 1,
                    o = e.closest(iV.popout),
                    a = [...this.selections];
                a[r] = i;
                let n = this.productJSON.variants.find(e => {
                    let t = !0;
                    for (let i = 0; i < a.length; i++) e.options[i] !== a[i] && (t = !1);
                    return t
                });
                e.classList.remove(iU.soldOut, iU.unavailable), e.parentNode.classList.remove(iU.sale), o && o.classList.remove(iU.soldOut, iU.unavailable, iU.sale), void 0 === n ? (e.classList.add(iU.unavailable), o && o.classList.add(iU.unavailable)) : n && !1 === n.available && (e.classList.add(iU.soldOut), o && o.classList.add(iU.soldOut)), n && n.compare_at_price > n.price && theme.settings.variantOnSale && e.parentNode.classList.add(iU.sale)
            })
        }
        getCurrentState() {
            this.selections = [];
            let e = this.container.querySelectorAll(iV.optionInputCurrent);
            e.length && e.forEach(e => {
                let t = e.value;
                t && "" !== t && this.selections.push(t)
            })
        }
    }
    let i0 = {
            product: "[data-product]",
            productForm: "[data-product-form]",
            productNotification: "product-notification",
            variantTitle: "[data-variant-title]",
            notificationProduct: "[data-notification-product]",
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            cartPage: "[data-cart-page]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            formWrapper: "[data-form-wrapper]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productImages: "product-images",
            productImage: "[data-product-image]",
            productMediaList: "[data-product-media-list]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            unitPrice: "[data-product-unit-price]",
            unitBase: "[data-product-base]",
            unitWrapper: "[data-product-unit]",
            isPreOrder: "[data-product-preorder]",
            productSlide: ".product__slide",
            subPrices: "[data-subscription-watch-price]",
            subSelectors: "[data-subscription-selectors]",
            subsToggle: "[data-toggles-group]",
            subsChild: "data-group-toggle",
            subDescription: "[data-plan-description]",
            section: "[data-section-type]",
            variantSku: "[data-variant-sku]",
            variantFinalSaleMeta: "[data-variant-final-sale-metafield]",
            variantButtons: "[data-variant-buttons]",
            variantOptionImage: "[data-variant-option-image]",
            quickAddModal: "[data-quick-add-modal]",
            priceOffWrap: "[data-price-off]",
            priceOffType: "[data-price-off-type]",
            priceOffAmount: "[data-price-off-amount]",
            remainingCount: "[data-remaining-count]",
            remainingMax: "[data-remaining-max]",
            remainingWrapper: "[data-remaining-wrapper]",
            remainingJSON: "[data-product-remaining-json]",
            optionValue: "[data-option-value]",
            optionPosition: "[data-option-position]",
            installment: "[data-product-form-installment]",
            inputId: 'input[name="id"]'
        },
        ij = {
            hidden: "hidden",
            variantSoldOut: "variant--soldout",
            variantUnavailable: "variant--unavailable",
            productPriceSale: "product__price--sale",
            remainingLow: "count-is-low",
            remainingIn: "count-is-in",
            remainingOut: "count-is-out",
            remainingUnavailable: "count-is-unavailable"
        },
        i3 = {
            remainingMaxAttr: "data-remaining-max",
            enableHistoryState: "data-enable-history-state",
            notificationPopup: "data-notification-popup",
            faderDesktop: "data-fader-desktop",
            faderMobile: "data-fader-mobile",
            optionPosition: "data-option-position",
            imageId: "data-image-id",
            mediaId: "data-media-id",
            quickAddButton: "data-quick-add-btn",
            finalSale: "data-final-sale",
            variantImageScroll: "data-variant-image-scroll"
        };
    class i2 extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            if (this.cartAddEvents(), this.container = this.closest(i0.section) || this.closest(i0.quickAddModal), !this.container) return;
            if (this.sectionId = this.container.dataset.sectionId, this.product = this.container.querySelector(i0.product), this.productForm = this.container.querySelector(i0.productForm), this.productNotification = this.container.querySelector(i0.productNotification), this.productImages = this.container.querySelector(i0.productImages), this.productMediaList = this.container.querySelector(i0.productMediaList), this.installmentForm = this.container.querySelector(i0.installment), this.skuWrapper = this.container.querySelector(i0.variantSku), this.sellout = null, this.variantImageScroll = "true" === this.container.getAttribute(i3.variantImageScroll), this.priceOffWrap = this.container.querySelector(i0.priceOffWrap), this.priceOffAmount = this.container.querySelector(i0.priceOffAmount), this.priceOffType = this.container.querySelector(i0.priceOffType), this.planDescription = this.container.querySelector(i0.subDescription), this.remainingWrapper = this.container.querySelector(i0.remainingWrapper), this.remainingWrapper) {
                let e = this.container.querySelector(i0.remainingMax);
                e && (this.remainingMaxInt = parseInt(e.getAttribute(i3.remainingMaxAttr), 10), this.remainingCount = this.container.querySelector(i0.remainingCount), this.remainingJSONWrapper = this.container.querySelector(i0.remainingJSON), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON"))
            }
            this.enableHistoryState = "true" === this.container.getAttribute(i3.enableHistoryState), this.hasUnitPricing = this.container.querySelector(i0.unitWrapper), this.subSelectors = this.container.querySelector(i0.subSelectors), this.subPrices = this.container.querySelector(i0.subPrices), this.isPreOrder = this.container.querySelector(i0.isPreOrder);
            let t = null,
                i = this.container.querySelector(i0.productJson);
            i && (t = i.innerHTML), t ? (this.productJSON = JSON.parse(t), this.linkForm(), this.sellout = new iz(this.container, this.productJSON)) : console.error("Missing product JSON"), this.variantOptionImages = this.container.querySelectorAll(i0.variantOptionImage), this.variantButtons = this.container.querySelectorAll(i0.variantButtons), this.variantOptionImages.length > 1 && this.optionImagesWidth()
        }
        cartAddEvents() {
            this.buttonATC = this.querySelector(i0.addToCart), this.buttonATC.addEventListener("click", e => {
                e.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    },
                    bubbles: !1
                })), this.closest(i0.quickAddModal) || (window.accessibility.lastElement = this.buttonATC)
            })
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new ir(this.container, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(e) {
            this.pushState(e.dataset), this.updateProductImage(e)
        }
        onPlanChange(e) {
            this.subPrices && this.pushState(e.dataset)
        }
        pushState(e, t = !1) {
            this.productState = this.setProductState(e), this.updateAddToCartState(e), this.updateNotificationForm(e), this.updateProductPrices(e), this.updateSaleText(e), this.updateSku(e), this.updateSubscriptionText(e), this.updateRemaining(e), this.updateLegend(e), this.fireHookEvent(e), this.sellout?.update(e), this.enableHistoryState && !t && this.updateHistoryState(e)
        }
        updateAddToCartState(e) {
            let t = e.variant,
                i = theme.strings.addToCart,
                s = this.container.querySelectorAll(i0.priceWrapper),
                r = this.container.querySelectorAll(i0.addToCart),
                o = this.container.querySelectorAll(i0.addToCartText),
                a = this.container.querySelectorAll(i0.formWrapper);
            if (this.installmentForm && t) {
                let n = this.installmentForm.querySelector(i0.inputId);
                n.value = t.id, n.dispatchEvent(new Event("change", {
                    bubbles: !0
                }))
            }
            this.isPreOrder && (i = theme.strings.preOrder), s.length && t && s.forEach(e => {
                e.classList.remove(ij.hidden)
            }), r?.forEach(e => {
                e.hasAttribute(i3.quickAddButton) || (t && t.available ? e.disabled = !1 : e.disabled = !0)
            }), o?.forEach(e => {
                let s = i;
                t ? t.available || (s = theme.strings.soldOut) : s = theme.strings.unavailable, e.textContent = s
            }), a.length && a.forEach(e => {
                if (t) {
                    t.available ? e.classList.remove(ij.variantSoldOut, ij.variantUnavailable) : (e.classList.add(ij.variantSoldOut), e.classList.remove(ij.variantUnavailable));
                    let i = e.querySelector(i0.originalSelectorId);
                    i && (i.value = t.id);
                    let s = e.querySelector(`${i0.inputId}[form]`);
                    s && (s.value = t.id, s.dispatchEvent(new Event("change")))
                } else e.classList.add(ij.variantUnavailable), e.classList.remove(ij.variantSoldOut)
            })
        }
        updateNotificationForm(e) {
            if (!this.productNotification) return;
            let t = this.productNotification.querySelector(i0.variantTitle),
                i = this.productNotification.querySelector(i0.notificationProduct);
            null != t && (t.textContent = e.variant.title, i.value = e.variant.name)
        }
        updateHistoryState(e) {
            let t = e.variant,
                i = e.plan,
                s = window.location.href;
            if (t && s.includes("/product")) {
                let r = new window.URL(s),
                    o = r.searchParams;
                o.set("variant", t.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), r.search = o.toString();
                let a = r.toString();
                window.history.replaceState({
                    path: a
                }, "", a)
                GPOConfigs?.initialize?.();
            }
        }
        updateRemaining(e) {
            let t = e.variant;
            if (this.remainingWrapper?.classList.remove(ij.remainingIn, ij.remainingOut, ij.remainingUnavailable, ij.remainingLow), t && this.remainingWrapper && this.remainingJSON) {
                let i = this.remainingJSON[t.id];
                ("out" === i || i < 1) && this.remainingWrapper.classList.add(ij.remainingOut), ("in" === i || i >= this.remainingMaxInt) && this.remainingWrapper.classList.add(ij.remainingIn), ("low" === i || i > 0 && i < this.remainingMaxInt) && (this.remainingWrapper.classList.add(ij.remainingLow), this.remainingCount && (this.remainingCount.innerHTML = i))
            } else !t && this.remainingWrapper && this.remainingWrapper.classList.add(ij.remainingUnavailable)
        }
        optionImagesWidth() {
            if (!this.variantButtons) return;
            let e = 0;
            requestAnimationFrame(() => {
                this.variantOptionImages.forEach(t => {
                    let i = t.clientWidth;
                    i > e && (e = i)
                }), this.variantButtons.forEach(t => {
                    t.style?.setProperty("--option-image-width", e + "px")
                })
            })
        }
        getBaseUnit(e) {
            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            let e = this.container.querySelectorAll(i0.subsToggle);
            e.forEach(e => {
                e.addEventListener("change", (function(e) {
                    let t = e.target.value.toString(),
                        i = this.container.querySelector(`[${i0.subsChild}="${t}"]`),
                        s = this.container.querySelectorAll(`[${i0.subsChild}]`);
                    if (i) {
                        i.classList.remove(ij.hidden);
                        let r = i.querySelector('[name="selling_plan"]');
                        r.checked = !0, r.dispatchEvent(new Event("change"))
                    }
                    s.forEach(e => {
                        if (e !== i) {
                            e.classList.add(ij.hidden);
                            let t = e.querySelectorAll('[name="selling_plan"]');
                            t.forEach(e => {
                                e.checked = !1, e.dispatchEvent(new Event("change"))
                            })
                        }
                    })
                }).bind(this))
            })
        }
        updateSaleText(e) {
            this.productState.planSale ? this.updateSaleTextSubscription(e) : this.productState.onSale ? this.updateSaleTextStandard(e) : this.priceOffWrap && this.priceOffWrap.classList.add(ij.hidden)
        }
        isVariantFinalSale(e) {
            let t = document.querySelector(i0.variantFinalSaleMeta).textContent,
                i = JSON.parse(t),
                s = !1;
            return i.forEach(t => {
                Number(t.variant_id) === e.id && (s = "true" === t.metafield_value)
            }), s
        }
        updateSaleTextStandard(e) {
            let t = e.variant;
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap) {
                let i = (t.compare_at_price - t.price) / 100;
                this.priceOffAmount.innerHTML = `$${i.toFixed(2)}`, this.priceOffWrap.classList.remove(ij.hidden)
            }
            this.priceOffWrap.hasAttribute(i3.finalSale) || this.isVariantFinalSale(t) ? this.priceOffWrap.classList.remove(ij.hidden) : this.priceOffWrap.classList.add(ij.hidden)
        }
        updateSubscriptionText(e) {
            e.plan && this.planDescription ? (this.planDescription.innerHTML = e.plan.detail.description, this.planDescription.classList.remove(ij.hidden)) : this.planDescription && this.planDescription.classList.add(ij.hidden)
        }
        updateSaleTextSubscription(e) {
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap) {
                let t = e.plan.detail.price_adjustments[0],
                    i = t.value;
                t && "percentage" === t.value_type ? this.priceOffAmount.innerHTML = `${i}%` : this.priceOffAmount.innerHTML = ek(i, theme.moneyFormat), this.priceOffWrap.classList.remove(ij.hidden)
            }
        }
        updateProductPrices(e) {
            let t = e.variant,
                i = e.plan,
                s = this.container.querySelectorAll(i0.priceWrapper);
            s.forEach(e => {
                let s = e.querySelector(i0.comparePrice),
                    r = e.querySelector(i0.productPrice),
                    o = e.querySelector(i0.comparePriceText),
                    a = "",
                    n = "";
                this.productState.available && (a = t.compare_at_price, n = t.price), this.productState.hasPlan && (n = i.allocation.price), this.productState.planSale && (a = i.allocation.compare_at_price, n = i.allocation.price), s && (this.productState.onSale || this.productState.planSale ? (s.classList.remove(ij.hidden), o.classList.remove(ij.hidden), r.classList.add(ij.productPriceSale)) : (s.classList.add(ij.hidden), o.classList.add(ij.hidden), r.classList.remove(ij.productPriceSale)), s.innerHTML = ek(a, theme.moneyFormat)), r.innerHTML = 0 === n ? window.theme.strings.free : ek(n, theme.moneyFormat)
            }), this.hasUnitPricing && this.updateProductUnits(e)
        }
        updateProductUnits(e) {
            let t = e.variant,
                i = e.plan,
                s = null;
            if (t && t.unit_price && (s = t.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s) {
                let r = this.getBaseUnit(t),
                    o = ek(s, theme.moneyFormat);
                this.container.querySelector(i0.unitPrice).innerHTML = o, this.container.querySelector(i0.unitBase).innerHTML = r, ew(this.container.querySelector(i0.unitWrapper))
            } else iR(this.container.querySelector(i0.unitWrapper))
        }
        updateSku(e) {
            this.skuWrapper && (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${e.variant.sku}`)
        }
        fireHookEvent(e) {
            let t = e.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: t
                },
                bubbles: !0
            }))
        }
        setProductState(e) {
            let t = e.variant,
                i = e.plan,
                s = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            return t && (!t.requires_selling_plan || i) ? (t.available || (s.soldOut = !0), t.compare_at_price > t.price && (s.onSale = !0), t.unit_price && (s.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), t.price > i.allocation.price && (s.planSale = !0))) : s.available = !1, s
        }
        updateProductImage(e) {
            let t = e.dataset.variant;
            if (t && t.featured_media) {
                let i = this.container.querySelector(`[${i3.imageId}="${t.featured_media.id}"]`);
                if (i) {
                    let s = i.getAttribute(i3.mediaId),
                        r = b();
                    if (i.dispatchEvent(new CustomEvent("theme:media:select", {
                            bubbles: !0,
                            detail: {
                                id: s
                            }
                        })), r && !this.productImages.hasAttribute(i3.faderDesktop) && this.variantImageScroll) {
                        let o = i.getBoundingClientRect().top;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                            bubbles: !1,
                            detail: {
                                hideTransition: !1
                            }
                        })), tg(o)
                    }
                    r || this.productImages.hasAttribute(i3.faderMobile) || this.productMediaList.scrollTo({
                        left: i.offsetLeft
                    })
                }
            }
        }
        updateLegend(e) {
            let t = e.variant;
            if (t) {
                let i = this.container.querySelectorAll(i0.optionValue);
                i.length && i.forEach(e => {
                    let i = e.closest(i0.optionPosition);
                    if (i) {
                        let s = i.getAttribute(i3.optionPosition),
                            r = parseInt(s, 10) - 1,
                            o = t.options[r];
                        e.innerHTML = o
                    }
                })
            }
        }
    }
    let iX = {
            open: "[data-popup-open]",
            close: "[data-popup-close]",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
        },
        i1 = {
            closing: "closing"
        };
    class iG {
        constructor(e, t, i = !0, s = !0) {
            this.popup = e, this.holder = t, this.a11y = F, this.isAnimating = !1, this.showModal = i, this.enableScrollLock = s, this.buttonPopupOpen = this.holder?.querySelector(iX.open), this.popupEvents()
        }
        popupOpen() {
            this.popup && (this.isAnimating = !0, this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show ? this.popup.setAttribute("open", "") : this.popup.show(), this.popup.removeAttribute("inert"), this.popup.focus(), this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), e_(this.popup).then(() => {
                this.isAnimating = !1, this.enableScrollLock && this.a11y.trapFocus(this.popup);
                let e = this.popup.querySelector("[autofocus]") || this.popup.querySelector(iX.focusable);
                e?.focus()
            }))
        }
        popupClose() {
            if (!(this.isAnimating || !this.popup || this.popup.hasAttribute("inert"))) {
                if (!this.popup.hasAttribute(i1.closing)) {
                    this.popup.setAttribute(i1.closing, ""), this.isAnimating = !0, e_(this.popup).then(() => {
                        this.isAnimating = !1, this.popupClose()
                    });
                    return
                }
                "function" == typeof this.popup.close ? this.popup.close() : this.popup.removeAttribute("open"), this.popupCloseActions()
            }
        }
        popupCloseActions() {
            !this.popup.hasAttribute("inert") && (this.popup.setAttribute("inert", ""), this.popup.removeAttribute(i1.closing), !iT() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", {
                bubbles: !1
            })), this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()))
        }
        popupEvents() {
            if (!this.popup) return;
            this.buttonPopupOpen?.addEventListener("click", e => {
                e.preventDefault(), this.popupOpen(), window.accessibility.lastElement = this.buttonPopupOpen
            });
            let e = this.popup.querySelectorAll(iX.close);
            e.length && e.forEach(e => {
                e.addEventListener("click", e => {
                    e.preventDefault(), this.popupClose()
                })
            }), this.showModal && this.popup.addEventListener("click", e => {
                "DIALOG" === e.target.nodeName && "click" === e.type && this.popupClose()
            }), this.popup.addEventListener("keydown", e => {
                "Escape" === e.code && (e.preventDefault(), this.popupClose())
            }), this.popup.addEventListener("close", () => this.popupCloseActions())
        }
    }
    let i4 = {
        dialog: "dialog"
    };
    class iJ extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            new iG(this.querySelector(i4.dialog), this, !0, !0)
        }
    }
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }, ])
        },
        setupShopifyXR(e) {
            if (!e) {
                if (!window.ShopifyXR) {
                    document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
                    return
                }
                document.querySelectorAll('[id^="ModelJSON-"]').forEach(e => {
                    window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
                }), window.ShopifyXR.setupXRElements()
            }
        }
    }, window.addEventListener("DOMContentLoaded", () => {
        window.ProductModel && window.ProductModel.loadShopifyXR()
    });
    let iY = {
            addToCart: "[data-add-to-cart]",
            productImage: "[data-product-image]",
            productJson: "[data-product-json]",
            form: "[data-product-form]",
            cartBar: "#cart-bar",
            productNotificationPopupButton: "[data-popup-open]",
            productSubmitAdd: ".product__submit__add",
            formWrapper: "[data-form-wrapper]",
            productVariants: "[data-product-variants]",
            slider: "[data-slider]"
        },
        iQ = {
            expanded: "is-expanded",
            visible: "is-visible",
            loading: "is-loading",
            added: "is-added"
        },
        i5 = {
            cartBarEnabled: "data-cart-bar-enabled",
            cartBarAdd: "data-add-to-cart-bar",
            cartBarScroll: "data-cart-bar-scroll",
            cartBarProductNotification: "data-cart-bar-product-notification",
            sectionId: "data-section-id",
            sliderIndex: "data-slider-index"
        },
        i6 = {};
    class i7 {
        constructor(e) {
            this.section = e, this.container = e.container, this.id = this.container.getAttribute(i5.sectionId), this.sliders = this.container.querySelectorAll(iY.slider), this.slider = [], this.formWrapper = this.container.querySelector(iY.formWrapper), this.cartBarEnabled = this.container.hasAttribute(i5.cartBarEnabled), this.cartBar = this.container.querySelector(iY.cartBar), this.setCartBarHeight = this.setCartBarHeight.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this), this.unlockTimer = 0, this.accessibility = F;
            let t = this.container.querySelector(iY.productJson);
            if (t && !t.innerHTML || !t) return;
            let i = JSON.parse(t.innerHTML).handle,
                s = {};
            i && (s = {
                handle: i
            }), Shopify.Products.recordRecentlyViewed(s), this.form = this.container.querySelector(iY.form), this.sliders.length && this.sliders.forEach((e, t) => {
                e.setAttribute(i5.sliderIndex, t), this.slider.push(new tp(this.container, e))
            }), this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight))
        }
        initCartBar() {
            this.cartBarBtns = this.cartBar.querySelectorAll(iY.productSubmitAdd), this.cartBarBtns.length > 0 && this.cartBarBtns.forEach(e => {
                e.addEventListener("click", e => {
                    e.preventDefault(), e.currentTarget.hasAttribute(i5.cartBarAdd) ? (this.cartBarEnabled && (e.currentTarget.classList.add(iQ.loading), e.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector(iY.addToCart).dispatchEvent(new Event("click", {
                        bubbles: !0
                    }))) : e.currentTarget.hasAttribute(i5.cartBarScroll) ? this.scrollToTop() : e.currentTarget.hasAttribute(i5.cartBarProductNotification) && this.container.querySelector(iY.productNotificationPopupButton).dispatchEvent(new Event("click"))
                }), e.hasAttribute(i5.cartBarAdd) && document.addEventListener("theme:product:add-error", this.scrollToTop)
            }), this.setCartBarHeight()
        }
        scrollToTop() {
            let e = this.container.querySelector(iY.productVariants),
                t = b() ? this.container : e || this.form,
                i = t.getBoundingClientRect().top;
            tg(b() ? i : i - 10)
        }
        toggleCartBarOnScroll() {
            let e = window.scrollY,
                t = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
            if (t && this.cartBar) {
                let i = t.offsetTop,
                    s = t.offsetHeight;
                this.cartBar.classList.toggle(iQ.visible, e > i + s)
            }
        }
        setCartBarHeight() {
            let e = this.cartBar.offsetHeight;
            document.documentElement.style.setProperty("--cart-bar-height", `${e}px`)
        }
        onUnload() {
            document.removeEventListener("theme:product:add-error", this.scrollToTop), this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight))
        }
        onBlockSelect(e) {
            let t = e.srcElement.closest(iY.slider);
            if (t && this.slider.length) {
                let i = t.hasAttribute(i5.sliderIndex) ? t.getAttribute(i5.sliderIndex) : 0;
                if (!this.slider[i]) return;
                this.slider[i].onBlockSelect(e)
            }
        }
        onBlockDeselect(e) {
            let t = e.srcElement.closest(iY.slider);
            if (t && this.slider.length) {
                let i = t.hasAttribute(i5.sliderIndex) ? t.getAttribute(i5.sliderIndex) : 0;
                if (!this.slider[i]) return;
                this.slider[i].onBlockDeselect(e)
            }
        }
    }
    e6("product", [{
        onLoad() {
            i6[this.id] = new i7(this)
        },
        onUnload(e) {
            i6[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            i6[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            i6[this.id].onBlockDeselect(e)
        }
    }, ta, iC, {
        onLoad() {
            iD[this.id] = new i8(this)
        },
        onUnload() {
            iD[this.id].onUnload()
        }
    }]), customElements.get("product-form") || customElements.define("product-form", i2), customElements.get("product-images") || customElements.define("product-images", iW), customElements.get("product-modal") || customElements.define("product-modal", iJ), customElements.get("product-model") || customElements.define("product-model", class e extends eo {
        constructor() {
            super()
        }
        loadContent() {
            super.loadContent(), Shopify.loadFeatures([{
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this.setupModelViewerUI.bind(this)
            }, ])
        }
        setupModelViewerUI(e) {
            e || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
        }
    }), customElements.get("product-siblings") || customElements.define("product-siblings", iS), customElements.get("radio-swatch") || customElements.define("radio-swatch", ip), customElements.get("recipient-form") || customElements.define("recipient-form", iH);
    let iK = {
            apiRelatedProductsTemplate: "[data-api-related-template]",
            relatedSection: "[data-related-section]",
            relatedProduct: "[data-grid-item]",
            recentlyViewed: "[data-recent-wrapper]",
            recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
            productItem: ".product-item",
            slider: "grid-slider"
        },
        iZ = {
            limit: "data-limit",
            minimum: "data-minimum",
            productId: "data-product-id"
        },
        se = {
            isHidden: "is-hidden",
            gridMobileSlider: "grid--mobile-slider"
        },
        st = {};
    class si {
        constructor(e) {
            this.section = e, this.sectionId = e.id, this.container = e.container, this.related(), this.recent()
        }
        related() {
            let e = this.container.querySelector(iK.relatedSection);
            if (!e) return;
            let t = e.getAttribute(iZ.productId),
                i = e.getAttribute(iZ.limit),
                s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${t}&intent=related`;
            fetch(s).then(e => e.text()).then(t => {
                let i = document.createElement("div");
                i.innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(iK.apiRelatedProductsTemplate).innerHTML;
                let s = i.querySelector(iK.relatedProduct);
                if (s) {
                    e.innerHTML = i.innerHTML;
                    let r = parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE"));
                    if (0 === r) {
                        let o = e.querySelector(iK.relatedProduct);
                        o.parentElement.classList.add(se.gridMobileSlider)
                    }
                } else e.dispatchEvent(new CustomEvent("theme:tab:hide", {
                    bubbles: !0
                }))
            }).catch(function() {
                e.dispatchEvent(new CustomEvent("theme:tab:hide", {
                    bubbles: !0
                }))
            })
        }
        recent() {
            let e = this.container.querySelector(iK.recentlyViewed),
                t = e ? parseInt(e.getAttribute(iZ.limit)) : 4;
            Shopify.Products.showRecentlyViewed({
                howManyToShow: t,
                wrapperId: `recently-viewed-products-${this.sectionId}`,
                section: this.section,
                target: "api-product-grid-item",
                onComplete(e, t) {
                    let i = t.container;
                    if (!i) return;
                    let s = i.querySelector(iK.recentlyViewed),
                        r = i.querySelector(iK.recentlyViewedWrapper),
                        o = e.querySelectorAll(iK.productItem),
                        a = s.querySelector(iK.slider),
                        n = s.hasAttribute(iZ.minimum) ? parseInt(s.getAttribute(iZ.minimum)) : 4,
                        l = !r && o.length > 0,
                        d = r && o.length >= n;
                    (l || d) && (d && r.classList.remove(se.isHidden), s.classList.remove("is-hidden"), s.dispatchEvent(new CustomEvent("theme:tab:check", {
                        bubbles: !0
                    })), a && a.dispatchEvent(new CustomEvent("theme:grid-slider:init", {
                        bubbles: !0
                    })))
                }
            })
        }
    }
    e6("related", [{
        onLoad() {
            st[this.id] = new si(this)
        }
    }, iC]), e6("reviews", [tm, t5]);
    let ss = {},
        sr = {
            sliderLogos: "[data-slider-logos]",
            sliderText: "[data-slider-text]",
            slide: "[data-slide]"
        },
        so = {
            isSelected: "is-selected",
            isInitialized: "is-initialized",
            flickityEnabled: "flickity-enabled"
        },
        sa = {
            slideData: "data-slide",
            slideIndex: "data-slide-index"
        };
    class sn {
        constructor(e) {
            this.container = e.container, this.slideshowNav = this.container.querySelector(sr.sliderLogos), this.slideshowText = this.container.querySelector(sr.sliderText), this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState(), this.flkty = null, this.flktyNav = null, this.logoSlides = this.slideshowNav.querySelectorAll(sr.slide), this.logoSlidesWidth = this.getSlidesWidth(), this.initSlideshowText(), this.initSlideshowNav()
        }
        getSlidesWidth() {
            let e = this.logoSlides.length;
            return 200 * e
        }
        initSlideshowText() {
            this.slideshowText && (this.flkty = new s(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: .2,
                friction: .6,
                draggable: !1,
                accessibility: !1,
                on: {
                    ready: () => this.sliderAccessibility(),
                    change: () => this.sliderAccessibility()
                }
            }))
        }
        sliderAccessibility() {
            let e = this.slideshowText.querySelectorAll(`${sr.slide} a, ${sr.slide} button`);
            e.length && e.forEach(e => {
                let t = e.closest(sr.slide);
                if (t) {
                    let i = t.classList.contains(so.isSelected) ? 0 : -1;
                    e.setAttribute("tabindex", i)
                }
            })
        }
        initSlideshowNav() {
            this.slideshowNav && (this.logoSlides.length && this.logoSlides.forEach(e => {
                e.addEventListener("click", () => {
                    let t = parseInt(e.getAttribute(sa.slideIndex)),
                        i = this.slideshowNav.classList.contains(so.flickityEnabled);
                    if (this.flkty && this.flkty.select(t), i) this.flktyNav.select(t), this.slideshowNav.classList.contains(so.isSelected) || this.flktyNav.playPlayer();
                    else {
                        let s = this.slideshowNav.querySelector(`.${so.isSelected}`);
                        s && s.classList.remove(so.isSelected), e.classList.add(so.isSelected)
                    }
                })
            }), this.setSlideshowNavState(), document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize))
        }
        setSlideshowNavState() {
            let e = this.slideshowNav.classList.contains(so.flickityEnabled);
            if (this.logoSlidesWidth > g()) {
                if (!e) {
                    this.slideshowNav.classList.add(so.isInitialized);
                    let t = this.slideshowNav.querySelector(`.${so.isSelected}`);
                    t && t.classList.remove(so.isSelected), this.logoSlides[0].classList.add(so.isSelected), !this.flktyNav && (this.flktyNav = new i(this.slideshowNav, {
                        autoPlay: 4e3,
                        prevNextButtons: !1,
                        contain: !1,
                        pageDots: !1,
                        wrapAround: !0,
                        watchCSS: !0,
                        selectedAttraction: .05,
                        friction: .8,
                        initialIndex: 0
                    }), this.flktyNav.on("deactivate", () => {
                        this.slideshowNav.querySelector(sr.slide).classList.add(so.isSelected), this.flkty && this.flkty.select(0)
                    }), this.flkty && (this.flkty.select(0), this.flktyNav.on("change", e => this.flkty.select(e))))
                }
            } else e && this.slideshowNav.classList.remove(so.isInitialized)
        }
        onBlockSelect(e) {
            if (!this.slideshowNav) return;
            let t = this.slideshowNav.querySelector(`[${sa.slideData}="${e.detail.blockId}"]`),
                i = parseInt(t.getAttribute(sa.slideIndex));
            this.slideshowNav.classList.contains(so.flickityEnabled) ? (this.flktyNav.select(i), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(so.isSelected)) : t.dispatchEvent(new Event("click"))
        }
        onBlockDeselect() {
            this.slideshowNav && this.slideshowNav.classList.contains(so.flickityEnabled) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(so.isSelected))
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize)
        }
    }
    e6("logos", [{
        onLoad() {
            ss[this.id] = new sn(this)
        },
        onUnload(e) {
            ss[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            ss[this.id].onBlockSelect(e)
        },
        onBlockDeselect(e) {
            ss[this.id].onBlockDeselect(e)
        }
    }, t5]);
    let sl = {};

    function sd(e = {}) {
        if (e.type || (e.type = "json"), e.url) return sl[e.url] ? sl[e.url] : function e(t, i) {
            let s = new Promise((e, s) => {
                if ("text" === i) fetch(t).then(e => e.text()).then(t => {
                    e(t)
                }).catch(e => {
                    s(e)
                });
                else {
                    var r, o, a;
                    let n, l, d;
                    r = t, o = function() {
                        e()
                    }, a = function() {
                        s()
                    }, n = document.getElementsByTagName("head")[0], l = !1, (d = document.createElement("script")).src = r, d.onload = d.onreadystatechange = function() {
                        l || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? a() : (l = !0, o())
                    }, n.appendChild(d)
                }
            });
            return sl[t] = s, s
        }(e.url, e.type);
        if (e.json) return sl[e.json] ? Promise.resolve(sl[e.json]) : window.fetch(e.json).then(e => e.json()).then(t => (sl[e.json] = t, t));
        if (!e.name) return Promise.reject();
        {
            let t = "".concat(e.name, e.version);
            return sl[t] ? sl[t] : function e(t) {
                let i = "".concat(t.name, t.version),
                    s = new Promise((e, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad(t) {
                                    var s, r, o;
                                    s = e, r = i, o = t, o ? r(o) : s()
                                }
                            }, ])
                        } catch (s) {
                            i(s)
                        }
                    });
                return sl[i] = s, s
            }(e)
        }
    }
    window.isYoutubeAPILoaded = !1, window.isVimeoAPILoaded = !1;
    let sc = {
            popupContainer: ".pswp",
            popupCloseBtn: ".pswp__custom-close",
            popupIframe: "iframe, video",
            popupThumbs: ".pswp__thumbs",
            popupButtons: ".pswp__button, .pswp__caption-close"
        },
        sh = {
            current: "is-current",
            customLoader: "pswp--custom-loader",
            customOpen: "pswp--custom-opening",
            loader: "pswp__loader",
            popupCloseButton: "pswp__button--close",
            isFocused: "is-focused"
        },
        su = {
            dataOptionClasses: "data-pswp-option-classes",
            ariaCurrent: "aria-current"
        },
        sp = `<div class="${sh.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    class sm {
        constructor(e, t = "") {
            this.items = e, this.pswpElement = document.querySelectorAll(sc.popupContainer)[0], this.popup = null, this.popupThumbs = null, this.popupThumbsContainer = this.pswpElement.querySelector(sc.popupThumbs), this.closeBtn = this.pswpElement.querySelector(sc.popupCloseBtn), this.keyupCloseEvent = e => this.keyupClose(e), this.a11y = F, this.options = "" !== t ? t : {
                history: !1,
                focus: !1,
                mainClass: ""
            }, this.init()
        }
        init() {
            this.pswpElement.classList.add(sh.customOpen), this.initLoader(), sd({
                url: window.theme.assets.photoswipe
            }).then(() => this.loadPopup()).catch(e => console.error(e))
        }
        initLoader() {
            if (this.pswpElement.classList.contains(sh.customLoader) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(su.dataOptionClasses, this.options.mainClass);
                let e = document.createElement("div");
                e.innerHTML = sp, e = e.firstChild, this.pswpElement.appendChild(e)
            } else this.pswpElement.setAttribute(su.dataOptionClasses, "")
        }
        loadPopup() {
            let e = window.themePhotoswipe.PhotoSwipe.default,
                t = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(sh.customLoader) && this.pswpElement.classList.remove(sh.customLoader), this.pswpElement.classList.remove(sh.customOpen), this.popup = new e(this.pswpElement, t, this.items, this.options), this.popup.init(), this.thumbsActions(), document.body.classList.contains(sh.isFocused) && setTimeout(() => {
                this.a11y.trapFocus(this.pswpElement, {
                    elementToFocus: this.closeBtn
                })
            }, 200), this.popup.listen("close", () => this.onClose()), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach(e => {
                let t = this.pswpElement.querySelector(`.pswp__${e}`);
                t && t.addEventListener("keyup", this.keyupCloseEvent)
            })
        }
        thumbsActions() {
            this.popupThumbsContainer && this.popupThumbsContainer.children.length && (this.popupThumbsContainer.addEventListener("wheel", e => this.stopDisabledScroll(e)), this.popupThumbsContainer.addEventListener("mousewheel", e => this.stopDisabledScroll(e)), this.popupThumbsContainer.addEventListener("DOMMouseScroll", e => this.stopDisabledScroll(e)), this.popupThumbs = this.pswpElement.querySelectorAll(`${sc.popupThumbs} > *`), this.popupThumbs.forEach((e, t) => {
                e.addEventListener("click", i => {
                    i.preventDefault();
                    let s = e.parentElement.querySelector(`.${sh.current}`);
                    s.classList.remove(sh.current), s.setAttribute(su.ariaCurrent, !1), e.classList.add(sh.current), e.setAttribute(su.ariaCurrent, !0), this.popup.goTo(t)
                })
            }), this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()), this.popup.listen("beforeChange", () => this.setCurrentThumb()))
        }
        stopDisabledScroll(e) {
            e.stopPropagation()
        }
        keyupClose(e) {
            "Enter" === e.code && this.popup.close()
        }
        onClose() {
            let e = this.pswpElement.querySelector(sc.popupIframe);
            if (e && e.parentNode.removeChild(e), this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                for (; this.popupThumbsContainer.firstChild;) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(su.dataOptionClasses, "");
            let t = this.pswpElement.querySelector(`.${sh.loader}`);
            t && this.pswpElement.removeChild(t), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach(e => {
                let t = this.pswpElement.querySelector(`.pswp__${e}`);
                t && t.removeEventListener("keyup", this.keyupCloseEvent)
            }), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
        }
        setCurrentThumb() {
            let e = this.pswpElement.querySelector(`${sc.popupThumbs} > .${sh.current}`);
            if (e && (e.classList.remove(sh.current), e.setAttribute(su.ariaCurrent, !1)), !this.popupThumbs) return;
            let t = this.popupThumbs[this.popup.getCurrentIndex()];
            t.classList.add(sh.current), t.setAttribute(su.ariaCurrent, !0), this.scrollThumbs(t)
        }
        scrollThumbs(e) {
            let t = this.popupThumbsContainer.scrollLeft,
                i = this.popupThumbsContainer.offsetWidth,
                s = t + i,
                r = e.offsetLeft,
                o = e.offsetWidth;
            if (s <= r + o || s > r) {
                let a = parseInt(window.getComputedStyle(e).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: r - a,
                    behavior: "smooth"
                })
            }
        }
    }
    let sg = {
        videoPlay: "data-video-play"
    };
    class sv extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.videoPlay = this.querySelectorAll(`[${sg.videoPlay}]`), this.videoPlay?.forEach(e => {
                e.addEventListener("click", e => {
                    let t = e.currentTarget;
                    if ("" !== t.getAttribute(sg.videoPlay).trim()) {
                        e.preventDefault();
                        let i = [{
                            html: t.getAttribute(sg.videoPlay)
                        }, ];
                        new sm(i, {
                            mainClass: "pswp--video"
                        }), window.accessibility.lastElement = t
                    }
                })
            })
        }
    }
    let sb = {
            videoTemplate: "[data-video-template]"
        },
        sy = {
            loading: "is-loading"
        },
        sf = {
            videoId: "data-video-id"
        };
    class sS extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.videoId = this.getAttribute(sf.videoId), this.videoTemplate = this.querySelector(sb.videoTemplate), this.video = null, this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this), this.videoId && this.renderVideo()
        }
        powerSaverVideoPlay() {
            this.video?.play()
        }
        renderVideo() {
            this.videoTemplateObserver = new IntersectionObserver((e, t) => {
                e.forEach(e => {
                    if (e.isIntersecting) {
                        let i = this.videoTemplate.innerHTML;
                        this.innerHTML = i, this.classList.remove(sy.loading), this.video = this.querySelector("video"), this.observeVideoPlayToggle(), this.video.play().then(() => {}).catch(() => {
                            document.addEventListener("click", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            }), document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                                passive: !0,
                                bubbles: !0,
                                once: !0
                            })
                        }), t.unobserve(e.target)
                    }
                })
            }, {
                root: null,
                rootMargin: "300px",
                threshold: [0, .1, .25, .5, .75, 1]
            }), this.videoTemplateObserver.observe(this)
        }
        observeVideoPlayToggle() {
            this.video && (this.videoPlayObserver = new IntersectionObserver(e => {
                e.forEach(e => {
                    let t = e.isIntersecting;
                    if (t && "function" == typeof this.video.play) {
                        let i = this.video.play();
                        void 0 !== i && i.then(e => {}).catch(e => {})
                    }
                    t || "function" != typeof this.video.pause || this.video.pause()
                })
            }, {
                rootMargin: "0px",
                threshold: [0, 1]
            }), this.videoPlayObserver.observe(this.video))
        }
        disconnectedCallback() {
            this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect(), this.videoId && (document.removeEventListener("click", this.powerSaverVideoPlay), document.removeEventListener("touchstart", this.powerSaverVideoPlay))
        }
    }
    e6("featured-video", [tl]), customElements.get("video-background") || customElements.define("video-background", sS), customElements.get("video-popup") || customElements.define("video-popup", sv), e6("slideshow", [tm, tl]);
    let sw = {
        imagesContainer: "[data-images-container]",
        imageHolder: "[data-image-holder]",
        imageElement: "[data-image-element]",
        rangeButton: "[data-range-button]",
        rangeInput: "[data-range-input]"
    };
    class sL extends HTMLElement {
        constructor() {
            super(), this.imageHolder = this.querySelector(sw.imageHolder), this.imageElement = this.querySelector(sw.imageElement), this.rangeButton = this.querySelector(sw.rangeButton), this.rangeInput = this.querySelector(sw.rangeInput), this.setOverlapImageSize = this.setOverlapImageSize.bind(this)
        }
        connectedCallback() {
            this.setOverlapImageSize(), this.setImagePosition(), this.rangeInput.addEventListener("input", () => this.setImagePosition()), document.addEventListener("theme:resize", this.setOverlapImageSize)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.setOverlapImageSize)
        }
        setImagePosition() {
            let e = this.rangeInput.value,
                t = this.imageElement.offsetWidth,
                i = this.rangeButton.offsetWidth;
            this.rangeButton.style.left = `${e}%`, this.imageHolder.style.width = `${(t-i)*(100-e)/100+i/2}px`
        }
        setOverlapImageSize() {
            let e = this.offsetWidth;
            this.imageElement.style.width = `${e}px`, this.setImagePosition()
        }
    }
    e6("custom-content", [tm, tl, tw]), customElements.get("video-background") || customElements.define("video-background", sS), customElements.get("video-popup") || customElements.define("video-popup", sv), customElements.get("compare-images") || customElements.define("compare-images", sL);
    var sE = {};

    function sk(e) {
        return sE[e]
    }
    sE.basic = [], sE.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }, ], sE.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }, ], sE.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }, ], window.theme.allMaps = window.theme.allMaps || {};
    let sA = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    class s$ {
        constructor(e) {
            this.container = e.container, this.mapContainer = this.container.querySelector("[data-map-container]"), this.key = this.container.getAttribute("data-api-key"), this.styleString = this.container.getAttribute("data-style") || "", this.zoomString = this.container.getAttribute("data-zoom") || 14, this.address = this.container.getAttribute("data-address"), this.enableCorrection = this.container.getAttribute("data-latlong-correction"), this.lat = this.container.getAttribute("data-lat"), this.long = this.container.getAttribute("data-long"), this.key && this.initMaps()
        }
        initMaps() {
            let e = function e(t) {
                if (null === window.theme.mapAPI) {
                    let i = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                    window.theme.mapAPI = sd({
                        url: i
                    })
                }
                return window.theme.mapAPI
            }(this.key);
            e.then(() => {
                var e;
                return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat, this.long) : (e = this.address, new Promise((t, i) => {
                    new google.maps.Geocoder().geocode({
                        address: e
                    }, function(e, s) {
                        "OK" == s ? t({
                            lat: e[0].geometry.location.lat(),
                            lng: e[0].geometry.location.lng()
                        }) : i(s)
                    })
                }))
            }).then(e => {
                var t, i, s, r, o;
                let a = parseInt(this.zoomString, 10),
                    n = sE[t = this.styleString],
                    l = (i = this.mapContainer, s = {
                        zoom: a,
                        styles: n,
                        center: e,
                        draggable: !0,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        zoomControl: !1,
                        disableDefaultUI: !0
                    }, r = new google.maps.Map(i, s), o = r.getCenter(), new google.maps.Marker({
                        map: r,
                        position: o
                    }), google.maps.event.addDomListener(window, "resize", function() {
                        google.maps.event.trigger(r, "resize"), r.setCenter(o)
                    }), r);
                return l
            }).then(e => {
                this.map = e, sA[this.id] = e
            }).catch(e => {
                console.log("Failed to load Google Map"), console.log(e)
            })
        }
        unload() {
            void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
        }
    }
    e6("map", {
        onLoad() {
            sA[this.id] = new s$(this)
        },
        onUnload() {
            "function" == typeof sA[this.id].unload && sA[this.id].unload()
        }
    });
    let sC = {
            largePromo: "[data-large-promo]",
            largePromoInner: "[data-large-promo-inner]",
            trackingInner: "[data-tracking-consent-inner]",
            tracking: "[data-tracking-consent]",
            trackingAccept: "[data-confirm-cookies]",
            cartBar: "cart-bar",
            newsletterPopup: "[data-newsletter]",
            newsletterPopupHolder: "[data-newsletter-holder]",
            newsletterHeading: "[data-newsletter-heading]",
            newsletterField: "[data-newsletter-field]",
            promoPopup: "[data-promo-text]",
            newsletterForm: "[data-newsletter-form]",
            delayAttribite: "data-popup-delay",
            cookieNameAttribute: "data-cookie-name",
            dataTargetReferrer: "data-target-referrer"
        },
        sT = {
            hidden: "hidden",
            hasValue: "has-value",
            cartBarVisible: "cart-bar-visible",
            isVisible: "is-visible",
            success: "has-success",
            selected: "selected",
            hasBlockSelected: "has-block-selected",
            mobile: "mobile",
            desktop: "desktop",
            bottom: "bottom"
        },
        sq = {};
    class sP {
        constructor(e, t, i) {
            if (this.element = t, this.delay = e.getAttribute(sC.delayAttribite), this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.popupActions = i, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                let s = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                this.delayed(s)
            }
            "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
        }
        always() {
            this.popupActions.popupOpen()
        }
        delayed(e = 10) {
            setTimeout(() => {
                this.popupActions.popupOpen()
            }, 1e3 * e)
        }
        idle() {
            let e = 0,
                t = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                i = ["load", "resize", "scroll"],
                s = () => {
                    e = setTimeout(() => {
                        e = 0, this.popupActions.popupOpen()
                    }, 6e4), t.forEach(e => {
                        document.addEventListener(e, r)
                    }), i.forEach(e => {
                        window.addEventListener(e, r)
                    })
                },
                r = () => {
                    e && clearTimeout(e), t.forEach(e => {
                        document.removeEventListener(e, r)
                    }), i.forEach(e => {
                        window.removeEventListener(e, r)
                    }), s()
                };
            s()
        }
        bottom() {
            document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
        }
        showPopupOnScroll() {
            window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
        }
        onUnload() {
            document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
        }
    }
    class sx {
        constructor(e) {
            if (this.el = e, this.locationPath = location.href, !this.el.hasAttribute(sC.dataTargetReferrer)) return !1;
            this.init()
        }
        init() {
            -1 !== this.locationPath.indexOf(this.el.getAttribute(sC.dataTargetReferrer)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
        }
    }
    class sI {
        constructor(e) {
            this.popup = e, this.modal = this.popup.querySelector(sC.largePromoInner), this.form = this.popup.querySelector(sC.newsletterForm), this.cookie = new tv(this.popup.getAttribute(sC.cookieNameAttribute), "user_has_closed"), this.isTargeted = new sx(this.popup), this.popupActions = new iG(this.modal, this.modal, !0, !0), this.a11y = F, this.init()
        }
        init() {
            let e = !1 !== this.cookie.read(),
                t = this.popup.classList.contains(sT.mobile),
                i = this.popup.classList.contains(sT.desktop),
                s = !b(),
                r = !0;
            if ((t && !s || i && s) && (r = !1), !r) {
                this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                }));
                return
            }(!e || window.Shopify.designMode) && (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new sP(this.popup, this.modal, this.popupActions), this.form && this.form.classList.contains(sT.success) && this.checkForSuccess(), this.modal.addEventListener("theme:popup:onclose", () => this.cookie.write()))
        }
        checkForSuccess() {
            this.popupActions.popupOpen(), this.cookie.write()
        }
        onBlockSelect(e) {
            this.popup.contains(e.target) && (this.popupActions.popupOpen(), this.popup.classList.add(sT.selected), this.popup.parentNode.classList.add(sT.hasBlockSelected))
        }
        onBlockDeselect(e) {
            this.popup.contains(e.target) && (this.popupActions.popupClose(), this.popup.classList.remove(sT.selected), this.popup.parentNode.classList.remove(sT.hasBlockSelected))
        }
    }
    class s_ {
        constructor(e) {
            this.popup = e, this.modal = document.querySelector(sC.tracking), this.acceptButton = this.modal.querySelector(sC.trackingAccept), this.enable = "true" === this.modal.getAttribute("data-enable"), this.showPopup = !1, this.popupActions = new iG(this.popup, this.popup, !1, !1), window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
            }, ], e => {
                if (e) throw e;
                let t = window.Shopify.customerPrivacy.userCanBeTracked(),
                    i = window.Shopify.customerPrivacy.getTrackingConsent();
                this.showPopup = !t && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
            })
        }
        init() {
            this.showPopup && this.popupActions.popupOpen(), this.clickEvents()
        }
        clickEvents() {
            this.acceptButton.addEventListener("click", e => {
                e.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.popupActions.popupClose()), document.documentElement.style.setProperty("--cookie-bar-height", "0px")
            }), document.addEventListener("trackingConsentAccepted", () => {})
        }
        onSelect() {
            this.showPopup && (this.popupActions.popupOpen(), this.popup.classList.add(sT.selected), this.popup.parentNode.classList.add(sT.hasBlockSelected))
        }
        onDeselect() {
            this.showPopup && (this.popupActions.popupClose(), this.popup.classList.remove(sT.selected), this.popup.parentNode.classList.remove(sT.hasBlockSelected))
        }
    }
    class sM {
        constructor(e) {
            this.popup = e, this.cookie = new tv(this.popup.getAttribute(sC.cookieNameAttribute), "user_has_closed"), this.isTargeted = new sx(this.popup), this.popupActions = new iG(this.popup, this.popup, !1, !1), this.init()
        }
        init() {
            let e = !1 !== this.cookie.read();
            (!e || window.Shopify.designMode) && (window.Shopify.designMode ? this.popupActions.popupOpen() : new sP(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write()))
        }
        onSelect() {
            this.popupActions.popupOpen(), this.popup.classList.add(sT.selected), this.popup.parentNode.classList.add(sT.hasBlockSelected)
        }
        onDeselect() {
            this.popupActions.popupClose(), this.popup.classList.remove(sT.selected), this.popup.parentNode.classList.remove(sT.hasBlockSelected)
        }
    }
    class sH {
        constructor(e) {
            this.popup = e, this.holder = this.popup.querySelector(sC.newsletterPopupHolder), this.heading = this.popup.querySelector(sC.newsletterHeading), this.newsletterField = this.popup.querySelector(sC.newsletterField), this.cookie = new tv(this.popup.getAttribute(sC.cookieNameAttribute), "newsletter_is_closed"), this.form = this.popup.querySelector(sC.newsletterForm), this.isTargeted = new sx(this.popup), this.popupActions = new iG(this.holder, this.holder, !1, !1), this.resetClassTimer = 0, this.init()
        }
        init() {
            let e = !1 !== this.cookie.read(),
                t = -1 !== window.location.search.indexOf("?customer_posted=true"),
                i = [...this.holder.classList].toString(),
                s = i.includes(sT.bottom);
            t && (this.delay = 0), (!e || window.Shopify.designMode) && (this.show(), this.form.classList.contains(sT.success) && this.checkForSuccess()), s && this.observeCartBar()
        }
        show() {
            window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new sP(this.popup, this.holder, this.popupActions)), this.showForm(), this.inputField(), this.holder.addEventListener("theme:popup:onclose", () => this.cookie.write())
        }
        checkForSuccess() {
            this.popupActions.popupOpen(), this.cookie.write()
        }
        observeCartBar() {
            if (this.cartBar = document.getElementById(sC.cartBar), !this.cartBar) return;
            let e = this.cartBar.classList.contains(sT.isVisible);
            document.body.classList.toggle(sT.cartBarVisible, e);
            let t = t => {
                for (let i of t) "attributes" === i.type && (e = i.target.classList.contains(sT.isVisible), document.body.classList.toggle(sT.cartBarVisible, e))
            };
            this.observer = new MutationObserver(t), this.observer.observe(this.cartBar, {
                attributes: !0,
                childList: !1,
                subtree: !1
            })
        }
        showForm() {
            this.heading.addEventListener("click", e => {
                e.preventDefault(), this.heading.classList.add(sT.hidden), this.form.classList.remove(sT.hidden), this.newsletterField.focus()
            }), this.heading.addEventListener("keyup", e => {
                "Enter" === e.code && this.heading.dispatchEvent(new Event("click"))
            })
        }
        inputField() {
            let e = () => {
                    this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(sT.hasValue)
                },
                t = () => {
                    this.resetClassTimer && clearTimeout(this.resetClassTimer), this.resetClassTimer = setTimeout(() => {
                        this.holder.classList.remove(sT.hasValue)
                    }, 2e3)
                };
            this.newsletterField.addEventListener("input", e), this.newsletterField.addEventListener("focus", e), this.newsletterField.addEventListener("focusout", t)
        }
        onBlockSelect(e) {
            this.popup.contains(e.target) && (this.popupActions.popupOpen(), this.popup.classList.add(sT.selected), this.popup.parentNode.classList.add(sT.hasBlockSelected))
        }
        onBlockDeselect(e) {
            this.popup.contains(e.target) && (this.popupActions.popupClose(), this.popup.classList.remove(sT.selected), this.popup.parentNode.classList.remove(sT.hasBlockSelected))
        }
        onUnload() {
            this.observer && this.observer.disconnect()
        }
    }
    e6("popups", [{
        onLoad() {
            sq[this.id] = [];
            let e = this.container.querySelectorAll(sC.largePromo);
            e.forEach(e => {
                sq[this.id].push(new sI(e))
            });
            let t = this.container.querySelectorAll(sC.tracking);
            t.forEach(e => {
                sq[this.id].push(new s_(e))
            });
            let i = this.container.querySelectorAll(sC.newsletterPopup);
            i.forEach(e => {
                sq[this.id].push(new sH(e))
            });
            let s = this.container.querySelectorAll(sC.promoPopup);
            s.forEach(e => {
                sq[this.id].push(new sM(e))
            })
        },
        onBlockSelect(e) {
            sq[this.id].forEach(t => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            })
        },
        onBlockDeselect(e) {
            sq[this.id].forEach(t => {
                "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            })
        },
        onSelect() {
            sq[this.id].forEach(e => {
                "function" == typeof e.onSelect && e.onSelect()
            })
        },
        onDeselect() {
            sq[this.id].forEach(e => {
                "function" == typeof e.onDeselect && e.onDeselect()
            })
        },
        onUnload() {
            sq[this.id].forEach(e => {
                "function" == typeof e.onUnload && e.onUnload()
            })
        }
    }, tw]);
    let sB = {
        modal: "[data-password-modal]",
        loginErrors: "#login_form .errors"
    };
    class sO {
        constructor(e) {
            this.container = e.container, this.popupActions = new iG(this.container.querySelector(sB.modal), this.container, !0, !0), this.container.querySelector(sB.loginErrors) && this.popupActions.popupOpen()
        }
    }
    e6("password-template", {
        onLoad() {
            new sO(this)
        }
    }), e6("list-collections", [tm, t5]), e6("columns", [t5, tm]), e6("newsletter", tw), customElements.get("compare-images") || customElements.define("compare-images", sL);
    let sD = {
            scrollToElement: "[data-scroll-to]",
            tooltip: "[data-tooltip]",
            collapsibleTrigger: "[data-collapsible-trigger]"
        },
        s8 = {
            open: "open",
            dataScrollTo: "data-scroll-to",
            tooltipStopMousenterValue: "data-tooltip-stop-mouseenter"
        },
        s9 = {};
    class sF {
        constructor(e) {
            this.section = e, this.container = e.container, this.scrollToButtons = this.container.querySelectorAll(sD.scrollToElement), this.scrollToButtons.length && this.init()
        }
        init() {
            this.scrollToButtons.forEach(e => {
                e.addEventListener("click", () => {
                    let t = this.container.querySelector(e.getAttribute(s8.dataScrollTo));
                    t && "A" !== e.tagName && this.scrollToElement(t)
                })
            })
        }
        scrollToElement(e) {
            tg(e.getBoundingClientRect().top + 1);
            let t = e.nextElementSibling.matches("details") ? e.nextElementSibling : null;
            if (t) {
                let i = t?.querySelector(sD.collapsibleTrigger),
                    s = t.hasAttribute(s8.open);
                s || i?.dispatchEvent(new Event("click"))
            }
            let r = document.querySelectorAll(`${sD.tooltip}:not([${s8.tooltipStopMousenterValue}])`);
            r.length && r.forEach(e => {
                e.setAttribute(s8.tooltipStopMousenterValue, ""), setTimeout(() => {
                    e.removeAttribute(s8.tooltipStopMousenterValue)
                }, 1e3)
            })
        }
    }
    let sN = {
            scrollSpy: "[data-scroll-spy]"
        },
        sW = {
            selected: "is-selected"
        },
        sR = {
            scrollSpy: "data-scroll-spy",
            mobile: "data-scroll-spy-mobile",
            desktop: "data-scroll-spy-desktop",
            triggerPoint: "data-scroll-trigger-point"
        },
        sV = {};
    class sU {
        constructor(e, t) {
            if (this.container = e, this.elementToSpy = t, this.anchorSelector = `[${sR.scrollSpy}="#${this.elementToSpy.id}"]`, this.anchor = this.container.querySelector(this.anchorSelector), this.anchorSiblings = this.container.querySelectorAll(`[${sR.scrollSpy}]`), this.initialized = !1, !this.anchor) return;
            this.triggerPoint = this.anchor.getAttribute(sR.triggerPoint), this.scrollCallback = () => this.onScroll(), this.toggleScrollObserver = this.toggleScrollObserver.bind(this), this.init()
        }
        init() {
            this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver)
        }
        toggleScrollObserver() {
            this.isEligible() ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), this.initialized = !0) : (document.removeEventListener("theme:scroll", this.scrollCallback), this.initialized = !1)
        }
        isEligible() {
            let e = b();
            return !e && this.anchor.hasAttribute(sR.mobile) || e && this.anchor.hasAttribute(sR.desktop) || !this.anchor.hasAttribute(sR.desktop) && !this.anchor.hasAttribute(sR.mobile)
        }
        onScroll() {
            this.top = this.elementToSpy.getBoundingClientRect().top;
            let e = Math.round(window.innerHeight),
                t = Math.round(window.scrollY),
                i = Math.round(this.top + t),
                s = this.elementToSpy.offsetHeight;
            i < t + e && !(i + s < t) && this.triggerPointReached() && (this.anchorSiblings.forEach(e => {
                e.matches(this.anchorSelector) || e.classList.remove(sW.selected)
            }), this.anchor.classList.add(sW.selected))
        }
        triggerPointReached() {
            let e = !1;
            switch (this.triggerPoint) {
                case "top":
                default:
                    e = this.top <= 0;
                    break;
                case "middle":
                    e = this.top <= window.innerHeight / 2;
                    break;
                case "bottom":
                    e = this.top <= window.innerHeight
            }
            return e
        }
        onUnload() {
            document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback)
        }
    }
    let sz = {
        onLoad() {
            sV[this.id] = [], this.container.querySelectorAll(sN.scrollSpy)?.forEach(e => {
                let t = this.container.querySelector(e.getAttribute(sR.scrollSpy));
                sV[this.id].push(new sU(this.container, t))
            })
        },
        onUnload() {
            sV[this.id].forEach(e => {
                "function" == typeof e.onUnload && e.onUnload()
            })
        }
    };
    e6("sidebar", [{
        onLoad() {
            s9[this.id] = new sF(this)
        }
    }, sz]);
    let s0 = {
            button: "[data-hover-target]",
            image: "[data-collection-image]"
        },
        sj = {
            target: "data-hover-target"
        },
        s3 = {
            visible: "is-visible",
            selected: "is-selected"
        },
        s2 = {};
    class sX {
        constructor(e) {
            this.container = e.container, this.buttons = this.container.querySelectorAll(s0.button), this.init()
        }
        init() {
            this.buttons.length && this.buttons.forEach(e => {
                e.addEventListener("mouseenter", e => {
                    let t = e.currentTarget.getAttribute(sj.target);
                    this.updateState(t)
                })
            })
        }
        updateState(e) {
            let t = this.container.querySelector(`[${sj.target}="${e}"]`),
                i = this.container.querySelector(`#${e}:not(.${s3.visible})`),
                s = this.container.querySelector(`${s0.button}.${s3.selected}`),
                r = this.container.querySelector(`${s0.image}.${s3.visible}`);
            i && b() && (r?.classList.remove(s3.visible), s?.classList.remove(s3.selected), i.classList.add(s3.visible), t.classList.add(s3.selected))
        }
        onBlockSelect(e) {
            this.updateState(e.target.id)
        }
    }
    e6("collections-hover", [{
        onLoad() {
            s2[this.id] = new sX(this)
        },
        onBlockSelect(e) {
            s2[this.id].onBlockSelect(e)
        }
    }, sz]);
    let s1 = {
            image: "[data-featured-image]",
            imagesHolder: "[data-featured-aside]",
            contentHolder: "[data-featured-content]",
            wrapper: "[data-featured-wrapper]"
        },
        sG = {
            horizontalScroll: "data-horizontal-scroll",
            horizontalScrollReversed: "data-horizontal-scroll-reversed"
        },
        s4 = {};
    class sJ {
        constructor(e) {
            this.container = e.container, this.horizontalScroll = this.container.hasAttribute(sG.horizontalScroll), this.horizontalScrollReversed = this.container.hasAttribute(sG.horizontalScrollReversed), this.images = this.container.querySelectorAll(s1.image), this.imagesHolder = this.container.querySelector(s1.imagesHolder), this.contentHolder = this.container.querySelector(s1.contentHolder), this.wrapper = this.container.querySelector(s1.wrapper), this.requestAnimationSticky = null, this.lastPercent = 0, this.scrollEvent = () => this.scrollEvents(), this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition(), this.calculateHeightEvent = () => this.calculateHeight(), this.init()
        }
        init() {
            this.horizontalScroll && this.imagesHolder && (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent), document.addEventListener("theme:scroll", this.scrollEvent)), this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent))
        }
        scrollEvents() {
            this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent))
        }
        removeAnimationFrame() {
            this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null)
        }
        calculateHorizontalPosition() {
            let e = window.scrollY + this.headerHeight,
                t = e + window.innerHeight,
                i = this.imagesHolder.offsetTop,
                s = this.imagesHolder.offsetHeight,
                r = i + s + this.headerHeight,
                o = s - (window.innerHeight - this.headerHeight),
                a = this.horizontalScrollReversed ? 1 : -1,
                n = 0;
            n = e >= i && t <= r ? (e - i) / o * 100 : e < i ? 0 : 100, n *= this.images.length - 1, this.container.style.setProperty("--translateX", `${n*a}%`), this.lastPercent !== n ? this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent) : this.requestAnimationSticky && this.removeAnimationFrame(), this.lastPercent = n
        }
        calculateHeight() {
            let {
                stickyHeaderHeight: e
            } = l();
            this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`), this.headerHeight = e
        }
        onUnload() {
            this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent), this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent)
        }
    }
    e6("featured-product", [{
        onLoad() {
            s4[this.id] = new sJ(this)
        },
        onUnload(e) {
            s4[this.id].onUnload(e)
        }
    }]);
    let sY = {
            holder: "[data-timeline-holder]",
            rows: "[data-timeline-rows]",
            row: "[data-timeline-row]",
            rowEditor: "[data-timeline-row-editor]",
            button: "[data-timeline-button]",
            scrollElement: "[data-block-scroll]",
            headerSticky: "[data-header-sticky]",
            headerHeight: "[data-header-height]"
        },
        sQ = {
            selected: "is-selected"
        },
        s5 = {};
    class s6 {
        constructor(e) {
            if (this.container = e.container, this.rows = this.container.querySelectorAll(sY.row), this.holder = this.container.querySelector(sY.holder), this.rows.length < 2 || !this.holder) return;
            this.rowsWidth = 0, this.rowsHeight = [], this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.buttons = this.container.querySelectorAll(sY.button), this.rowsHolder = this.container.querySelector(sY.rows), this.requestAnimation = null, this.isDesktopView = b(), this.isScrollEnabled = !1, this.scrollEvent = e => this.scrollEvents(e), this.resizeEvent = () => this.resizeEvents(), this.init()
        }
        init() {
            this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame(() => this.calculatePosition()), this.isDesktopView && !this.isScrollEnabled && (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.addEventListener("scroll", this.scrollEvent), document.addEventListener("theme:resize:width", this.resizeEvent), this.buttons.length && this.buttons.forEach((e, t) => {
                e.addEventListener("click", e => {
                    e.preventDefault();
                    let i = e.currentTarget.closest(sY.row);
                    if (i) {
                        if (b()) {
                            let s = Math.max(...this.rowsHeight),
                                r = this.holderHeight / this.rows.length,
                                o = this.holder.getBoundingClientRect().top;
                            tg((t > 0 && s < r ? r * t + o : o) + 1)
                        } else {
                            let a = i.offsetLeft - 16;
                            this.rowsHolder.scrollTo({
                                left: a,
                                behavior: "smooth"
                            })
                        }
                    }
                })
            })
        }
        resizeEvents() {
            this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame(() => this.calculatePosition());
            let e = b();
            e && !this.isScrollEnabled ? (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)) : !e && this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent))
        }
        scrollEvents(e) {
            if (!this.requestAnimation) {
                let t = e.currentTarget;
                this.requestAnimation = requestAnimationFrame(() => this.calculatePosition(t))
            }
        }
        removeAnimationFrame() {
            this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), this.requestAnimation = null)
        }
        calculateRowsDimensions() {
            if (this.rows.length) {
                this.rowsHeight = [], this.rowsWidth = 0;
                let e = 0;
                this.rows.forEach((t, i) => {
                    if (this.rowsHeight.push(t.offsetHeight), this.rowsWidth += t.offsetWidth + parseInt(getComputedStyle(t).marginRight), window.Shopify.designMode) {
                        let s = this.container.querySelectorAll(sY.rowEditor);
                        s.length && (e += t.offsetHeight, s[i]?.style.setProperty("--row-height-min", `${t.offsetHeight}px`), s[i + 1]?.style.setProperty("--row-top-mobile", `${e}px`))
                    }
                })
            }
        }
        calculatePosition(e = null) {
            this.removeAnimationFrame();
            let t = b(),
                i = this.holderHeight / this.rows.length,
                s = this.holderTop,
                r = window.innerHeight,
                o = window.scrollY + 1.5 * r,
                a = 0;
            if (!t && e) {
                let n = e.scrollLeft - 16,
                    l = e.offsetWidth;
                a = n / (this.rowsWidth - l) * 100, this.holder.style.setProperty("--percent-mobile", `${a}%`)
            }
            t && (o < this.holderTop || o > this.holderTop + this.holderHeight + r) || this.rows.forEach((e, r) => {
                if (r > 0) {
                    let n = e.offsetLeft / this.rowsWidth * 100,
                        l = a > n;
                    t && (l = s + i < o, s - i < o && e.previousElementSibling?.style.setProperty("--percent-desktop", `${(o-s)/i*100}%`)), e.classList.toggle(sQ.selected, l)
                }
                s += i
            })
        }
        onUnload() {
            this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.removeEventListener("scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent)
        }
        onBlockSelect(e) {
            let t = this.container.querySelector(sY.scrollElement);
            if (t) {
                let i = e.srcElement,
                    s = [...i.parentElement.children].indexOf(i),
                    r = this.rows[s];
                r && t.scrollTo({
                    top: 0,
                    left: r.offsetLeft,
                    behavior: "smooth"
                })
            }
        }
    }
    e6("timeline", [{
        onLoad() {
            s5[this.id] = new s6(this)
        },
        onUnload(e) {
            s5[this.id].onUnload(e)
        },
        onBlockSelect(e) {
            s5[this.id].onBlockSelect(e)
        }
    }]), document.addEventListener("DOMContentLoaded", function() {
        e7("*");
        let e = document.querySelector("[data-scroll-top-button]");
        e && (e.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        }), document.addEventListener("theme:scroll", () => {
            e.classList.toggle("is-visible", window.scrollY > window.innerHeight)
        })), window.self !== window.top && document.querySelector("html").classList.add("iframe");
        "scrollBehavior" in document.documentElement.style || sd({
            url: window.theme.assets.smoothscroll
        })
    }), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}(themeVendor.ScrollLock, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);